import { Injectable, ɵɵdefineInjectable, ɵɵinject, NgModule } from '@angular/core';
import { HttpParams, HttpHeaders, HttpRequest, HttpResponse, HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { filter, map, tap } from 'rxjs/operators';

/**
 * @fileoverview added by tsickle
 * Generated from: api/models.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: api/base-service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Custom parameter codec to correctly handle the plus sign in parameter
 * values. See https://github.com/angular/angular/issues/18261
 */
import * as ɵngcc0 from '@angular/core';
class ParameterCodec {
    /**
     * @param {?} key
     * @return {?}
     */
    encodeKey(key) {
        return encodeURIComponent(key);
    }
    /**
     * @param {?} value
     * @return {?}
     */
    encodeValue(value) {
        return encodeURIComponent(value);
    }
    /**
     * @param {?} key
     * @return {?}
     */
    decodeKey(key) {
        return decodeURIComponent(key);
    }
    /**
     * @param {?} value
     * @return {?}
     */
    decodeValue(value) {
        return decodeURIComponent(value);
    }
}
/** @type {?} */
const PARAMETER_CODEC = new ParameterCodec();
/**
 * Base class for API services
 */
class BaseService {
    /**
     * @param {?} config
     * @param {?} http
     */
    constructor(config, http) {
        this.config = config;
        this.http = http;
        this._rootUrl = '';
    }
    /**
     * Returns the root url for API operations. If not set directly in this
     * service, will fallback to ApiConfiguration.rootUrl.
     * @return {?}
     */
    get rootUrl() {
        return this._rootUrl || this.config.rootUrl;
    }
    /**
     * Sets the root URL for API operations in this service.
     * @param {?} rootUrl
     * @return {?}
     */
    set rootUrl(rootUrl) {
        this._rootUrl = rootUrl;
    }
    /**
     * Creates a new `HttpParams` with the correct codec
     * @protected
     * @return {?}
     */
    newParams() {
        return new HttpParams({
            encoder: PARAMETER_CODEC
        });
    }
}
if (false) {
    /**
     * @type {?}
     * @private
     */
    BaseService.prototype._rootUrl;
    /**
     * @type {?}
     * @protected
     */
    BaseService.prototype.config;
    /**
     * @type {?}
     * @protected
     */
    BaseService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: api/api-configuration.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Global configuration for Api services
 */
class ApiConfiguration {
    constructor() {
        this.rootUrl = 'https://api.basespace.illumina.com/v2';
    }
}
ApiConfiguration.ngInjectableDef = ɵngcc0.ɵɵdefineInjectable({ token: ApiConfiguration, factory: function ApiConfiguration_Factory(t) { return new (t || ApiConfiguration)(); }, providedIn: 'root' });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(ApiConfiguration, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, { constructor: [], rootUrl: [] });
/** @nocollapse */ ApiConfiguration.ngInjectableDef = ɵɵdefineInjectable({ factory: function ApiConfiguration_Factory() { return new ApiConfiguration(); }, token: ApiConfiguration, providedIn: "root" });
if (false) {
    /** @type {?} */
    ApiConfiguration.prototype.rootUrl;
}
/**
 * @record
 */
function ApiConfigurationInterface() { }
if (false) {
    /** @type {?|undefined} */
    ApiConfigurationInterface.prototype.rootUrl;
}

/**
 * @fileoverview added by tsickle
 * Generated from: api/services/basespace.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class BasespaceService extends BaseService {
    /**
     * @param {?} config
     * @param {?} http
     */
    constructor(config, http) {
        super(config, http);
    }
    /**
     * @param {?} params The `BasespaceService.GetV2AgreementsParams` containing the following parameters:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `id`: The Id of the resource
     *
     * - `category`: Required, only agreements with category exactly matching the specified value will be returned.
     *
     * @return {?} OK
     */
    GetV2AgreementsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        if (params.id != null)
            __params = __params.set('id', params.id.toString());
        if (params.category != null)
            __params = __params.set('category', params.category.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/agreements/`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2AgreementsParams` containing the following parameters:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `id`: The Id of the resource
     *
     * - `category`: Required, only agreements with category exactly matching the specified value will be returned.
     *
     * @return {?} OK
     */
    GetV2Agreements(params) {
        return this.GetV2AgreementsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} id Agreement ID
     * @return {?} OK
     */
    GetV2AgreementsIdResponse(id) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/agreements/${id}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} id Agreement ID
     * @return {?} OK
     */
    GetV2AgreementsId(id) {
        return this.GetV2AgreementsIdResponse(id).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Request metadata about applications
     * @param {?=} id The Id of the resource
     * @return {?} OK
     */
    GetV2ApplicationmetadataResponse(id) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (id != null)
            __params = __params.set('id', id.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/applicationmetadata`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Request metadata about applications
     * @param {?=} id The Id of the resource
     * @return {?} OK
     */
    GetV2Applicationmetadata(id) {
        return this.GetV2ApplicationmetadataResponse(id).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2ApplicationsParams` containing the following parameters:
     *
     * - `cwlactive`: Returns only applications where there is a CWL form enabled.
     *
     * - `autolaunchableonruncompleteappsonly`: Returns only applications that can be auto-launched after a run completes
     *
     * - `allversions`: Return all the applications versions
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `references`: Returns all analysis workflows that a user has access to that were created from a particular app, denoted by its unique slug ID
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `id`: The Id of the resource
     *
     * - `category`: Return all apps that belong to a specific category that a user has access to (examples include: Native, Workflow, Other). Only a single category can be specified in a given call
     *
     * @return {?} OK
     */
    GetV2ApplicationsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.cwlactive != null)
            __params = __params.set('cwlactive', params.cwlactive.toString());
        if (params.autolaunchableonruncompleteappsonly != null)
            __params = __params.set('autolaunchableonruncompleteappsonly', params.autolaunchableonruncompleteappsonly.toString());
        if (params.allversions != null)
            __params = __params.set('allversions', params.allversions.toString());
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.references != null)
            __params = __params.set('references', params.references.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        if (params.id != null)
            __params = __params.set('id', params.id.toString());
        if (params.category != null)
            __params = __params.set('category', params.category.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/applications`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2ApplicationsParams` containing the following parameters:
     *
     * - `cwlactive`: Returns only applications where there is a CWL form enabled.
     *
     * - `autolaunchableonruncompleteappsonly`: Returns only applications that can be auto-launched after a run completes
     *
     * - `allversions`: Return all the applications versions
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `references`: Returns all analysis workflows that a user has access to that were created from a particular app, denoted by its unique slug ID
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `id`: The Id of the resource
     *
     * - `category`: Return all apps that belong to a specific category that a user has access to (examples include: Native, Workflow, Other). Only a single category can be specified in a given call
     *
     * @return {?} OK
     */
    GetV2Applications(params) {
        return this.GetV2ApplicationsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2ApplicationsIdParams` containing the following parameters:
     *
     * - `id`:
     *
     * - `propertyitemslimit`: Returns only the specified number of property items per property for the application
     *
     * - `propertieslimit`: Returns only the specified number of properties for the application.
     *
     * @return {?} OK
     */
    GetV2ApplicationsIdResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.propertyitemslimit != null)
            __params = __params.set('propertyitemslimit', params.propertyitemslimit.toString());
        if (params.propertieslimit != null)
            __params = __params.set('propertieslimit', params.propertieslimit.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/applications/${params.id}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2ApplicationsIdParams` containing the following parameters:
     *
     * - `id`:
     *
     * - `propertyitemslimit`: Returns only the specified number of property items per property for the application
     *
     * - `propertieslimit`: Returns only the specified number of properties for the application.
     *
     * @return {?} OK
     */
    GetV2ApplicationsId(params) {
        return this.GetV2ApplicationsIdResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} id The Id of the resource
     * @return {?} OK
     */
    GetV2ApplicationsIdQcthresholdsResponse(id) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/applications/${id}/qcthresholds`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} id The Id of the resource
     * @return {?} OK
     */
    GetV2ApplicationsIdQcthresholds(id) {
        return this.GetV2ApplicationsIdQcthresholdsResponse(id).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * List the QC thresholds to be updated. You must include the name of the metric to be thresholded, the type of logical operator, the dataset type unique ID to apply the threshold to, and the threshold values.
     * @param {?} params The `BasespaceService.PutV2ApplicationsIdQcthresholdsParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `qcthresholds`:
     *
     * @return {?} OK
     */
    PutV2ApplicationsIdQcthresholdsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        (params.qcthresholds || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('qcthresholds', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('PUT', this.rootUrl + `/applications/${params.id}/qcthresholds`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * List the QC thresholds to be updated. You must include the name of the metric to be thresholded, the type of logical operator, the dataset type unique ID to apply the threshold to, and the threshold values.
     * @param {?} params The `BasespaceService.PutV2ApplicationsIdQcthresholdsParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `qcthresholds`:
     *
     * @return {?} OK
     */
    PutV2ApplicationsIdQcthresholds(params) {
        return this.PutV2ApplicationsIdQcthresholdsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2ApplicationsIdScreenshotsParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2ApplicationsIdScreenshotsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/applications/${params.id}/screenshots`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2ApplicationsIdScreenshotsParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2ApplicationsIdScreenshots(params) {
        return this.GetV2ApplicationsIdScreenshotsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} id The Id of the resource
     * @return {?} OK
     */
    GetV2ApplicationsIdSettingsResponse(id) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/applications/${id}/settings`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} id The Id of the resource
     * @return {?} OK
     */
    GetV2ApplicationsIdSettings(id) {
        return this.GetV2ApplicationsIdSettingsResponse(id).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2ApplicationsIdVersionsParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2ApplicationsIdVersionsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/applications/${params.id}/versions`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2ApplicationsIdVersionsParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2ApplicationsIdVersions(params) {
        return this.GetV2ApplicationsIdVersionsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} id The Id of the resource
     * @return {?} OK
     */
    GetV2ApplicationsIdWorkflowdependenciesResponse(id) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/applications/${id}/workflowdependencies`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} id The Id of the resource
     * @return {?} OK
     */
    GetV2ApplicationsIdWorkflowdependencies(id) {
        return this.GetV2ApplicationsIdWorkflowdependenciesResponse(id).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Add the required triggers for the analysis workflow to launch. Workflows can depend on a certain amount of biosample actual yield to show up or they can depend on another app completing.
     * @param {?} params The `BasespaceService.PutV2ApplicationsIdWorkflowdependenciesParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `version`:
     *
     * - `dependencies`:
     *
     * @return {?} OK
     */
    PutV2ApplicationsIdWorkflowdependenciesResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.version != null)
            __params = __params.set('version', params.version.toString());
        (params.dependencies || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('dependencies', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('PUT', this.rootUrl + `/applications/${params.id}/workflowdependencies`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Add the required triggers for the analysis workflow to launch. Workflows can depend on a certain amount of biosample actual yield to show up or they can depend on another app completing.
     * @param {?} params The `BasespaceService.PutV2ApplicationsIdWorkflowdependenciesParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `version`:
     *
     * - `dependencies`:
     *
     * @return {?} OK
     */
    PutV2ApplicationsIdWorkflowdependencies(params) {
        return this.PutV2ApplicationsIdWorkflowdependenciesResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Create an analysis workflow using the settings, app, and version of an existing appsession.
     * @param {?} params The `BasespaceService.PostV2ApplicationsIdWorkflowsParams` containing the following parameters:
     *
     * - `id`: Applicaiton Id
     *
     * - `payload`:
     *
     * @return {?} OK
     */
    PostV2ApplicationsIdWorkflowsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/applications/${params.id}/workflows`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Create an analysis workflow using the settings, app, and version of an existing appsession.
     * @param {?} params The `BasespaceService.PostV2ApplicationsIdWorkflowsParams` containing the following parameters:
     *
     * - `id`: Applicaiton Id
     *
     * - `payload`:
     *
     * @return {?} OK
     */
    PostV2ApplicationsIdWorkflows(params) {
        return this.PostV2ApplicationsIdWorkflowsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Request direct file upload presigned url information for a new file in the specified resource (dataset or appresult)
     * @param {?} params The `BasespaceService.GetV2AppresultsIdFileUploadInfoParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `uploadpartcount`:
     *
     * - `filepath`:
     *
     * @return {?} Request direct file upload presigned url information for a new file in the specified resource
     */
    GetV2AppresultsIdFileUploadInfoResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.uploadpartcount != null)
            __params = __params.set('uploadpartcount', params.uploadpartcount.toString());
        if (params.filepath != null)
            __params = __params.set('filepath', params.filepath.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/appresults/${params.id}/file-upload-info`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Request direct file upload presigned url information for a new file in the specified resource (dataset or appresult)
     * @param {?} params The `BasespaceService.GetV2AppresultsIdFileUploadInfoParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `uploadpartcount`:
     *
     * - `filepath`:
     *
     * @return {?} Request direct file upload presigned url information for a new file in the specified resource
     */
    GetV2AppresultsIdFileUploadInfo(params) {
        return this.GetV2AppresultsIdFileUploadInfoResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Complete multipart upload and report uploaded files to a resource (dataset or appresult)
     * @param {?} params The `BasespaceService.PostV2AppresultsIdFileUploadInfoParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `payload`:
     *
     * @return {?} Complete multipart upload and report uploaded files to a resource (dataset or appresult)
     */
    PostV2AppresultsIdFileUploadInfoResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/appresults/${params.id}/file-upload-info`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Complete multipart upload and report uploaded files to a resource (dataset or appresult)
     * @param {?} params The `BasespaceService.PostV2AppresultsIdFileUploadInfoParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `payload`:
     *
     * @return {?} Complete multipart upload and report uploaded files to a resource (dataset or appresult)
     */
    PostV2AppresultsIdFileUploadInfo(params) {
        return this.PostV2AppresultsIdFileUploadInfoResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2AppsessionsParams` containing the following parameters:
     *
     * - `usercreatedby`: ID of user who created appsession
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `qcstatus`: Filter by QC status
     *
     * - `propertyfilters`: Filter by appsessions include the specified property names
     *
     * - `ownedbycurrentuser`: Only include appsessions where the project has WRITE permission by the current user
     *
     * - `output.projects`: Filter by ID of output project
     *
     * - `offset`: The starting offset to read
     *
     * - `name`:
     *
     * - `limit`: The maximum number of items to return
     *
     * - `input.runs`: Filter by ID of run input
     *
     * - `input.biosamples`: Filter by ID of biosample input
     *
     * - `include`: Additional resources to include
     *
     * - `executionstatus`: Filter by execution status
     *
     * - `deliverystatus`: Filter by delivery status
     *
     * - `datemodified`:
     *
     * - `applicationfamilyslugs`: Filter by application family
     *
     * - `appid`: Filter by ID of application used
     *
     * @return {?} OK
     */
    GetV2AppsessionsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.usercreatedby != null)
            __params = __params.set('usercreatedby', params.usercreatedby.toString());
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.qcstatus != null)
            __params = __params.set('qcstatus', params.qcstatus.toString());
        (params.propertyfilters || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('propertyfilters', val.toString()); }));
        if (params.ownedbycurrentuser != null)
            __params = __params.set('ownedbycurrentuser', params.ownedbycurrentuser.toString());
        (params.outputProjects || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('output.projects', val.toString()); }));
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.name != null)
            __params = __params.set('name', params.name.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        (params.inputRuns || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('input.runs', val.toString()); }));
        (params.inputBiosamples || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('input.biosamples', val.toString()); }));
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        if (params.executionstatus != null)
            __params = __params.set('executionstatus', params.executionstatus.toString());
        if (params.deliverystatus != null)
            __params = __params.set('deliverystatus', params.deliverystatus.toString());
        if (params.datemodified != null)
            __params = __params.set('datemodified', params.datemodified.toString());
        (params.applicationfamilyslugs || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('applicationfamilyslugs', val.toString()); }));
        if (params.appid != null)
            __params = __params.set('appid', params.appid.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/appsessions`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2AppsessionsParams` containing the following parameters:
     *
     * - `usercreatedby`: ID of user who created appsession
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `qcstatus`: Filter by QC status
     *
     * - `propertyfilters`: Filter by appsessions include the specified property names
     *
     * - `ownedbycurrentuser`: Only include appsessions where the project has WRITE permission by the current user
     *
     * - `output.projects`: Filter by ID of output project
     *
     * - `offset`: The starting offset to read
     *
     * - `name`:
     *
     * - `limit`: The maximum number of items to return
     *
     * - `input.runs`: Filter by ID of run input
     *
     * - `input.biosamples`: Filter by ID of biosample input
     *
     * - `include`: Additional resources to include
     *
     * - `executionstatus`: Filter by execution status
     *
     * - `deliverystatus`: Filter by delivery status
     *
     * - `datemodified`:
     *
     * - `applicationfamilyslugs`: Filter by application family
     *
     * - `appid`: Filter by ID of application used
     *
     * @return {?} OK
     */
    GetV2Appsessions(params) {
        return this.GetV2AppsessionsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?=} payload undefined
     * @return {?} OK
     */
    PostV2AppsessionsResponse(payload) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/appsessions`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?=} payload undefined
     * @return {?} OK
     */
    PostV2Appsessions(payload) {
        return this.PostV2AppsessionsResponse(payload).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.DeleteV2AppsessionsIdParams` containing the following parameters:
     *
     * - `id`: Appsession ID
     *
     * - `preserve`: Preserve "Metadata", to keep records, but not files, of an appsession
     *
     * - `bypasstrash`: Select true to go straight to deletion
     *
     * @return {?} OK
     */
    DeleteV2AppsessionsIdResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.preserve != null)
            __params = __params.set('preserve', params.preserve.toString());
        if (params.bypasstrash != null)
            __params = __params.set('bypasstrash', params.bypasstrash.toString());
        /** @type {?} */
        let req = new HttpRequest('DELETE', this.rootUrl + `/appsessions/${params.id}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.DeleteV2AppsessionsIdParams` containing the following parameters:
     *
     * - `id`: Appsession ID
     *
     * - `preserve`: Preserve "Metadata", to keep records, but not files, of an appsession
     *
     * - `bypasstrash`: Select true to go straight to deletion
     *
     * @return {?} OK
     */
    DeleteV2AppsessionsId(params) {
        return this.DeleteV2AppsessionsIdResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2AppsessionsIdParams` containing the following parameters:
     *
     * - `id`: Appsession ID
     *
     * - `showhiddenitems`: ShowHiddenItems
     *
     * - `include`: Additional resources to include
     *
     * @return {?} OK
     */
    GetV2AppsessionsIdResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.showhiddenitems != null)
            __params = __params.set('showhiddenitems', params.showhiddenitems.toString());
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/appsessions/${params.id}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2AppsessionsIdParams` containing the following parameters:
     *
     * - `id`: Appsession ID
     *
     * - `showhiddenitems`: ShowHiddenItems
     *
     * - `include`: Additional resources to include
     *
     * @return {?} OK
     */
    GetV2AppsessionsId(params) {
        return this.GetV2AppsessionsIdResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * The Execution Status cannot be changed since it is an automated status tracking the progress of running the app. The Qc Status may be updated only when the Execution Status is set to “Complete” or “Aborted”. Delivery Status may be updated at any time. Comments can be added when updating statuses.
     * @param {?} params The `BasespaceService.PostV2AppsessionsIdParams` containing the following parameters:
     *
     * - `id`: Appsession ID
     *
     * - `payload`:
     *
     * @return {?} OK
     */
    PostV2AppsessionsIdResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/appsessions/${params.id}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * The Execution Status cannot be changed since it is an automated status tracking the progress of running the app. The Qc Status may be updated only when the Execution Status is set to “Complete” or “Aborted”. Delivery Status may be updated at any time. Comments can be added when updating statuses.
     * @param {?} params The `BasespaceService.PostV2AppsessionsIdParams` containing the following parameters:
     *
     * - `id`: Appsession ID
     *
     * - `payload`:
     *
     * @return {?} OK
     */
    PostV2AppsessionsId(params) {
        return this.PostV2AppsessionsIdResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2AppsessionsIdCommentsParams` containing the following parameters:
     *
     * - `id`: Appsession ID
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2AppsessionsIdCommentsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/appsessions/${params.id}/comments`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2AppsessionsIdCommentsParams` containing the following parameters:
     *
     * - `id`: Appsession ID
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2AppsessionsIdComments(params) {
        return this.GetV2AppsessionsIdCommentsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2AppsessionsIdLogfilesParams` containing the following parameters:
     *
     * - `turbomode`:
     *
     * - `id`: Appsession ID
     *
     * - `filehrefcontentresolution`: Resolves the HrefContent to the direct file URI to avoid a hop to GET: files/{id}/content
     *
     * - `excludevcfindexfolder`: Whether to exclude VCF index folders
     *
     * - `excludesystemfolder`: Whether to exclude system folders
     *
     * - `excludeemptyfiles`: Whether to exclude empty files
     *
     * - `excludebamcoveragefolder`: Whether to exclude BAM coverage folders
     *
     * - `statuses`: Optionally filter by status (default complete)
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `pathprefix`: To be pre-fixed in the path of the file
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `includesubdirectories`: Whether to return subdirectories
     *
     * - `filesetid`:
     *
     * - `extensions`: Filter by file extension
     *
     * - `excludeextensions`: Exclude by file extension
     *
     * - `directory`: Filter by directory path (root is /)
     *
     * @return {?} OK
     */
    GetV2AppsessionsIdLogfilesResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.turbomode != null)
            __params = __params.set('turbomode', params.turbomode.toString());
        if (params.filehrefcontentresolution != null)
            __params = __params.set('filehrefcontentresolution', params.filehrefcontentresolution.toString());
        if (params.excludevcfindexfolder != null)
            __params = __params.set('excludevcfindexfolder', params.excludevcfindexfolder.toString());
        if (params.excludesystemfolder != null)
            __params = __params.set('excludesystemfolder', params.excludesystemfolder.toString());
        if (params.excludeemptyfiles != null)
            __params = __params.set('excludeemptyfiles', params.excludeemptyfiles.toString());
        if (params.excludebamcoveragefolder != null)
            __params = __params.set('excludebamcoveragefolder', params.excludebamcoveragefolder.toString());
        (params.statuses || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('statuses', val.toString()); }));
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.pathprefix != null)
            __params = __params.set('pathprefix', params.pathprefix.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        if (params.includesubdirectories != null)
            __params = __params.set('includesubdirectories', params.includesubdirectories.toString());
        if (params.filesetid != null)
            __params = __params.set('filesetid', params.filesetid.toString());
        if (params.extensions != null)
            __params = __params.set('extensions', params.extensions.toString());
        if (params.excludeextensions != null)
            __params = __params.set('excludeextensions', params.excludeextensions.toString());
        if (params.directory != null)
            __params = __params.set('directory', params.directory.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/appsessions/${params.id}/logfiles`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2AppsessionsIdLogfilesParams` containing the following parameters:
     *
     * - `turbomode`:
     *
     * - `id`: Appsession ID
     *
     * - `filehrefcontentresolution`: Resolves the HrefContent to the direct file URI to avoid a hop to GET: files/{id}/content
     *
     * - `excludevcfindexfolder`: Whether to exclude VCF index folders
     *
     * - `excludesystemfolder`: Whether to exclude system folders
     *
     * - `excludeemptyfiles`: Whether to exclude empty files
     *
     * - `excludebamcoveragefolder`: Whether to exclude BAM coverage folders
     *
     * - `statuses`: Optionally filter by status (default complete)
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `pathprefix`: To be pre-fixed in the path of the file
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `includesubdirectories`: Whether to return subdirectories
     *
     * - `filesetid`:
     *
     * - `extensions`: Filter by file extension
     *
     * - `excludeextensions`: Exclude by file extension
     *
     * - `directory`: Filter by directory path (root is /)
     *
     * @return {?} OK
     */
    GetV2AppsessionsIdLogfiles(params) {
        return this.GetV2AppsessionsIdLogfilesResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.PostV2AppsessionsIdLogfilesParams` containing the following parameters:
     *
     * - `id`: Appsession ID
     *
     * - `payload`:
     *
     * @return {?} OK
     */
    PostV2AppsessionsIdLogfilesResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/appsessions/${params.id}/logfiles`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.PostV2AppsessionsIdLogfilesParams` containing the following parameters:
     *
     * - `id`: Appsession ID
     *
     * - `payload`:
     *
     * @return {?} OK
     */
    PostV2AppsessionsIdLogfiles(params) {
        return this.PostV2AppsessionsIdLogfilesResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2AppsessionsIdPropertiesParams` containing the following parameters:
     *
     * - `id`: Appsession ID
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `showhiddenitems`: Show Hidden projects and Datasets
     *
     * - `propertyitemslimit`: Limit the # of property items returned per property
     *
     * - `propertyfilters`: Filter by property name
     *
     * - `propertieslimit`: Limit the # of properties returned
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2AppsessionsIdPropertiesResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.showhiddenitems != null)
            __params = __params.set('showhiddenitems', params.showhiddenitems.toString());
        if (params.propertyitemslimit != null)
            __params = __params.set('propertyitemslimit', params.propertyitemslimit.toString());
        (params.propertyfilters || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('propertyfilters', val.toString()); }));
        if (params.propertieslimit != null)
            __params = __params.set('propertieslimit', params.propertieslimit.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/appsessions/${params.id}/properties`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2AppsessionsIdPropertiesParams` containing the following parameters:
     *
     * - `id`: Appsession ID
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `showhiddenitems`: Show Hidden projects and Datasets
     *
     * - `propertyitemslimit`: Limit the # of property items returned per property
     *
     * - `propertyfilters`: Filter by property name
     *
     * - `propertieslimit`: Limit the # of properties returned
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2AppsessionsIdProperties(params) {
        return this.GetV2AppsessionsIdPropertiesResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.PostV2AppsessionsIdPropertiesParams` containing the following parameters:
     *
     * - `id`: Appsession ID
     *
     * - `payload`:
     *
     * @return {?} OK or Created
     */
    PostV2AppsessionsIdPropertiesResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/appsessions/${params.id}/properties`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.PostV2AppsessionsIdPropertiesParams` containing the following parameters:
     *
     * - `id`: Appsession ID
     *
     * - `payload`:
     *
     * @return {?} OK or Created
     */
    PostV2AppsessionsIdProperties(params) {
        return this.PostV2AppsessionsIdPropertiesResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.DeleteV2AppsessionsIdPropertiesNameParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `id`: Appsession ID
     * @return {?}
     */
    DeleteV2AppsessionsIdPropertiesNameResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('DELETE', this.rootUrl + `/appsessions/${params.id}/properties/${params.name}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.DeleteV2AppsessionsIdPropertiesNameParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `id`: Appsession ID
     * @return {?}
     */
    DeleteV2AppsessionsIdPropertiesName(params) {
        return this.DeleteV2AppsessionsIdPropertiesNameResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2AppsessionsIdPropertiesNameParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `id`: Appsession ID
     *
     * - `showhiddenitems`: Hidden filter
     *
     * - `propertyitemslimit`: Limit the # of property items returned per property
     *
     * @return {?} OK
     */
    GetV2AppsessionsIdPropertiesNameResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.showhiddenitems != null)
            __params = __params.set('showhiddenitems', params.showhiddenitems.toString());
        if (params.propertyitemslimit != null)
            __params = __params.set('propertyitemslimit', params.propertyitemslimit.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/appsessions/${params.id}/properties/${params.name}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2AppsessionsIdPropertiesNameParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `id`: Appsession ID
     *
     * - `showhiddenitems`: Hidden filter
     *
     * - `propertyitemslimit`: Limit the # of property items returned per property
     *
     * @return {?} OK
     */
    GetV2AppsessionsIdPropertiesName(params) {
        return this.GetV2AppsessionsIdPropertiesNameResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2AppsessionsIdPropertiesNameItemsParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `id`: Appsession ID
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `showhiddenitems`: Hidden filter
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2AppsessionsIdPropertiesNameItemsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.showhiddenitems != null)
            __params = __params.set('showhiddenitems', params.showhiddenitems.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/appsessions/${params.id}/properties/${params.name}/items`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2AppsessionsIdPropertiesNameItemsParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `id`: Appsession ID
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `showhiddenitems`: Hidden filter
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2AppsessionsIdPropertiesNameItems(params) {
        return this.GetV2AppsessionsIdPropertiesNameItemsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.PostV2AppsessionsIdRescheduleParams` containing the following parameters:
     *
     * - `id`:
     *
     * - `payload`:
     * @return {?}
     */
    PostV2AppsessionsIdRescheduleResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/appsessions/${params.id}/reschedule`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.PostV2AppsessionsIdRescheduleParams` containing the following parameters:
     *
     * - `id`:
     *
     * - `payload`:
     * @return {?}
     */
    PostV2AppsessionsIdReschedule(params) {
        return this.PostV2AppsessionsIdRescheduleResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * The analysis must have a status of “Running” or “Pending”.
     * Stopping a running analysis will update the status to “Aborted”.
     * Stopping a pending analysis will update the status to “Canceled”.
     * @param {?} params The `BasespaceService.PostV2AppsessionsIdStopParams` containing the following parameters:
     *
     * - `id`: Appsession ID
     *
     * - `payload`:
     *
     * @return {?} OK
     */
    PostV2AppsessionsIdStopResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/appsessions/${params.id}/stop`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * The analysis must have a status of “Running” or “Pending”.
     * Stopping a running analysis will update the status to “Aborted”.
     * Stopping a pending analysis will update the status to “Canceled”.
     * @param {?} params The `BasespaceService.PostV2AppsessionsIdStopParams` containing the following parameters:
     *
     * - `id`: Appsession ID
     *
     * - `payload`:
     *
     * @return {?} OK
     */
    PostV2AppsessionsIdStop(params) {
        return this.PostV2AppsessionsIdStopResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?=} payload undefined
     * @return {?}
     */
    PostV2AppsessionsTrackResponse(payload) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/appsessions/track`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?=} payload undefined
     * @return {?}
     */
    PostV2AppsessionsTrack(payload) {
        return this.PostV2AppsessionsTrackResponse(payload).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?=} payload undefined
     * @return {?}
     */
    PostV2AppsessionsWorkflowsessionsTrackResponse(payload) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/appsessions/workflowsessions/track`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?=} payload undefined
     * @return {?}
     */
    PostV2AppsessionsWorkflowsessionsTrack(payload) {
        return this.PostV2AppsessionsWorkflowsessionsTrackResponse(payload).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Archive one or more Runs or Projects.  The status will update right away, but the archive process itself is async.
     * @param {?=} payload undefined
     * @return {?} OK
     */
    PostV2ArchiveResponse(payload) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/archive`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'text'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Archive one or more Runs or Projects.  The status will update right away, but the archive process itself is async.
     * @param {?=} payload undefined
     * @return {?} OK
     */
    PostV2Archive(payload) {
        return this.PostV2ArchiveResponse(payload).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?=} eventaction undefined
     * @return {?}
     */
    GetV2ArchivingstatsResponse(eventaction) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (eventaction != null)
            __params = __params.set('eventaction', eventaction.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/archivingstats`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?=} eventaction undefined
     * @return {?}
     */
    GetV2Archivingstats(eventaction) {
        return this.GetV2ArchivingstatsResponse(eventaction).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2ArchivingstatsdetailsParams` containing the following parameters:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `id`: The Id of the resource
     * @return {?}
     */
    GetV2ArchivingstatsdetailsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        if (params.id != null)
            __params = __params.set('id', params.id.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/archivingstatsdetails`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2ArchivingstatsdetailsParams` containing the following parameters:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `id`: The Id of the resource
     * @return {?}
     */
    GetV2Archivingstatsdetails(params) {
        return this.GetV2ArchivingstatsdetailsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2AutodeletioneventsParams` containing the following parameters:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `id`: The Id of the resource
     * @return {?}
     */
    GetV2AutodeletioneventsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        if (params.id != null)
            __params = __params.set('id', params.id.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/autodeletionevents`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2AutodeletioneventsParams` containing the following parameters:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `id`: The Id of the resource
     * @return {?}
     */
    GetV2Autodeletionevents(params) {
        return this.GetV2AutodeletioneventsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2AutodeletionpipelineParams` containing the following parameters:
     *
     * - `format`:
     *
     * - `emailtemplatename`:
     * @return {?}
     */
    GetV2AutodeletionpipelineResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.format != null)
            __params = __params.set('format', params.format.toString());
        if (params.emailtemplatename != null)
            __params = __params.set('emailtemplatename', params.emailtemplatename.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/autodeletionpipeline`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2AutodeletionpipelineParams` containing the following parameters:
     *
     * - `format`:
     *
     * - `emailtemplatename`:
     * @return {?}
     */
    GetV2Autodeletionpipeline(params) {
        return this.GetV2AutodeletionpipelineResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2AutodeletionusersParams` containing the following parameters:
     *
     * - `sent`:
     *
     * - `illuminausers`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `id`: The Id of the resource
     *
     * - `emailtemplatename`:
     * @return {?}
     */
    GetV2AutodeletionusersResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sent != null)
            __params = __params.set('sent', params.sent.toString());
        if (params.illuminausers != null)
            __params = __params.set('illuminausers', params.illuminausers.toString());
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        if (params.id != null)
            __params = __params.set('id', params.id.toString());
        if (params.emailtemplatename != null)
            __params = __params.set('emailtemplatename', params.emailtemplatename.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/autodeletionusers`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2AutodeletionusersParams` containing the following parameters:
     *
     * - `sent`:
     *
     * - `illuminausers`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `id`: The Id of the resource
     *
     * - `emailtemplatename`:
     * @return {?}
     */
    GetV2Autodeletionusers(params) {
        return this.GetV2AutodeletionusersResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2BiosamplesParams` containing the following parameters:
     *
     * - `status`: Only return biosamples with the given Status(es)
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `propertynamestartswith`:
     *
     * - `projectid`: Only return biosamples with the specified default projects or datasets in those projects
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `labstatus`: Only return biosamples with the given LabStatus(es)
     *
     * - `include`: Sub elements to include in the response
     *
     * - `biosamplename`: Only return biosamples with the given BioSampleName(s)
     *
     * @return {?} OK
     */
    GetV2BiosamplesResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        (params.status || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('status', val.toString()); }));
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        (params.propertynamestartswith || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('propertynamestartswith', val.toString()); }));
        (params.projectid || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('projectid', val.toString()); }));
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        (params.labstatus || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('labstatus', val.toString()); }));
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        (params.biosamplename || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('biosamplename', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/biosamples`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2BiosamplesParams` containing the following parameters:
     *
     * - `status`: Only return biosamples with the given Status(es)
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `propertynamestartswith`:
     *
     * - `projectid`: Only return biosamples with the specified default projects or datasets in those projects
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `labstatus`: Only return biosamples with the given LabStatus(es)
     *
     * - `include`: Sub elements to include in the response
     *
     * - `biosamplename`: Only return biosamples with the given BioSampleName(s)
     *
     * @return {?} OK
     */
    GetV2Biosamples(params) {
        return this.GetV2BiosamplesResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Create a biological sample.
     * @param {?=} payload undefined
     * @return {?} OK
     */
    PostV2BiosamplesResponse(payload) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/biosamples`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Create a biological sample.
     * @param {?=} payload undefined
     * @return {?} OK
     */
    PostV2Biosamples(payload) {
        return this.PostV2BiosamplesResponse(payload).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * All lab requeues, from each of the types, are listed here. A pool lab requeue will show up on the list of lab requeues for all biosamples that make up the pool.
     * @param {?} params The `BasespaceService.GetV2BiosamplesBiosampleidLabrequeuesParams` containing the following parameters:
     *
     * - `biosampleid`: Biosample ID
     *
     * - `type`: Specify which type of lab requeue to be listed e.g. NewBioSampleLibrary, AdditionalYieldOfLibraryPool, or AdditionalYieldOfFinishedLibrary.
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2BiosamplesBiosampleidLabrequeuesResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.type != null)
            __params = __params.set('type', params.type.toString());
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/biosamples/${params.biosampleid}/labrequeues`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * All lab requeues, from each of the types, are listed here. A pool lab requeue will show up on the list of lab requeues for all biosamples that make up the pool.
     * @param {?} params The `BasespaceService.GetV2BiosamplesBiosampleidLabrequeuesParams` containing the following parameters:
     *
     * - `biosampleid`: Biosample ID
     *
     * - `type`: Specify which type of lab requeue to be listed e.g. NewBioSampleLibrary, AdditionalYieldOfLibraryPool, or AdditionalYieldOfFinishedLibrary.
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2BiosamplesBiosampleidLabrequeues(params) {
        return this.GetV2BiosamplesBiosampleidLabrequeuesResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2BiosamplesIdParams` containing the following parameters:
     *
     * - `id`: Biosample ID
     *
     * - `include`: Sub elements to include in the response
     *
     * @return {?} OK
     */
    GetV2BiosamplesIdResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/biosamples/${params.id}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2BiosamplesIdParams` containing the following parameters:
     *
     * - `id`: Biosample ID
     *
     * - `include`: Sub elements to include in the response
     *
     * @return {?} OK
     */
    GetV2BiosamplesId(params) {
        return this.GetV2BiosamplesIdResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Setting a new default project of a biosample will redirect newly created datasets to the new project. The biosample status may transition between any of the possible statuses. Setting a biosample to canceled will automatically cancel all analyses in progress for that biosample.
     * @param {?} params The `BasespaceService.PostV2BiosamplesIdParams` containing the following parameters:
     *
     * - `id`: Biosample ID
     *
     * - `payload`:
     *
     * @return {?} OK
     */
    PostV2BiosamplesIdResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/biosamples/${params.id}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Setting a new default project of a biosample will redirect newly created datasets to the new project. The biosample status may transition between any of the possible statuses. Setting a biosample to canceled will automatically cancel all analyses in progress for that biosample.
     * @param {?} params The `BasespaceService.PostV2BiosamplesIdParams` containing the following parameters:
     *
     * - `id`: Biosample ID
     *
     * - `payload`:
     *
     * @return {?} OK
     */
    PostV2BiosamplesId(params) {
        return this.PostV2BiosamplesIdResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2BiosamplesIdAggregatedfastqdatasetsParams` containing the following parameters:
     *
     * - `mixlibrarytypesallowed`: If true, mixing datasets of different library types is allowed, false otherwise
     *
     * - `id`: Biosample ID
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `selectedlibraryprepids`: Optional comma-separated list of selected LibraryPrepId values to consider
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     * @return {?}
     */
    GetV2BiosamplesIdAggregatedfastqdatasetsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.mixlibrarytypesallowed != null)
            __params = __params.set('mixlibrarytypesallowed', params.mixlibrarytypesallowed.toString());
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        (params.selectedlibraryprepids || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('selectedlibraryprepids', val.toString()); }));
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/biosamples/${params.id}/aggregatedfastqdatasets`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2BiosamplesIdAggregatedfastqdatasetsParams` containing the following parameters:
     *
     * - `mixlibrarytypesallowed`: If true, mixing datasets of different library types is allowed, false otherwise
     *
     * - `id`: Biosample ID
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `selectedlibraryprepids`: Optional comma-separated list of selected LibraryPrepId values to consider
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     * @return {?}
     */
    GetV2BiosamplesIdAggregatedfastqdatasets(params) {
        return this.GetV2BiosamplesIdAggregatedfastqdatasetsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.PostV2BiosamplesIdAggregationParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `payload`:
     * @return {?}
     */
    PostV2BiosamplesIdAggregationResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/biosamples/${params.id}/aggregation`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.PostV2BiosamplesIdAggregationParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `payload`:
     * @return {?}
     */
    PostV2BiosamplesIdAggregation(params) {
        return this.PostV2BiosamplesIdAggregationResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2BiosamplesIdLibrariesParams` containing the following parameters:
     *
     * - `id`: Biosample ID
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `include`: Sub elements to include in the response: LibraryIndex, YieldInformation
     *
     * @return {?} OK
     */
    GetV2BiosamplesIdLibrariesResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/biosamples/${params.id}/libraries`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2BiosamplesIdLibrariesParams` containing the following parameters:
     *
     * - `id`: Biosample ID
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `include`: Sub elements to include in the response: LibraryIndex, YieldInformation
     *
     * @return {?} OK
     */
    GetV2BiosamplesIdLibraries(params) {
        return this.GetV2BiosamplesIdLibrariesResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.PostV2BiosamplesIdLibrariesParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `payload`:
     *
     * @return {?} OK
     */
    PostV2BiosamplesIdLibrariesResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/biosamples/${params.id}/libraries`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.PostV2BiosamplesIdLibrariesParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `payload`:
     *
     * @return {?} OK
     */
    PostV2BiosamplesIdLibraries(params) {
        return this.PostV2BiosamplesIdLibrariesResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * List properties for a resource
     * @param {?} params The `BasespaceService.GetV2BiosamplesIdPropertiesParams` containing the following parameters:
     *
     * - `id`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `showhiddenitems`: Show Hidden projects and Datasets
     *
     * - `propertyitemslimit`: Limit the # of property items returned per property
     *
     * - `propertyfilters`: Filter by property name
     *
     * - `propertieslimit`: Limit the # of properties returned
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2BiosamplesIdPropertiesResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.showhiddenitems != null)
            __params = __params.set('showhiddenitems', params.showhiddenitems.toString());
        if (params.propertyitemslimit != null)
            __params = __params.set('propertyitemslimit', params.propertyitemslimit.toString());
        (params.propertyfilters || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('propertyfilters', val.toString()); }));
        if (params.propertieslimit != null)
            __params = __params.set('propertieslimit', params.propertieslimit.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/biosamples/${params.id}/properties`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * List properties for a resource
     * @param {?} params The `BasespaceService.GetV2BiosamplesIdPropertiesParams` containing the following parameters:
     *
     * - `id`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `showhiddenitems`: Show Hidden projects and Datasets
     *
     * - `propertyitemslimit`: Limit the # of property items returned per property
     *
     * - `propertyfilters`: Filter by property name
     *
     * - `propertieslimit`: Limit the # of properties returned
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2BiosamplesIdProperties(params) {
        return this.GetV2BiosamplesIdPropertiesResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Get property information
     * @param {?} params The `BasespaceService.GetV2BiosamplesIdPropertiesNameParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `id`:
     *
     * - `showhiddenitems`: Hidden filter
     *
     * - `propertyitemslimit`: Limit the # of property items returned per property
     *
     * @return {?} OK
     */
    GetV2BiosamplesIdPropertiesNameResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.showhiddenitems != null)
            __params = __params.set('showhiddenitems', params.showhiddenitems.toString());
        if (params.propertyitemslimit != null)
            __params = __params.set('propertyitemslimit', params.propertyitemslimit.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/biosamples/${params.id}/properties/${params.name}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get property information
     * @param {?} params The `BasespaceService.GetV2BiosamplesIdPropertiesNameParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `id`:
     *
     * - `showhiddenitems`: Hidden filter
     *
     * - `propertyitemslimit`: Limit the # of property items returned per property
     *
     * @return {?} OK
     */
    GetV2BiosamplesIdPropertiesName(params) {
        return this.GetV2BiosamplesIdPropertiesNameResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Get property item details
     * @param {?} params The `BasespaceService.GetV2BiosamplesIdPropertiesNameItemsParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `id`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `showhiddenitems`: Hidden filter
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2BiosamplesIdPropertiesNameItemsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.showhiddenitems != null)
            __params = __params.set('showhiddenitems', params.showhiddenitems.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/biosamples/${params.id}/properties/${params.name}/items`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get property item details
     * @param {?} params The `BasespaceService.GetV2BiosamplesIdPropertiesNameItemsParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `id`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `showhiddenitems`: Hidden filter
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2BiosamplesIdPropertiesNameItems(params) {
        return this.GetV2BiosamplesIdPropertiesNameItemsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2BiosamplesIdRunlanesummariesParams` containing the following parameters:
     *
     * - `id`: Biosample ID
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2BiosamplesIdRunlanesummariesResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/biosamples/${params.id}/runlanesummaries`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2BiosamplesIdRunlanesummariesParams` containing the following parameters:
     *
     * - `id`: Biosample ID
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2BiosamplesIdRunlanesummaries(params) {
        return this.GetV2BiosamplesIdRunlanesummariesResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Setting a new default project of a biosample will redirect newly created datasets to the new project.
     * @param {?=} payload undefined
     * @return {?} OK
     */
    PostV2BiosamplesBulkupdateResponse(payload) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/biosamples/bulkupdate`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Setting a new default project of a biosample will redirect newly created datasets to the new project.
     * @param {?=} payload undefined
     * @return {?} OK
     */
    PostV2BiosamplesBulkupdate(payload) {
        return this.PostV2BiosamplesBulkupdateResponse(payload).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Queue one or more resources for data compression.  Compression process is async.
     * @param {?=} payload undefined
     * @return {?} OK
     */
    PostV2DatacompressResponse(payload) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/datacompress`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'text'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Queue one or more resources for data compression.  Compression process is async.
     * @param {?=} payload undefined
     * @return {?} OK
     */
    PostV2Datacompress(payload) {
        return this.PostV2DatacompressResponse(payload).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2DatasetsParams` containing the following parameters:
     *
     * - `uploadstatus`: Return datasets of this file upload status.
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `qcstatus`: Return datasets of this QC status.
     *
     * - `propertyfilters`: Specify which properties to include in the properties section, e.g. Input.BioSamples, Input.Libraries, or Input.Runs.
     *
     * - `projectid`: Return datasets related to this project ID.
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `isarchived`: The archive states to filter by. Valid values include: True, False.
     *
     * - `inputruntokens`: Return datasets related to this run ID token.
     *
     * - `inputruns`: Return datasets related to this run ID.
     *
     * - `inputbiosamples`: Return datasets related to this biosample ID.
     *
     * - `include`: Can specify to return Properties, which returns an additional properties section for each dataset. Or return AppSessionRoot, which returns information about the root analysis of a workflow in the AppSession section for each dataset it applies to.
     *
     * - `datasettypes`: Return datasets of this type or excluding this type. Supports comma-separated lists.
     *
     * - `appsessionids`: Return datasets related to this app session ID.
     *
     * @return {?} A list of datasets
     */
    GetV2DatasetsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        (params.uploadstatus || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('uploadstatus', val.toString()); }));
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        (params.qcstatus || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('qcstatus', val.toString()); }));
        (params.propertyfilters || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('propertyfilters', val.toString()); }));
        if (params.projectid != null)
            __params = __params.set('projectid', params.projectid.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        if (params.isarchived != null)
            __params = __params.set('isarchived', params.isarchived.toString());
        (params.inputruntokens || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('inputruntokens', val.toString()); }));
        (params.inputruns || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('inputruns', val.toString()); }));
        (params.inputbiosamples || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('inputbiosamples', val.toString()); }));
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        (params.datasettypes || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('datasettypes', val.toString()); }));
        (params.appsessionids || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('appsessionids', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/datasets`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2DatasetsParams` containing the following parameters:
     *
     * - `uploadstatus`: Return datasets of this file upload status.
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `qcstatus`: Return datasets of this QC status.
     *
     * - `propertyfilters`: Specify which properties to include in the properties section, e.g. Input.BioSamples, Input.Libraries, or Input.Runs.
     *
     * - `projectid`: Return datasets related to this project ID.
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `isarchived`: The archive states to filter by. Valid values include: True, False.
     *
     * - `inputruntokens`: Return datasets related to this run ID token.
     *
     * - `inputruns`: Return datasets related to this run ID.
     *
     * - `inputbiosamples`: Return datasets related to this biosample ID.
     *
     * - `include`: Can specify to return Properties, which returns an additional properties section for each dataset. Or return AppSessionRoot, which returns information about the root analysis of a workflow in the AppSession section for each dataset it applies to.
     *
     * - `datasettypes`: Return datasets of this type or excluding this type. Supports comma-separated lists.
     *
     * - `appsessionids`: Return datasets related to this app session ID.
     *
     * @return {?} A list of datasets
     */
    GetV2Datasets(params) {
        return this.GetV2DatasetsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?=} payload undefined
     * @return {?} OK
     */
    PostV2DatasetsResponse(payload) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/datasets`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?=} payload undefined
     * @return {?} OK
     */
    PostV2Datasets(payload) {
        return this.PostV2DatasetsResponse(payload).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} id Dataset ID
     * @return {?} OK
     */
    GetV2DatasetsIdResponse(id) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/datasets/${id}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} id Dataset ID
     * @return {?} OK
     */
    GetV2DatasetsId(id) {
        return this.GetV2DatasetsIdResponse(id).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * The QcStatus of a dataset may only be updated when the UploadStatus is set to “Complete”. The QcStatus may then be updated to one of the following values: QcFailed or QcPassed. A comment may be entered into the Comment field when updating the dataset QcStatus.
     * @param {?} params The `BasespaceService.PostV2DatasetsIdParams` containing the following parameters:
     *
     * - `id`: Dataset ID
     *
     * - `payload`:
     *
     * @return {?} OK
     */
    PostV2DatasetsIdResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/datasets/${params.id}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * The QcStatus of a dataset may only be updated when the UploadStatus is set to “Complete”. The QcStatus may then be updated to one of the following values: QcFailed or QcPassed. A comment may be entered into the Comment field when updating the dataset QcStatus.
     * @param {?} params The `BasespaceService.PostV2DatasetsIdParams` containing the following parameters:
     *
     * - `id`: Dataset ID
     *
     * - `payload`:
     *
     * @return {?} OK
     */
    PostV2DatasetsId(params) {
        return this.PostV2DatasetsIdResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2DatasetsIdCommentsParams` containing the following parameters:
     *
     * - `id`: Dataset ID
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2DatasetsIdCommentsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/datasets/${params.id}/comments`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2DatasetsIdCommentsParams` containing the following parameters:
     *
     * - `id`: Dataset ID
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2DatasetsIdComments(params) {
        return this.GetV2DatasetsIdCommentsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.PostV2DatasetsIdCopyParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `payload`:
     *
     * @return {?} OK
     */
    PostV2DatasetsIdCopyResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/datasets/${params.id}/copy`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.PostV2DatasetsIdCopyParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `payload`:
     *
     * @return {?} OK
     */
    PostV2DatasetsIdCopy(params) {
        return this.PostV2DatasetsIdCopyResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Request direct upload information for a new dataset
     * @param {?} id The Id of the resource
     * @return {?} Request direct upload information for a new resource
     */
    GetV2DatasetsIdDirectUploadInfoResponse(id) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/datasets/${id}/direct-upload-info`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Request direct upload information for a new dataset
     * @param {?} id The Id of the resource
     * @return {?} Request direct upload information for a new resource
     */
    GetV2DatasetsIdDirectUploadInfo(id) {
        return this.GetV2DatasetsIdDirectUploadInfoResponse(id).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Report uploaded files to a dataset
     * @param {?} params The `BasespaceService.PostV2DatasetsIdDirectUploadInfoParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `payload`:
     *
     * @return {?} Report uploaded files to a resource
     */
    PostV2DatasetsIdDirectUploadInfoResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        __body = params.payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/datasets/${params.id}/direct-upload-info`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Report uploaded files to a dataset
     * @param {?} params The `BasespaceService.PostV2DatasetsIdDirectUploadInfoParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `payload`:
     *
     * @return {?} Report uploaded files to a resource
     */
    PostV2DatasetsIdDirectUploadInfo(params) {
        return this.PostV2DatasetsIdDirectUploadInfoResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2DatasetsIdFilesParams` containing the following parameters:
     *
     * - `turbomode`:
     *
     * - `id`: The Id of the resource
     *
     * - `filehrefcontentresolution`: Resolves the HrefContent to the direct file URI to avoid a hop to GET: files/{id}/content
     *
     * - `excludevcfindexfolder`: Whether to exclude VCF index folders
     *
     * - `excludesystemfolder`: Whether to exclude system folders
     *
     * - `excludeemptyfiles`: Whether to exclude empty files
     *
     * - `excludebamcoveragefolder`: Whether to exclude BAM coverage folders
     *
     * - `statuses`: Optionally filter by status (default complete)
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `pathprefix`: To be pre-fixed in the path of the file
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `includesubdirectories`: Whether to return subdirectories
     *
     * - `filesetid`:
     *
     * - `extensions`: Filter by file extension
     *
     * - `excludeextensions`: Exclude by file extension
     *
     * - `directory`: Filter by directory path (root is /)
     *
     * @return {?} OK
     */
    GetV2DatasetsIdFilesResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.turbomode != null)
            __params = __params.set('turbomode', params.turbomode.toString());
        if (params.filehrefcontentresolution != null)
            __params = __params.set('filehrefcontentresolution', params.filehrefcontentresolution.toString());
        if (params.excludevcfindexfolder != null)
            __params = __params.set('excludevcfindexfolder', params.excludevcfindexfolder.toString());
        if (params.excludesystemfolder != null)
            __params = __params.set('excludesystemfolder', params.excludesystemfolder.toString());
        if (params.excludeemptyfiles != null)
            __params = __params.set('excludeemptyfiles', params.excludeemptyfiles.toString());
        if (params.excludebamcoveragefolder != null)
            __params = __params.set('excludebamcoveragefolder', params.excludebamcoveragefolder.toString());
        (params.statuses || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('statuses', val.toString()); }));
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.pathprefix != null)
            __params = __params.set('pathprefix', params.pathprefix.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        if (params.includesubdirectories != null)
            __params = __params.set('includesubdirectories', params.includesubdirectories.toString());
        if (params.filesetid != null)
            __params = __params.set('filesetid', params.filesetid.toString());
        if (params.extensions != null)
            __params = __params.set('extensions', params.extensions.toString());
        if (params.excludeextensions != null)
            __params = __params.set('excludeextensions', params.excludeextensions.toString());
        if (params.directory != null)
            __params = __params.set('directory', params.directory.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/datasets/${params.id}/files`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2DatasetsIdFilesParams` containing the following parameters:
     *
     * - `turbomode`:
     *
     * - `id`: The Id of the resource
     *
     * - `filehrefcontentresolution`: Resolves the HrefContent to the direct file URI to avoid a hop to GET: files/{id}/content
     *
     * - `excludevcfindexfolder`: Whether to exclude VCF index folders
     *
     * - `excludesystemfolder`: Whether to exclude system folders
     *
     * - `excludeemptyfiles`: Whether to exclude empty files
     *
     * - `excludebamcoveragefolder`: Whether to exclude BAM coverage folders
     *
     * - `statuses`: Optionally filter by status (default complete)
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `pathprefix`: To be pre-fixed in the path of the file
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `includesubdirectories`: Whether to return subdirectories
     *
     * - `filesetid`:
     *
     * - `extensions`: Filter by file extension
     *
     * - `excludeextensions`: Exclude by file extension
     *
     * - `directory`: Filter by directory path (root is /)
     *
     * @return {?} OK
     */
    GetV2DatasetsIdFiles(params) {
        return this.GetV2DatasetsIdFilesResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.PostV2DatasetsIdFilesParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `file`: The file to upload
     *
     * @return {?} OK
     */
    PostV2DatasetsIdFilesResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let __formData = new FormData();
        __body = __formData;
        if (params.file != null) {
            __formData.append('file', (/** @type {?} */ (params.file)));
        }
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/datasets/${params.id}/files`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.PostV2DatasetsIdFilesParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `file`: The file to upload
     *
     * @return {?} OK
     */
    PostV2DatasetsIdFiles(params) {
        return this.PostV2DatasetsIdFilesResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Request direct file upload presigned url information for a new file in the specified resource (dataset or appresult)
     * @param {?} params The `BasespaceService.GetV2DatasetsIdFileUploadInfoParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `uploadpartcount`:
     *
     * - `filepath`:
     *
     * @return {?} Request direct file upload presigned url information for a new file in the specified resource
     */
    GetV2DatasetsIdFileUploadInfoResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.uploadpartcount != null)
            __params = __params.set('uploadpartcount', params.uploadpartcount.toString());
        if (params.filepath != null)
            __params = __params.set('filepath', params.filepath.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/datasets/${params.id}/file-upload-info`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Request direct file upload presigned url information for a new file in the specified resource (dataset or appresult)
     * @param {?} params The `BasespaceService.GetV2DatasetsIdFileUploadInfoParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `uploadpartcount`:
     *
     * - `filepath`:
     *
     * @return {?} Request direct file upload presigned url information for a new file in the specified resource
     */
    GetV2DatasetsIdFileUploadInfo(params) {
        return this.GetV2DatasetsIdFileUploadInfoResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Complete multipart upload and report uploaded files to a resource (dataset or appresult)
     * @param {?} params The `BasespaceService.PostV2DatasetsIdFileUploadInfoParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `payload`:
     *
     * @return {?} Complete multipart upload and report uploaded files to a resource (dataset or appresult)
     */
    PostV2DatasetsIdFileUploadInfoResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/datasets/${params.id}/file-upload-info`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Complete multipart upload and report uploaded files to a resource (dataset or appresult)
     * @param {?} params The `BasespaceService.PostV2DatasetsIdFileUploadInfoParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `payload`:
     *
     * @return {?} Complete multipart upload and report uploaded files to a resource (dataset or appresult)
     */
    PostV2DatasetsIdFileUploadInfo(params) {
        return this.PostV2DatasetsIdFileUploadInfoResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * List properties for a resource
     * @param {?} params The `BasespaceService.GetV2DatasetsIdPropertiesParams` containing the following parameters:
     *
     * - `id`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `showhiddenitems`: Show Hidden projects and Datasets
     *
     * - `propertyitemslimit`: Limit the # of property items returned per property
     *
     * - `propertyfilters`: Filter by property name
     *
     * - `propertieslimit`: Limit the # of properties returned
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2DatasetsIdPropertiesResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.showhiddenitems != null)
            __params = __params.set('showhiddenitems', params.showhiddenitems.toString());
        if (params.propertyitemslimit != null)
            __params = __params.set('propertyitemslimit', params.propertyitemslimit.toString());
        (params.propertyfilters || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('propertyfilters', val.toString()); }));
        if (params.propertieslimit != null)
            __params = __params.set('propertieslimit', params.propertieslimit.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/datasets/${params.id}/properties`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * List properties for a resource
     * @param {?} params The `BasespaceService.GetV2DatasetsIdPropertiesParams` containing the following parameters:
     *
     * - `id`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `showhiddenitems`: Show Hidden projects and Datasets
     *
     * - `propertyitemslimit`: Limit the # of property items returned per property
     *
     * - `propertyfilters`: Filter by property name
     *
     * - `propertieslimit`: Limit the # of properties returned
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2DatasetsIdProperties(params) {
        return this.GetV2DatasetsIdPropertiesResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Get property information
     * @param {?} params The `BasespaceService.GetV2DatasetsIdPropertiesNameParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `id`:
     *
     * - `showhiddenitems`: Hidden filter
     *
     * - `propertyitemslimit`: Limit the # of property items returned per property
     *
     * @return {?} OK
     */
    GetV2DatasetsIdPropertiesNameResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.showhiddenitems != null)
            __params = __params.set('showhiddenitems', params.showhiddenitems.toString());
        if (params.propertyitemslimit != null)
            __params = __params.set('propertyitemslimit', params.propertyitemslimit.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/datasets/${params.id}/properties/${params.name}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get property information
     * @param {?} params The `BasespaceService.GetV2DatasetsIdPropertiesNameParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `id`:
     *
     * - `showhiddenitems`: Hidden filter
     *
     * - `propertyitemslimit`: Limit the # of property items returned per property
     *
     * @return {?} OK
     */
    GetV2DatasetsIdPropertiesName(params) {
        return this.GetV2DatasetsIdPropertiesNameResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Get property item details
     * @param {?} params The `BasespaceService.GetV2DatasetsIdPropertiesNameItemsParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `id`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `showhiddenitems`: Hidden filter
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2DatasetsIdPropertiesNameItemsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.showhiddenitems != null)
            __params = __params.set('showhiddenitems', params.showhiddenitems.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/datasets/${params.id}/properties/${params.name}/items`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get property item details
     * @param {?} params The `BasespaceService.GetV2DatasetsIdPropertiesNameItemsParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `id`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `showhiddenitems`: Hidden filter
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2DatasetsIdPropertiesNameItems(params) {
        return this.GetV2DatasetsIdPropertiesNameItemsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2DatasettypesIdParams` containing the following parameters:
     *
     * - `id`: Dataset type ID
     *
     * - `include`:
     *
     * @return {?} OK
     */
    GetV2DatasettypesIdResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/datasettypes/${params.id}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2DatasettypesIdParams` containing the following parameters:
     *
     * - `id`: Dataset type ID
     *
     * - `include`:
     *
     * @return {?} OK
     */
    GetV2DatasettypesId(params) {
        return this.GetV2DatasettypesIdResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2GdssharetransferstatsParams` containing the following parameters:
     *
     * - `status`:
     *
     * - `operationtype`:
     *
     * - `maxitems`:
     * @return {?}
     */
    GetV2GdssharetransferstatsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.status != null)
            __params = __params.set('status', params.status.toString());
        if (params.operationtype != null)
            __params = __params.set('operationtype', params.operationtype.toString());
        if (params.maxitems != null)
            __params = __params.set('maxitems', params.maxitems.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/gdssharetransferstats`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2GdssharetransferstatsParams` containing the following parameters:
     *
     * - `status`:
     *
     * - `operationtype`:
     *
     * - `maxitems`:
     * @return {?}
     */
    GetV2Gdssharetransferstats(params) {
        return this.GetV2GdssharetransferstatsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Delete a resource in ICA
     * @param {?} params The `BasespaceService.DeleteV2IcauploadsFoldertypeDataidParams` containing the following parameters:
     *
     * - `foldertype`:
     *
     * - `dataid`:
     * @return {?}
     */
    DeleteV2IcauploadsFoldertypeDataidResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('DELETE', this.rootUrl + `/icauploads/${params.foldertype}/${params.dataid}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Delete a resource in ICA
     * @param {?} params The `BasespaceService.DeleteV2IcauploadsFoldertypeDataidParams` containing the following parameters:
     *
     * - `foldertype`:
     *
     * - `dataid`:
     * @return {?}
     */
    DeleteV2IcauploadsFoldertypeDataid(params) {
        return this.DeleteV2IcauploadsFoldertypeDataidResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Complete file(s) upload to ICA, and respond with meta data
     * @param {?} params The `BasespaceService.PostV2IcauploadsFoldertypeCompleteUploadParams` containing the following parameters:
     *
     * - `foldertype`:
     *
     * - `payload`:
     * @return {?}
     */
    PostV2IcauploadsFoldertypeCompleteUploadResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/icauploads/${params.foldertype}/complete-upload`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Complete file(s) upload to ICA, and respond with meta data
     * @param {?} params The `BasespaceService.PostV2IcauploadsFoldertypeCompleteUploadParams` containing the following parameters:
     *
     * - `foldertype`:
     *
     * - `payload`:
     * @return {?}
     */
    PostV2IcauploadsFoldertypeCompleteUpload(params) {
        return this.PostV2IcauploadsFoldertypeCompleteUploadResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Get upload destination on ICA and temporary upload credentials
     * @param {?} params The `BasespaceService.PostV2IcauploadsFoldertypeDirectUploadInfoParams` containing the following parameters:
     *
     * - `foldertype`:
     *
     * - `payload`:
     * @return {?}
     */
    PostV2IcauploadsFoldertypeDirectUploadInfoResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/icauploads/${params.foldertype}/direct-upload-info`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get upload destination on ICA and temporary upload credentials
     * @param {?} params The `BasespaceService.PostV2IcauploadsFoldertypeDirectUploadInfoParams` containing the following parameters:
     *
     * - `foldertype`:
     *
     * - `payload`:
     * @return {?}
     */
    PostV2IcauploadsFoldertypeDirectUploadInfo(params) {
        return this.PostV2IcauploadsFoldertypeDirectUploadInfoResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Request access to temporary data presigned URL for upload to test connectivity
     * @param {?} params The `BasespaceService.GetV2InstrumentconnectioncheckFileUploadInfoParams` containing the following parameters:
     *
     * - `uploadpartcount`:
     *
     * - `id`: The Id of the resource
     *
     * - `filepath`:
     *
     * @return {?} Request access to temporary data presigned URL for upload to test connectivity
     */
    GetV2InstrumentconnectioncheckFileUploadInfoResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.uploadpartcount != null)
            __params = __params.set('uploadpartcount', params.uploadpartcount.toString());
        if (params.id != null)
            __params = __params.set('id', params.id.toString());
        if (params.filepath != null)
            __params = __params.set('filepath', params.filepath.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/instrumentconnectioncheck/file-upload-info`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Request access to temporary data presigned URL for upload to test connectivity
     * @param {?} params The `BasespaceService.GetV2InstrumentconnectioncheckFileUploadInfoParams` containing the following parameters:
     *
     * - `uploadpartcount`:
     *
     * - `id`: The Id of the resource
     *
     * - `filepath`:
     *
     * @return {?} Request access to temporary data presigned URL for upload to test connectivity
     */
    GetV2InstrumentconnectioncheckFileUploadInfo(params) {
        return this.GetV2InstrumentconnectioncheckFileUploadInfoResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Create non-run instrument diagnostic data.
     * @param {?=} payload undefined
     * @return {?} Create non-run instrument diagnostic data
     */
    PostV2InstrumentdiagnosticsResponse(payload) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/instrumentdiagnostics`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Create non-run instrument diagnostic data.
     * @param {?=} payload undefined
     * @return {?} Create non-run instrument diagnostic data
     */
    PostV2Instrumentdiagnostics(payload) {
        return this.PostV2InstrumentdiagnosticsResponse(payload).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Get non-run instrument diagnostic data.
     * @param {?} id The Id of the resource
     * @return {?} Get non-run instrument diagnostic data
     */
    GetV2InstrumentdiagnosticsIdResponse(id) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/instrumentdiagnostics/${id}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get non-run instrument diagnostic data.
     * @param {?} id The Id of the resource
     * @return {?} Get non-run instrument diagnostic data
     */
    GetV2InstrumentdiagnosticsId(id) {
        return this.GetV2InstrumentdiagnosticsIdResponse(id).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Update non-run instrument diagnostic data.
     * @param {?} params The `BasespaceService.PostV2InstrumentdiagnosticsIdParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `payload`:
     *
     * @return {?} Update non-run instrument diagnostic data
     */
    PostV2InstrumentdiagnosticsIdResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/instrumentdiagnostics/${params.id}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Update non-run instrument diagnostic data.
     * @param {?} params The `BasespaceService.PostV2InstrumentdiagnosticsIdParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `payload`:
     *
     * @return {?} Update non-run instrument diagnostic data
     */
    PostV2InstrumentdiagnosticsId(params) {
        return this.PostV2InstrumentdiagnosticsIdResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * List available instruments for a user.
     * @param {?} params The `BasespaceService.GetV2InstrumentsParams` containing the following parameters:
     *
     * - `allworkgroups`:
     *
     * - `activeruns`:
     *
     * - `todate`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `id`: The Id of the resource
     *
     * - `fromdate`:
     *
     * @return {?} A list of instruments
     */
    GetV2InstrumentsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.allworkgroups != null)
            __params = __params.set('allworkgroups', params.allworkgroups.toString());
        if (params.activeruns != null)
            __params = __params.set('activeruns', params.activeruns.toString());
        if (params.todate != null)
            __params = __params.set('todate', params.todate.toString());
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        if (params.id != null)
            __params = __params.set('id', params.id.toString());
        if (params.fromdate != null)
            __params = __params.set('fromdate', params.fromdate.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/instruments`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * List available instruments for a user.
     * @param {?} params The `BasespaceService.GetV2InstrumentsParams` containing the following parameters:
     *
     * - `allworkgroups`:
     *
     * - `activeruns`:
     *
     * - `todate`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `id`: The Id of the resource
     *
     * - `fromdate`:
     *
     * @return {?} A list of instruments
     */
    GetV2Instruments(params) {
        return this.GetV2InstrumentsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Post instrument errors.
     * @param {?=} payload undefined
     * @return {?} OK
     */
    PostV2InstrumentsErrorsResponse(payload) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/instruments/errors`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Post instrument errors.
     * @param {?=} payload undefined
     * @return {?} OK
     */
    PostV2InstrumentsErrors(payload) {
        return this.PostV2InstrumentsErrorsResponse(payload).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Get instrument statistics for given serial numbers and time range. Returned data can be grouped by month or week.
     * @param {?} params The `BasespaceService.GetV2InstrumentstatisticsParams` containing the following parameters:
     *
     * - `timezone`: User timezone for binning.
     *
     * - `serialnumbers`: Comma-separated list of serial numbers.
     *
     * - `fromdate`: From date in user ISO 8601 format.
     *
     * - `todate`: To date in ISO 8601 format. Defaults to current date if not specified.
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `id`: The Id of the resource
     *
     * - `binby`: BinBy can be 'week' or 'month'.
     *
     * @return {?} OK
     */
    GetV2InstrumentstatisticsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.todate != null)
            __params = __params.set('todate', params.todate.toString());
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        if (params.id != null)
            __params = __params.set('id', params.id.toString());
        if (params.binby != null)
            __params = __params.set('binby', params.binby.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/instrumentstatistics`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get instrument statistics for given serial numbers and time range. Returned data can be grouped by month or week.
     * @param {?} params The `BasespaceService.GetV2InstrumentstatisticsParams` containing the following parameters:
     *
     * - `timezone`: User timezone for binning.
     *
     * - `serialnumbers`: Comma-separated list of serial numbers.
     *
     * - `fromdate`: From date in user ISO 8601 format.
     *
     * - `todate`: To date in ISO 8601 format. Defaults to current date if not specified.
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `id`: The Id of the resource
     *
     * - `binby`: BinBy can be 'week' or 'month'.
     *
     * @return {?} OK
     */
    GetV2Instrumentstatistics(params) {
        return this.GetV2InstrumentstatisticsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * List of instruments with active runs
     * @param {?} params The `BasespaceService.GetV2InstrumentstatusParams` containing the following parameters:
     *
     * - `includeactiveruns`: Set to true to include a list of active runs for each instrument.  Default is false.
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `serialnumbers`: A comma-delimited list of instrument serial numbers.
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `id`: The Id of the resource
     *
     * @return {?} A list of instruments with active runs
     */
    GetV2InstrumentstatusResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.includeactiveruns != null)
            __params = __params.set('includeactiveruns', params.includeactiveruns.toString());
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.serialnumbers != null)
            __params = __params.set('serialnumbers', params.serialnumbers.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        if (params.id != null)
            __params = __params.set('id', params.id.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/instrumentstatus`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * List of instruments with active runs
     * @param {?} params The `BasespaceService.GetV2InstrumentstatusParams` containing the following parameters:
     *
     * - `includeactiveruns`: Set to true to include a list of active runs for each instrument.  Default is false.
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `serialnumbers`: A comma-delimited list of instrument serial numbers.
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `id`: The Id of the resource
     *
     * @return {?} A list of instruments with active runs
     */
    GetV2Instrumentstatus(params) {
        return this.GetV2InstrumentstatusResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2LabrequeuesParams` containing the following parameters:
     *
     * - `type`: Only return labrequeues with the given LabRequeueTypes(s)
     *
     * - `status`: Only return labrequeues with the given Status(es)
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `id`: The Id of the resource
     *
     * @return {?} OK
     */
    GetV2LabrequeuesResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        (params.type || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('type', val.toString()); }));
        (params.status || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('status', val.toString()); }));
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        if (params.id != null)
            __params = __params.set('id', params.id.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/labrequeues`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2LabrequeuesParams` containing the following parameters:
     *
     * - `type`: Only return labrequeues with the given LabRequeueTypes(s)
     *
     * - `status`: Only return labrequeues with the given Status(es)
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `id`: The Id of the resource
     *
     * @return {?} OK
     */
    GetV2Labrequeues(params) {
        return this.GetV2LabrequeuesResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} id Labrequeue ID
     * @return {?} OK
     */
    GetV2LabrequeuesIdResponse(id) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/labrequeues/${id}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} id Labrequeue ID
     * @return {?} OK
     */
    GetV2LabrequeuesId(id) {
        return this.GetV2LabrequeuesIdResponse(id).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * The QC thresholds are applied to a user's account. Any runs uploaded in that user's context will automatically have all lanes of the flowcell undergo automatic QC based on the QC thresholds. Thresholds are saved either to a lane, or to a lane and read number.
     * @param {?=} id The Id of the resource
     * @return {?} OK
     */
    GetV2LaneqcthresholdsResponse(id) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (id != null)
            __params = __params.set('id', id.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/laneqcthresholds`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * The QC thresholds are applied to a user's account. Any runs uploaded in that user's context will automatically have all lanes of the flowcell undergo automatic QC based on the QC thresholds. Thresholds are saved either to a lane, or to a lane and read number.
     * @param {?=} id The Id of the resource
     * @return {?} OK
     */
    GetV2Laneqcthresholds(id) {
        return this.GetV2LaneqcthresholdsResponse(id).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * List the QC thresholds to be updated.
     * @param {?} params The `BasespaceService.PutV2LaneqcthresholdsParams` containing the following parameters:
     *
     * - `qcthresholds`:
     *
     * - `id`: The Id of the resource
     *
     * @return {?} OK
     */
    PutV2LaneqcthresholdsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        (params.qcthresholds || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('qcthresholds', val.toString()); }));
        if (params.id != null)
            __params = __params.set('id', params.id.toString());
        /** @type {?} */
        let req = new HttpRequest('PUT', this.rootUrl + `/laneqcthresholds`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * List the QC thresholds to be updated.
     * @param {?} params The `BasespaceService.PutV2LaneqcthresholdsParams` containing the following parameters:
     *
     * - `qcthresholds`:
     *
     * - `id`: The Id of the resource
     *
     * @return {?} OK
     */
    PutV2Laneqcthresholds(params) {
        return this.PutV2LaneqcthresholdsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} id The Id of the resource
     * @return {?} OK
     */
    GetV2LanesIdResponse(id) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/lanes/${id}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} id The Id of the resource
     * @return {?} OK
     */
    GetV2LanesId(id) {
        return this.GetV2LanesIdResponse(id).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * The status of a lane may be updated to the following values: QcFailed, QcPassed.
     * @param {?} params The `BasespaceService.PostV2LanesIdParams` containing the following parameters:
     *
     * - `id`:
     *
     * - `payload`:
     *
     * @return {?} OK
     */
    PostV2LanesIdResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/lanes/${params.id}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * The status of a lane may be updated to the following values: QcFailed, QcPassed.
     * @param {?} params The `BasespaceService.PostV2LanesIdParams` containing the following parameters:
     *
     * - `id`:
     *
     * - `payload`:
     *
     * @return {?} OK
     */
    PostV2LanesId(params) {
        return this.PostV2LanesIdResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2LanesIdCommentsParams` containing the following parameters:
     *
     * - `id`: Lane ID
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2LanesIdCommentsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/lanes/${params.id}/comments`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2LanesIdCommentsParams` containing the following parameters:
     *
     * - `id`: Lane ID
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2LanesIdComments(params) {
        return this.GetV2LanesIdCommentsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2LibrariesParams` containing the following parameters:
     *
     * - `status`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `id`: The Id of the resource
     *
     * @return {?} OK
     */
    GetV2LibrariesResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        (params.status || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('status', val.toString()); }));
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        if (params.id != null)
            __params = __params.set('id', params.id.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/libraries`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2LibrariesParams` containing the following parameters:
     *
     * - `status`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `id`: The Id of the resource
     *
     * @return {?} OK
     */
    GetV2Libraries(params) {
        return this.GetV2LibrariesResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * List properties for a resource
     * @param {?} params The `BasespaceService.GetV2LibrariesIdPropertiesParams` containing the following parameters:
     *
     * - `id`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `showhiddenitems`: Show Hidden projects and Datasets
     *
     * - `propertyitemslimit`: Limit the # of property items returned per property
     *
     * - `propertyfilters`: Filter by property name
     *
     * - `propertieslimit`: Limit the # of properties returned
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2LibrariesIdPropertiesResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.showhiddenitems != null)
            __params = __params.set('showhiddenitems', params.showhiddenitems.toString());
        if (params.propertyitemslimit != null)
            __params = __params.set('propertyitemslimit', params.propertyitemslimit.toString());
        (params.propertyfilters || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('propertyfilters', val.toString()); }));
        if (params.propertieslimit != null)
            __params = __params.set('propertieslimit', params.propertieslimit.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/libraries/${params.id}/properties`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * List properties for a resource
     * @param {?} params The `BasespaceService.GetV2LibrariesIdPropertiesParams` containing the following parameters:
     *
     * - `id`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `showhiddenitems`: Show Hidden projects and Datasets
     *
     * - `propertyitemslimit`: Limit the # of property items returned per property
     *
     * - `propertyfilters`: Filter by property name
     *
     * - `propertieslimit`: Limit the # of properties returned
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2LibrariesIdProperties(params) {
        return this.GetV2LibrariesIdPropertiesResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Get property information
     * @param {?} params The `BasespaceService.GetV2LibrariesIdPropertiesNameParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `id`:
     *
     * - `showhiddenitems`: Hidden filter
     *
     * - `propertyitemslimit`: Limit the # of property items returned per property
     *
     * @return {?} OK
     */
    GetV2LibrariesIdPropertiesNameResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.showhiddenitems != null)
            __params = __params.set('showhiddenitems', params.showhiddenitems.toString());
        if (params.propertyitemslimit != null)
            __params = __params.set('propertyitemslimit', params.propertyitemslimit.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/libraries/${params.id}/properties/${params.name}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get property information
     * @param {?} params The `BasespaceService.GetV2LibrariesIdPropertiesNameParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `id`:
     *
     * - `showhiddenitems`: Hidden filter
     *
     * - `propertyitemslimit`: Limit the # of property items returned per property
     *
     * @return {?} OK
     */
    GetV2LibrariesIdPropertiesName(params) {
        return this.GetV2LibrariesIdPropertiesNameResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Get property item details
     * @param {?} params The `BasespaceService.GetV2LibrariesIdPropertiesNameItemsParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `id`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `showhiddenitems`: Hidden filter
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2LibrariesIdPropertiesNameItemsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.showhiddenitems != null)
            __params = __params.set('showhiddenitems', params.showhiddenitems.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/libraries/${params.id}/properties/${params.name}/items`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get property item details
     * @param {?} params The `BasespaceService.GetV2LibrariesIdPropertiesNameItemsParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `id`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `showhiddenitems`: Hidden filter
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2LibrariesIdPropertiesNameItems(params) {
        return this.GetV2LibrariesIdPropertiesNameItemsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * The requested additional yield is the total yield to be requested for the whole pool. To estimate how much yield will be added from each library, divide the requested additional yield by the number of libraries in the pool.
     * @param {?} params The `BasespaceService.PostV2LibrariesLibraryidLabrequeuesParams` containing the following parameters:
     *
     * - `libraryid`:
     *
     * - `payload`:
     *
     * @return {?} OK
     */
    PostV2LibrariesLibraryidLabrequeuesResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/libraries/${params.libraryid}/labrequeues`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * The requested additional yield is the total yield to be requested for the whole pool. To estimate how much yield will be added from each library, divide the requested additional yield by the number of libraries in the pool.
     * @param {?} params The `BasespaceService.PostV2LibrariesLibraryidLabrequeuesParams` containing the following parameters:
     *
     * - `libraryid`:
     *
     * - `payload`:
     *
     * @return {?} OK
     */
    PostV2LibrariesLibraryidLabrequeues(params) {
        return this.PostV2LibrariesLibraryidLabrequeuesResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2LibrarypoolsParams` containing the following parameters:
     *
     * - `status`: Possible values are: Active, Failed, Consumed, QCFailed
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `id`: The Id of the resource
     *
     * @return {?} OK
     */
    GetV2LibrarypoolsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        (params.status || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('status', val.toString()); }));
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        if (params.id != null)
            __params = __params.set('id', params.id.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/librarypools`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2LibrarypoolsParams` containing the following parameters:
     *
     * - `status`: Possible values are: Active, Failed, Consumed, QCFailed
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `id`: The Id of the resource
     *
     * @return {?} OK
     */
    GetV2Librarypools(params) {
        return this.GetV2LibrarypoolsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * The status of a pool may be updated to the following values: Active, Failed, Consumed or QCFailed. Setting a pool to Failed or QCFailed will exclude all FASTQ datasets created from the pool from app launch when one of its biosamples are selected as an input. This is also reflected on the Actual Yield of each biosample in the pool.
     * @param {?} params The `BasespaceService.PostV2LibrarypoolsIdParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `payload`:
     *
     * @return {?} OK
     */
    PostV2LibrarypoolsIdResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/librarypools/${params.id}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * The status of a pool may be updated to the following values: Active, Failed, Consumed or QCFailed. Setting a pool to Failed or QCFailed will exclude all FASTQ datasets created from the pool from app launch when one of its biosamples are selected as an input. This is also reflected on the Actual Yield of each biosample in the pool.
     * @param {?} params The `BasespaceService.PostV2LibrarypoolsIdParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `payload`:
     *
     * @return {?} OK
     */
    PostV2LibrarypoolsId(params) {
        return this.PostV2LibrarypoolsIdResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2LibrarypoolsIdLibrariesParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `include`: Sub elements to include in the response: LibraryIndex, YieldInformation
     *
     * @return {?} OK
     */
    GetV2LibrarypoolsIdLibrariesResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/librarypools/${params.id}/libraries`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2LibrarypoolsIdLibrariesParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `include`: Sub elements to include in the response: LibraryIndex, YieldInformation
     *
     * @return {?} OK
     */
    GetV2LibrarypoolsIdLibraries(params) {
        return this.GetV2LibrarypoolsIdLibrariesResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * List properties for a resource
     * @param {?} params The `BasespaceService.GetV2LibrarypoolsIdPropertiesParams` containing the following parameters:
     *
     * - `id`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `showhiddenitems`: Show Hidden projects and Datasets
     *
     * - `propertyitemslimit`: Limit the # of property items returned per property
     *
     * - `propertyfilters`: Filter by property name
     *
     * - `propertieslimit`: Limit the # of properties returned
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2LibrarypoolsIdPropertiesResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.showhiddenitems != null)
            __params = __params.set('showhiddenitems', params.showhiddenitems.toString());
        if (params.propertyitemslimit != null)
            __params = __params.set('propertyitemslimit', params.propertyitemslimit.toString());
        (params.propertyfilters || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('propertyfilters', val.toString()); }));
        if (params.propertieslimit != null)
            __params = __params.set('propertieslimit', params.propertieslimit.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/librarypools/${params.id}/properties`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * List properties for a resource
     * @param {?} params The `BasespaceService.GetV2LibrarypoolsIdPropertiesParams` containing the following parameters:
     *
     * - `id`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `showhiddenitems`: Show Hidden projects and Datasets
     *
     * - `propertyitemslimit`: Limit the # of property items returned per property
     *
     * - `propertyfilters`: Filter by property name
     *
     * - `propertieslimit`: Limit the # of properties returned
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2LibrarypoolsIdProperties(params) {
        return this.GetV2LibrarypoolsIdPropertiesResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Get property information
     * @param {?} params The `BasespaceService.GetV2LibrarypoolsIdPropertiesNameParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `id`:
     *
     * - `showhiddenitems`: Hidden filter
     *
     * - `propertyitemslimit`: Limit the # of property items returned per property
     *
     * @return {?} OK
     */
    GetV2LibrarypoolsIdPropertiesNameResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.showhiddenitems != null)
            __params = __params.set('showhiddenitems', params.showhiddenitems.toString());
        if (params.propertyitemslimit != null)
            __params = __params.set('propertyitemslimit', params.propertyitemslimit.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/librarypools/${params.id}/properties/${params.name}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get property information
     * @param {?} params The `BasespaceService.GetV2LibrarypoolsIdPropertiesNameParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `id`:
     *
     * - `showhiddenitems`: Hidden filter
     *
     * - `propertyitemslimit`: Limit the # of property items returned per property
     *
     * @return {?} OK
     */
    GetV2LibrarypoolsIdPropertiesName(params) {
        return this.GetV2LibrarypoolsIdPropertiesNameResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Get property item details
     * @param {?} params The `BasespaceService.GetV2LibrarypoolsIdPropertiesNameItemsParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `id`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `showhiddenitems`: Hidden filter
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2LibrarypoolsIdPropertiesNameItemsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.showhiddenitems != null)
            __params = __params.set('showhiddenitems', params.showhiddenitems.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/librarypools/${params.id}/properties/${params.name}/items`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get property item details
     * @param {?} params The `BasespaceService.GetV2LibrarypoolsIdPropertiesNameItemsParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `id`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `showhiddenitems`: Hidden filter
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2LibrarypoolsIdPropertiesNameItems(params) {
        return this.GetV2LibrarypoolsIdPropertiesNameItemsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.PostV2LibrarypoolsPoolidLabrequeuesParams` containing the following parameters:
     *
     * - `poolid`:
     *
     * - `payload`:
     *
     * @return {?} OK
     */
    PostV2LibrarypoolsPoolidLabrequeuesResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/librarypools/${params.poolid}/labrequeues`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.PostV2LibrarypoolsPoolidLabrequeuesParams` containing the following parameters:
     *
     * - `poolid`:
     *
     * - `payload`:
     *
     * @return {?} OK
     */
    PostV2LibrarypoolsPoolidLabrequeues(params) {
        return this.PostV2LibrarypoolsPoolidLabrequeuesResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Delete a notification
     * @param {?} id The Id of the resource
     * @return {?}
     */
    DeleteV2NotificationsIdResponse(id) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('DELETE', this.rootUrl + `/notifications/${id}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Delete a notification
     * @param {?} id The Id of the resource
     * @return {?}
     */
    DeleteV2NotificationsId(id) {
        return this.DeleteV2NotificationsIdResponse(id).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Dismiss a user notification. Only DataDeletion, Storage or Subscription notifications can dismissed. For Deleting an Activity notification, use the DELETE endpoint
     * @param {?} params The `BasespaceService.PutV2NotificationsDismissParams` containing the following parameters:
     *
     * - `type`: The Type of the notification with in a stream.Only notifications with 'IsDismissable' flag set are dismissable
     *
     * - `stream`: The stream type of the notification to be dismissed.Only DataDeletion, Storage or Subscription notifications can dismissed.
     *
     * - `id`: The Id of the resource
     * @return {?}
     */
    PutV2NotificationsDismissResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.type != null)
            __params = __params.set('type', params.type.toString());
        if (params.stream != null)
            __params = __params.set('stream', params.stream.toString());
        if (params.id != null)
            __params = __params.set('id', params.id.toString());
        /** @type {?} */
        let req = new HttpRequest('PUT', this.rootUrl + `/notifications/dismiss`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Dismiss a user notification. Only DataDeletion, Storage or Subscription notifications can dismissed. For Deleting an Activity notification, use the DELETE endpoint
     * @param {?} params The `BasespaceService.PutV2NotificationsDismissParams` containing the following parameters:
     *
     * - `type`: The Type of the notification with in a stream.Only notifications with 'IsDismissable' flag set are dismissable
     *
     * - `stream`: The stream type of the notification to be dismissed.Only DataDeletion, Storage or Subscription notifications can dismissed.
     *
     * - `id`: The Id of the resource
     * @return {?}
     */
    PutV2NotificationsDismiss(params) {
        return this.PutV2NotificationsDismissResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Get OAuthV1 token using an OAuthV2Token
     * @param {?=} payload undefined
     * @return {?} OAuthV1 token issued from an OAuthV2 token
     */
    PostV2Oauthv1Tokenfromoauthv2Response(payload) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/oauthv1/tokenfromoauthv2`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get OAuthV1 token using an OAuthV2Token
     * @param {?=} payload undefined
     * @return {?} OAuthV1 token issued from an OAuthV2 token
     */
    PostV2Oauthv1Tokenfromoauthv2(payload) {
        return this.PostV2Oauthv1Tokenfromoauthv2Response(payload).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?=} payload undefined
     * @return {?} OK
     */
    PostV2Oauthv2TokenResponse(payload) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/oauthv2/token`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?=} payload undefined
     * @return {?} OK
     */
    PostV2Oauthv2Token(payload) {
        return this.PostV2Oauthv2TokenResponse(payload).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Create token for a trusted Platform service
     * @param {?=} payload undefined
     * @return {?} OAuthV2 token
     */
    PostV2Oauthv2TokenfromapplicationjwtResponse(payload) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/oauthv2/tokenfromapplicationjwt`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Create token for a trusted Platform service
     * @param {?=} payload undefined
     * @return {?} OAuthV2 token
     */
    PostV2Oauthv2Tokenfromapplicationjwt(payload) {
        return this.PostV2Oauthv2TokenfromapplicationjwtResponse(payload).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Create token for a given user id
     * @param {?} params The `BasespaceService.PostV2Oauthv2tokensUseridParams` containing the following parameters:
     *
     * - `userid`:
     *
     * - `payload`:
     *
     * @return {?} OAuthV2 token for workgroup
     */
    PostV2Oauthv2tokensUseridResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/oauthv2tokens/${params.userid}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Create token for a given user id
     * @param {?} params The `BasespaceService.PostV2Oauthv2tokensUseridParams` containing the following parameters:
     *
     * - `userid`:
     *
     * - `payload`:
     *
     * @return {?} OAuthV2 token for workgroup
     */
    PostV2Oauthv2tokensUserid(params) {
        return this.PostV2Oauthv2tokensUseridResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Invalidate/delete token for a given user
     * @return {?}
     */
    DeleteV2Oauthv2tokensCurrentResponse() {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('DELETE', this.rootUrl + `/oauthv2tokens/current`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Invalidate/delete token for a given user
     * @return {?}
     */
    DeleteV2Oauthv2tokensCurrent() {
        return this.DeleteV2Oauthv2tokensCurrentResponse().pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Request a requeue for a new library, given an existing preprequest.
     * @param {?} params The `BasespaceService.PostV2PreprequestsPreprequestidLabrequeuesParams` containing the following parameters:
     *
     * - `preprequestid`:
     *
     * - `payload`:
     *
     * @return {?} OK
     */
    PostV2PreprequestsPreprequestidLabrequeuesResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/preprequests/${params.preprequestid}/labrequeues`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Request a requeue for a new library, given an existing preprequest.
     * @param {?} params The `BasespaceService.PostV2PreprequestsPreprequestidLabrequeuesParams` containing the following parameters:
     *
     * - `preprequestid`:
     *
     * - `payload`:
     *
     * @return {?} OK
     */
    PostV2PreprequestsPreprequestidLabrequeues(params) {
        return this.PostV2PreprequestsPreprequestidLabrequeuesResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.PostV2ProjectsParams` containing the following parameters:
     *
     * - `name`: The name of the project.
     *
     * - `payload`:
     *
     * - `description`: Optional description of the project.
     *
     * @return {?} OK
     */
    PostV2ProjectsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.name != null)
            __params = __params.set('name', params.name.toString());
        __body = params.payload;
        if (params.description != null)
            __params = __params.set('description', params.description.toString());
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/projects`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.PostV2ProjectsParams` containing the following parameters:
     *
     * - `name`: The name of the project.
     *
     * - `payload`:
     *
     * - `description`: Optional description of the project.
     *
     * @return {?} OK
     */
    PostV2Projects(params) {
        return this.PostV2ProjectsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2ProjectsIdParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `propertyitemslimit`:
     *
     * - `propertieslimit`:
     *
     * - `include`:
     *
     * @return {?} Get information about a project
     */
    GetV2ProjectsIdResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.propertyitemslimit != null)
            __params = __params.set('propertyitemslimit', params.propertyitemslimit.toString());
        if (params.propertieslimit != null)
            __params = __params.set('propertieslimit', params.propertieslimit.toString());
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/projects/${params.id}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2ProjectsIdParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `propertyitemslimit`:
     *
     * - `propertieslimit`:
     *
     * - `include`:
     *
     * @return {?} Get information about a project
     */
    GetV2ProjectsId(params) {
        return this.GetV2ProjectsIdResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2ProjectsIdDatasetsParams` containing the following parameters:
     *
     * - `id`: Project ID
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `isarchived`: The archive states to filter by. Valid values include: True, False.
     *
     * @return {?} OK
     */
    GetV2ProjectsIdDatasetsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        if (params.isarchived != null)
            __params = __params.set('isarchived', params.isarchived.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/projects/${params.id}/datasets`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2ProjectsIdDatasetsParams` containing the following parameters:
     *
     * - `id`: Project ID
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `isarchived`: The archive states to filter by. Valid values include: True, False.
     *
     * @return {?} OK
     */
    GetV2ProjectsIdDatasets(params) {
        return this.GetV2ProjectsIdDatasetsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.PostV2ProjectsIdDatasetsParams` containing the following parameters:
     *
     * - `id`: Project ID
     *
     * - `payload`:
     *
     * @return {?} OK
     */
    PostV2ProjectsIdDatasetsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/projects/${params.id}/datasets`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.PostV2ProjectsIdDatasetsParams` containing the following parameters:
     *
     * - `id`: Project ID
     *
     * - `payload`:
     *
     * @return {?} OK
     */
    PostV2ProjectsIdDatasets(params) {
        return this.PostV2ProjectsIdDatasetsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * List properties for a resource
     * @param {?} params The `BasespaceService.GetV2ProjectsIdPropertiesParams` containing the following parameters:
     *
     * - `id`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `showhiddenitems`: Show Hidden projects and Datasets
     *
     * - `propertyitemslimit`: Limit the # of property items returned per property
     *
     * - `propertyfilters`: Filter by property name
     *
     * - `propertieslimit`: Limit the # of properties returned
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2ProjectsIdPropertiesResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.showhiddenitems != null)
            __params = __params.set('showhiddenitems', params.showhiddenitems.toString());
        if (params.propertyitemslimit != null)
            __params = __params.set('propertyitemslimit', params.propertyitemslimit.toString());
        (params.propertyfilters || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('propertyfilters', val.toString()); }));
        if (params.propertieslimit != null)
            __params = __params.set('propertieslimit', params.propertieslimit.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/projects/${params.id}/properties`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * List properties for a resource
     * @param {?} params The `BasespaceService.GetV2ProjectsIdPropertiesParams` containing the following parameters:
     *
     * - `id`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `showhiddenitems`: Show Hidden projects and Datasets
     *
     * - `propertyitemslimit`: Limit the # of property items returned per property
     *
     * - `propertyfilters`: Filter by property name
     *
     * - `propertieslimit`: Limit the # of properties returned
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2ProjectsIdProperties(params) {
        return this.GetV2ProjectsIdPropertiesResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Get property information
     * @param {?} params The `BasespaceService.GetV2ProjectsIdPropertiesNameParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `id`:
     *
     * - `showhiddenitems`: Hidden filter
     *
     * - `propertyitemslimit`: Limit the # of property items returned per property
     *
     * @return {?} OK
     */
    GetV2ProjectsIdPropertiesNameResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.showhiddenitems != null)
            __params = __params.set('showhiddenitems', params.showhiddenitems.toString());
        if (params.propertyitemslimit != null)
            __params = __params.set('propertyitemslimit', params.propertyitemslimit.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/projects/${params.id}/properties/${params.name}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get property information
     * @param {?} params The `BasespaceService.GetV2ProjectsIdPropertiesNameParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `id`:
     *
     * - `showhiddenitems`: Hidden filter
     *
     * - `propertyitemslimit`: Limit the # of property items returned per property
     *
     * @return {?} OK
     */
    GetV2ProjectsIdPropertiesName(params) {
        return this.GetV2ProjectsIdPropertiesNameResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Get property item details
     * @param {?} params The `BasespaceService.GetV2ProjectsIdPropertiesNameItemsParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `id`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `showhiddenitems`: Hidden filter
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2ProjectsIdPropertiesNameItemsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.showhiddenitems != null)
            __params = __params.set('showhiddenitems', params.showhiddenitems.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/projects/${params.id}/properties/${params.name}/items`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get property item details
     * @param {?} params The `BasespaceService.GetV2ProjectsIdPropertiesNameItemsParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `id`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `showhiddenitems`: Hidden filter
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2ProjectsIdPropertiesNameItems(params) {
        return this.GetV2ProjectsIdPropertiesNameItemsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?=} payload undefined
     * @return {?}
     */
    PostV2PublishappsessionstatusResponse(payload) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/publishappsessionstatus`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?=} payload undefined
     * @return {?}
     */
    PostV2Publishappsessionstatus(payload) {
        return this.PostV2PublishappsessionstatusResponse(payload).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2ResourcemanifestParams` containing the following parameters:
     *
     * - `fileszipped`:
     *
     * - `excludeemptyfiles`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `samples`:
     *
     * - `runmetrics`:
     *
     * - `runlogs`:
     *
     * - `runimages`:
     *
     * - `projects`:
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `ipdrunparameters`:
     *
     * - `id`: The Id of the resource
     *
     * - `extensions`:
     *
     * - `datasets`:
     *
     * - `appsessions`:
     *
     * - `appresults`:
     *
     * @return {?} OK
     */
    GetV2ResourcemanifestResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.fileszipped != null)
            __params = __params.set('fileszipped', params.fileszipped.toString());
        if (params.excludeemptyfiles != null)
            __params = __params.set('excludeemptyfiles', params.excludeemptyfiles.toString());
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        (params.samples || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('samples', val.toString()); }));
        (params.runmetrics || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('runmetrics', val.toString()); }));
        (params.runlogs || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('runlogs', val.toString()); }));
        (params.runimages || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('runimages', val.toString()); }));
        (params.projects || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('projects', val.toString()); }));
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        (params.ipdrunparameters || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('ipdrunparameters', val.toString()); }));
        if (params.id != null)
            __params = __params.set('id', params.id.toString());
        (params.extensions || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('extensions', val.toString()); }));
        (params.datasets || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('datasets', val.toString()); }));
        (params.appsessions || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('appsessions', val.toString()); }));
        (params.appresults || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('appresults', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/resourcemanifest`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2ResourcemanifestParams` containing the following parameters:
     *
     * - `fileszipped`:
     *
     * - `excludeemptyfiles`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `samples`:
     *
     * - `runmetrics`:
     *
     * - `runlogs`:
     *
     * - `runimages`:
     *
     * - `projects`:
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `ipdrunparameters`:
     *
     * - `id`: The Id of the resource
     *
     * - `extensions`:
     *
     * - `datasets`:
     *
     * - `appsessions`:
     *
     * - `appresults`:
     *
     * @return {?} OK
     */
    GetV2Resourcemanifest(params) {
        return this.GetV2ResourcemanifestResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Restore one or more Runs or Projects.  The process is async, and may take up to 48 hours.
     * @param {?=} payload undefined
     * @return {?} OK
     */
    PostV2RestoreResponse(payload) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/restore`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'text'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Restore one or more Runs or Projects.  The process is async, and may take up to 48 hours.
     * @param {?=} payload undefined
     * @return {?} OK
     */
    PostV2Restore(payload) {
        return this.PostV2RestoreResponse(payload).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2RunsParams` containing the following parameters:
     *
     * - `statuses`: The run statuses to filter by. Valid values include: New, Ready, Running, Paused, Stopped, Uploading, PendingAnalysis, Analyzing, Complete, Failed, NeedsAttention. Multiple values may be provided separated by commas.
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `propertynamestartswith`: Filter properties by name starting with. Max items returned is 1024.
     *
     * - `output.projects`: The project ids to filter by.
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `laneandqcstatuses`: The lane and QC statues to filter by.  Valid values include: Inital, QcPassed, and LaneQcFailed.  Multiple values may be separated by commas.
     *
     * - `instrumenttype`: The instrument type to filter by.
     *
     * - `include`: Sub elements to include in the response
     *
     * - `id`: The Id of the resource
     *
     * - `flowcellbarcode`: The flowcell barcode to filter by. To request empty barcodes, provide an empty string
     *
     * - `experimentname`: The experiment name to filter by.
     *
     * - `excludepropertynamestartswith`: Filter properties by name not starting with. Max items returned is 1024.
     *
     * @return {?} OK
     */
    GetV2RunsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.statuses != null)
            __params = __params.set('statuses', params.statuses.toString());
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        (params.propertynamestartswith || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('propertynamestartswith', val.toString()); }));
        (params.outputProjects || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('output.projects', val.toString()); }));
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        if (params.laneandqcstatuses != null)
            __params = __params.set('laneandqcstatuses', params.laneandqcstatuses.toString());
        if (params.instrumenttype != null)
            __params = __params.set('instrumenttype', params.instrumenttype.toString());
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        if (params.id != null)
            __params = __params.set('id', params.id.toString());
        if (params.flowcellbarcode != null)
            __params = __params.set('flowcellbarcode', params.flowcellbarcode.toString());
        if (params.experimentname != null)
            __params = __params.set('experimentname', params.experimentname.toString());
        (params.excludepropertynamestartswith || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('excludepropertynamestartswith', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/runs`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2RunsParams` containing the following parameters:
     *
     * - `statuses`: The run statuses to filter by. Valid values include: New, Ready, Running, Paused, Stopped, Uploading, PendingAnalysis, Analyzing, Complete, Failed, NeedsAttention. Multiple values may be provided separated by commas.
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `propertynamestartswith`: Filter properties by name starting with. Max items returned is 1024.
     *
     * - `output.projects`: The project ids to filter by.
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `laneandqcstatuses`: The lane and QC statues to filter by.  Valid values include: Inital, QcPassed, and LaneQcFailed.  Multiple values may be separated by commas.
     *
     * - `instrumenttype`: The instrument type to filter by.
     *
     * - `include`: Sub elements to include in the response
     *
     * - `id`: The Id of the resource
     *
     * - `flowcellbarcode`: The flowcell barcode to filter by. To request empty barcodes, provide an empty string
     *
     * - `experimentname`: The experiment name to filter by.
     *
     * - `excludepropertynamestartswith`: Filter properties by name not starting with. Max items returned is 1024.
     *
     * @return {?} OK
     */
    GetV2Runs(params) {
        return this.GetV2RunsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.PostV2RunsParams` containing the following parameters:
     *
     * - `instrumenttype`: The InstrumentType identifies from which the run is generated. This is REQUIRED for runs uploaded manually. Runs uploaded from an instrument must specify the ClientKey. AllowedValues: 'HiSeq1000', 'HiSeq1500', 'HiSeq2000', 'HiSeq2500', 'HiSeq3000', 'HiSeq4000', 'HiSeqX', 'NovaSeq5000', 'NovaSeq6000', 'MiniSeq', 'MiSeq', 'MiSeqDx', 'NextSeq', 'NextSeqDx', 'iSeq100'
     *
     * - `experimentname`: The name of the experiment.
     *
     * - `samplesheetname`: The name of the sample sheet.
     *
     * - `payload`:
     *
     * @return {?} OK
     */
    PostV2RunsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.instrumenttype != null)
            __params = __params.set('instrumenttype', params.instrumenttype.toString());
        if (params.experimentname != null)
            __params = __params.set('experimentname', params.experimentname.toString());
        if (params.samplesheetname != null)
            __params = __params.set('samplesheetname', params.samplesheetname.toString());
        __body = params.payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/runs`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.PostV2RunsParams` containing the following parameters:
     *
     * - `instrumenttype`: The InstrumentType identifies from which the run is generated. This is REQUIRED for runs uploaded manually. Runs uploaded from an instrument must specify the ClientKey. AllowedValues: 'HiSeq1000', 'HiSeq1500', 'HiSeq2000', 'HiSeq2500', 'HiSeq3000', 'HiSeq4000', 'HiSeqX', 'NovaSeq5000', 'NovaSeq6000', 'MiniSeq', 'MiSeq', 'MiSeqDx', 'NextSeq', 'NextSeqDx', 'iSeq100'
     *
     * - `experimentname`: The name of the experiment.
     *
     * - `samplesheetname`: The name of the sample sheet.
     *
     * - `payload`:
     *
     * @return {?} OK
     */
    PostV2Runs(params) {
        return this.PostV2RunsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2RunsIdParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `propertyitemslimit`:
     *
     * - `propertieslimit`:
     *
     * - `include`:
     *
     * @return {?} Get information about a run
     */
    GetV2RunsIdResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.propertyitemslimit != null)
            __params = __params.set('propertyitemslimit', params.propertyitemslimit.toString());
        if (params.propertieslimit != null)
            __params = __params.set('propertieslimit', params.propertieslimit.toString());
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/runs/${params.id}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2RunsIdParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `propertyitemslimit`:
     *
     * - `propertieslimit`:
     *
     * - `include`:
     *
     * @return {?} Get information about a run
     */
    GetV2RunsId(params) {
        return this.GetV2RunsIdResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.PostV2RunsIdParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `uploadstatus`: Specifies the updated state of a run. AllowedValues: 'Uploading', 'Completed', 'Failed'.
     *
     * - `runparametersxml`: Update the run data based on the contents of run parameters.
     *
     * - `prepkitname`: Specifies the PrepkitName.
     *
     * - `payload`:
     *
     * - `instrumentrunstatus`: Specifies the updated state of a run. AllowedValues: 'Running', 'Stopped', 'InstrumentCompleted', 'Failed', 'Rehybing'.
     *
     * - `instrumentrunnumber`: Specifies the InstrumentRunNumber.
     *
     * - `instrumentrunid`: Specifies the InstrumentRunId.
     *
     * - `flowcellbarcode`: Specifies the FlowcellBarcode.
     *
     * @return {?} OK
     */
    PostV2RunsIdResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.uploadstatus != null)
            __params = __params.set('uploadstatus', params.uploadstatus.toString());
        if (params.runparametersxml != null)
            __params = __params.set('runparametersxml', params.runparametersxml.toString());
        if (params.prepkitname != null)
            __params = __params.set('prepkitname', params.prepkitname.toString());
        __body = params.payload;
        if (params.instrumentrunstatus != null)
            __params = __params.set('instrumentrunstatus', params.instrumentrunstatus.toString());
        if (params.instrumentrunnumber != null)
            __params = __params.set('instrumentrunnumber', params.instrumentrunnumber.toString());
        if (params.instrumentrunid != null)
            __params = __params.set('instrumentrunid', params.instrumentrunid.toString());
        if (params.flowcellbarcode != null)
            __params = __params.set('flowcellbarcode', params.flowcellbarcode.toString());
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/runs/${params.id}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.PostV2RunsIdParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `uploadstatus`: Specifies the updated state of a run. AllowedValues: 'Uploading', 'Completed', 'Failed'.
     *
     * - `runparametersxml`: Update the run data based on the contents of run parameters.
     *
     * - `prepkitname`: Specifies the PrepkitName.
     *
     * - `payload`:
     *
     * - `instrumentrunstatus`: Specifies the updated state of a run. AllowedValues: 'Running', 'Stopped', 'InstrumentCompleted', 'Failed', 'Rehybing'.
     *
     * - `instrumentrunnumber`: Specifies the InstrumentRunNumber.
     *
     * - `instrumentrunid`: Specifies the InstrumentRunId.
     *
     * - `flowcellbarcode`: Specifies the FlowcellBarcode.
     *
     * @return {?} OK
     */
    PostV2RunsId(params) {
        return this.PostV2RunsIdResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2RunsIdFilesParams` containing the following parameters:
     *
     * - `recursive`: If a 'directory' is provided, files in subfolders of the given directory are also included
     *
     * - `id`: The Id of the resource
     *
     * - `filehrefcontentresolution`: Resolves the HrefContent to the direct file URI to avoid a hop to GET: files/{id}/content
     *
     * - `statuses`: Optionally filter by status (default complete)
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `pathprefix`: To be pre-fixed in the path of the file
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `include`: Possible values: 'Subdirectories', 'TotalCount'
     *
     * - `extensions`: The file extensions to filter by (comma-separated)
     *
     * - `excludeextensions`: The file extensions to exclude (comma-separated)
     *
     * - `directory`: The directory path to filter by (root is /)
     *
     * @return {?} OK
     */
    GetV2RunsIdFilesResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.recursive != null)
            __params = __params.set('recursive', params.recursive.toString());
        if (params.filehrefcontentresolution != null)
            __params = __params.set('filehrefcontentresolution', params.filehrefcontentresolution.toString());
        (params.statuses || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('statuses', val.toString()); }));
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.pathprefix != null)
            __params = __params.set('pathprefix', params.pathprefix.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        if (params.extensions != null)
            __params = __params.set('extensions', params.extensions.toString());
        if (params.excludeextensions != null)
            __params = __params.set('excludeextensions', params.excludeextensions.toString());
        if (params.directory != null)
            __params = __params.set('directory', params.directory.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/runs/${params.id}/files`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2RunsIdFilesParams` containing the following parameters:
     *
     * - `recursive`: If a 'directory' is provided, files in subfolders of the given directory are also included
     *
     * - `id`: The Id of the resource
     *
     * - `filehrefcontentresolution`: Resolves the HrefContent to the direct file URI to avoid a hop to GET: files/{id}/content
     *
     * - `statuses`: Optionally filter by status (default complete)
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `pathprefix`: To be pre-fixed in the path of the file
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `include`: Possible values: 'Subdirectories', 'TotalCount'
     *
     * - `extensions`: The file extensions to filter by (comma-separated)
     *
     * - `excludeextensions`: The file extensions to exclude (comma-separated)
     *
     * - `directory`: The directory path to filter by (root is /)
     *
     * @return {?} OK
     */
    GetV2RunsIdFiles(params) {
        return this.GetV2RunsIdFilesResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.PostV2RunsIdFilesParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `file`: The file to upload
     *
     * @return {?} OK
     */
    PostV2RunsIdFilesResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let __formData = new FormData();
        __body = __formData;
        if (params.file != null) {
            __formData.append('file', (/** @type {?} */ (params.file)));
        }
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/runs/${params.id}/files`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.PostV2RunsIdFilesParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `file`: The file to upload
     *
     * @return {?} OK
     */
    PostV2RunsIdFiles(params) {
        return this.PostV2RunsIdFilesResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Request direct file upload presigned url information for a new file in the specified resource (sample or run)
     * @param {?} params The `BasespaceService.GetV2RunsIdFileUploadInfoParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `uploadpartcount`:
     *
     * - `filepath`:
     *
     * @return {?} Request direct file upload presigned url information for a new file in the specified resource
     */
    GetV2RunsIdFileUploadInfoResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.uploadpartcount != null)
            __params = __params.set('uploadpartcount', params.uploadpartcount.toString());
        if (params.filepath != null)
            __params = __params.set('filepath', params.filepath.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/runs/${params.id}/file-upload-info`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Request direct file upload presigned url information for a new file in the specified resource (sample or run)
     * @param {?} params The `BasespaceService.GetV2RunsIdFileUploadInfoParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `uploadpartcount`:
     *
     * - `filepath`:
     *
     * @return {?} Request direct file upload presigned url information for a new file in the specified resource
     */
    GetV2RunsIdFileUploadInfo(params) {
        return this.GetV2RunsIdFileUploadInfoResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Complete multipart upload and report uploaded files to a resource (sample or run)
     * @param {?} params The `BasespaceService.PostV2RunsIdFileUploadInfoParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `payload`:
     *
     * @return {?} Complete multipart upload and report uploaded files to a resource (sample or run)
     */
    PostV2RunsIdFileUploadInfoResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/runs/${params.id}/file-upload-info`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Complete multipart upload and report uploaded files to a resource (sample or run)
     * @param {?} params The `BasespaceService.PostV2RunsIdFileUploadInfoParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `payload`:
     *
     * @return {?} Complete multipart upload and report uploaded files to a resource (sample or run)
     */
    PostV2RunsIdFileUploadInfo(params) {
        return this.PostV2RunsIdFileUploadInfoResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * List properties for a resource
     * @param {?} params The `BasespaceService.GetV2RunsIdPropertiesParams` containing the following parameters:
     *
     * - `id`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `showhiddenitems`: Show Hidden projects and Datasets
     *
     * - `propertyitemslimit`: Limit the # of property items returned per property
     *
     * - `propertyfilters`: Filter by property name
     *
     * - `propertieslimit`: Limit the # of properties returned
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2RunsIdPropertiesResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.showhiddenitems != null)
            __params = __params.set('showhiddenitems', params.showhiddenitems.toString());
        if (params.propertyitemslimit != null)
            __params = __params.set('propertyitemslimit', params.propertyitemslimit.toString());
        (params.propertyfilters || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('propertyfilters', val.toString()); }));
        if (params.propertieslimit != null)
            __params = __params.set('propertieslimit', params.propertieslimit.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/runs/${params.id}/properties`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * List properties for a resource
     * @param {?} params The `BasespaceService.GetV2RunsIdPropertiesParams` containing the following parameters:
     *
     * - `id`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `showhiddenitems`: Show Hidden projects and Datasets
     *
     * - `propertyitemslimit`: Limit the # of property items returned per property
     *
     * - `propertyfilters`: Filter by property name
     *
     * - `propertieslimit`: Limit the # of properties returned
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2RunsIdProperties(params) {
        return this.GetV2RunsIdPropertiesResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Get property information
     * @param {?} params The `BasespaceService.GetV2RunsIdPropertiesNameParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `id`:
     *
     * - `showhiddenitems`: Hidden filter
     *
     * - `propertyitemslimit`: Limit the # of property items returned per property
     *
     * @return {?} OK
     */
    GetV2RunsIdPropertiesNameResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.showhiddenitems != null)
            __params = __params.set('showhiddenitems', params.showhiddenitems.toString());
        if (params.propertyitemslimit != null)
            __params = __params.set('propertyitemslimit', params.propertyitemslimit.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/runs/${params.id}/properties/${params.name}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get property information
     * @param {?} params The `BasespaceService.GetV2RunsIdPropertiesNameParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `id`:
     *
     * - `showhiddenitems`: Hidden filter
     *
     * - `propertyitemslimit`: Limit the # of property items returned per property
     *
     * @return {?} OK
     */
    GetV2RunsIdPropertiesName(params) {
        return this.GetV2RunsIdPropertiesNameResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Get property item details
     * @param {?} params The `BasespaceService.GetV2RunsIdPropertiesNameItemsParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `id`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `showhiddenitems`: Hidden filter
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2RunsIdPropertiesNameItemsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.showhiddenitems != null)
            __params = __params.set('showhiddenitems', params.showhiddenitems.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/runs/${params.id}/properties/${params.name}/items`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get property item details
     * @param {?} params The `BasespaceService.GetV2RunsIdPropertiesNameItemsParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `id`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `showhiddenitems`: Hidden filter
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2RunsIdPropertiesNameItems(params) {
        return this.GetV2RunsIdPropertiesNameItemsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Request run sample sheet
     * @param {?} id The Id of the resource
     * @return {?} OK
     */
    GetV2RunsIdSamplesheetResponse(id) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/runs/${id}/samplesheet`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Request run sample sheet
     * @param {?} id The Id of the resource
     * @return {?} OK
     */
    GetV2RunsIdSamplesheet(id) {
        return this.GetV2RunsIdSamplesheetResponse(id).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Request sequencing stats
     * @param {?} id The Id of the resource
     * @return {?} OK
     */
    GetV2RunsIdSequencingstatsResponse(id) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/runs/${id}/sequencingstats`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Request sequencing stats
     * @param {?} id The Id of the resource
     * @return {?} OK
     */
    GetV2RunsIdSequencingstats(id) {
        return this.GetV2RunsIdSequencingstatsResponse(id).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * check user access for the run ids and returned filtered list
     * @param {?=} ids undefined
     * @return {?} check user access for the run ids and returned filtered list
     */
    GetV2RunsAccesscheckResponse(ids) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        (ids || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('ids', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/runs/accesscheck`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * check user access for the run ids and returned filtered list
     * @param {?=} ids undefined
     * @return {?} check user access for the run ids and returned filtered list
     */
    GetV2RunsAccesscheck(ids) {
        return this.GetV2RunsAccesscheckResponse(ids).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?=} payload undefined
     * @return {?} OK
     */
    PostV2RunsStartResponse(payload) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/runs/start`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?=} payload undefined
     * @return {?} OK
     */
    PostV2RunsStart(payload) {
        return this.PostV2RunsStartResponse(payload).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @return {?} OK
     */
    GetV2RunuploadtestResponse() {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/runuploadtest`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @return {?} OK
     */
    GetV2Runuploadtest() {
        return this.GetV2RunuploadtestResponse().pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Request direct file upload presigned url information for a new file in the specified resource (sample or run)
     * @param {?} params The `BasespaceService.GetV2SamplesIdFileUploadInfoParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `uploadpartcount`:
     *
     * - `filepath`:
     *
     * @return {?} Request direct file upload presigned url information for a new file in the specified resource
     */
    GetV2SamplesIdFileUploadInfoResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.uploadpartcount != null)
            __params = __params.set('uploadpartcount', params.uploadpartcount.toString());
        if (params.filepath != null)
            __params = __params.set('filepath', params.filepath.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/samples/${params.id}/file-upload-info`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Request direct file upload presigned url information for a new file in the specified resource (sample or run)
     * @param {?} params The `BasespaceService.GetV2SamplesIdFileUploadInfoParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `uploadpartcount`:
     *
     * - `filepath`:
     *
     * @return {?} Request direct file upload presigned url information for a new file in the specified resource
     */
    GetV2SamplesIdFileUploadInfo(params) {
        return this.GetV2SamplesIdFileUploadInfoResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Complete multipart upload and report uploaded files to a resource (sample or run)
     * @param {?} params The `BasespaceService.PostV2SamplesIdFileUploadInfoParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `payload`:
     *
     * @return {?} Complete multipart upload and report uploaded files to a resource (sample or run)
     */
    PostV2SamplesIdFileUploadInfoResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/samples/${params.id}/file-upload-info`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Complete multipart upload and report uploaded files to a resource (sample or run)
     * @param {?} params The `BasespaceService.PostV2SamplesIdFileUploadInfoParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `payload`:
     *
     * @return {?} Complete multipart upload and report uploaded files to a resource (sample or run)
     */
    PostV2SamplesIdFileUploadInfo(params) {
        return this.PostV2SamplesIdFileUploadInfoResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @return {?}
     */
    DeleteV2SessionInvalidateResponse() {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('DELETE', this.rootUrl + `/session/invalidate`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @return {?}
     */
    DeleteV2SessionInvalidate() {
        return this.DeleteV2SessionInvalidateResponse().pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * List properties for a resource
     * @param {?} params The `BasespaceService.GetV2SubjectsIdPropertiesParams` containing the following parameters:
     *
     * - `id`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `showhiddenitems`: Show Hidden projects and Datasets
     *
     * - `propertyitemslimit`: Limit the # of property items returned per property
     *
     * - `propertyfilters`: Filter by property name
     *
     * - `propertieslimit`: Limit the # of properties returned
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2SubjectsIdPropertiesResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.showhiddenitems != null)
            __params = __params.set('showhiddenitems', params.showhiddenitems.toString());
        if (params.propertyitemslimit != null)
            __params = __params.set('propertyitemslimit', params.propertyitemslimit.toString());
        (params.propertyfilters || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('propertyfilters', val.toString()); }));
        if (params.propertieslimit != null)
            __params = __params.set('propertieslimit', params.propertieslimit.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/subjects/${params.id}/properties`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * List properties for a resource
     * @param {?} params The `BasespaceService.GetV2SubjectsIdPropertiesParams` containing the following parameters:
     *
     * - `id`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `showhiddenitems`: Show Hidden projects and Datasets
     *
     * - `propertyitemslimit`: Limit the # of property items returned per property
     *
     * - `propertyfilters`: Filter by property name
     *
     * - `propertieslimit`: Limit the # of properties returned
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2SubjectsIdProperties(params) {
        return this.GetV2SubjectsIdPropertiesResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Get property information
     * @param {?} params The `BasespaceService.GetV2SubjectsIdPropertiesNameParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `id`:
     *
     * - `showhiddenitems`: Hidden filter
     *
     * - `propertyitemslimit`: Limit the # of property items returned per property
     *
     * @return {?} OK
     */
    GetV2SubjectsIdPropertiesNameResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.showhiddenitems != null)
            __params = __params.set('showhiddenitems', params.showhiddenitems.toString());
        if (params.propertyitemslimit != null)
            __params = __params.set('propertyitemslimit', params.propertyitemslimit.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/subjects/${params.id}/properties/${params.name}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get property information
     * @param {?} params The `BasespaceService.GetV2SubjectsIdPropertiesNameParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `id`:
     *
     * - `showhiddenitems`: Hidden filter
     *
     * - `propertyitemslimit`: Limit the # of property items returned per property
     *
     * @return {?} OK
     */
    GetV2SubjectsIdPropertiesName(params) {
        return this.GetV2SubjectsIdPropertiesNameResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Get property item details
     * @param {?} params The `BasespaceService.GetV2SubjectsIdPropertiesNameItemsParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `id`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `showhiddenitems`: Hidden filter
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2SubjectsIdPropertiesNameItemsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.showhiddenitems != null)
            __params = __params.set('showhiddenitems', params.showhiddenitems.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/subjects/${params.id}/properties/${params.name}/items`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get property item details
     * @param {?} params The `BasespaceService.GetV2SubjectsIdPropertiesNameItemsParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `id`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `showhiddenitems`: Hidden filter
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2SubjectsIdPropertiesNameItems(params) {
        return this.GetV2SubjectsIdPropertiesNameItemsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Creates a Platform JWT for an instrument.
     * @param {?=} payload undefined
     * @return {?} OK
     */
    PostV2TokensInstrumentsResponse(payload) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/tokens/instruments`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Creates a Platform JWT for an instrument.
     * @param {?=} payload undefined
     * @return {?} OK
     */
    PostV2TokensInstruments(payload) {
        return this.PostV2TokensInstrumentsResponse(payload).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Deleting all items from the trash is a non-reversible action. All items and their files will be removed from Sequence Hub permanently.
     * @return {?}
     */
    DeleteV2TrashResponse() {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('DELETE', this.rootUrl + `/trash`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Deleting all items from the trash is a non-reversible action. All items and their files will be removed from Sequence Hub permanently.
     * @return {?}
     */
    DeleteV2Trash() {
        return this.DeleteV2TrashResponse().pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2TrashParams` containing the following parameters:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2TrashResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/trash`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2TrashParams` containing the following parameters:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2Trash(params) {
        return this.GetV2TrashResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} id The Id of the resource
     * @return {?} OK
     */
    GetV2TrashIdResponse(id) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/trash/${id}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} id The Id of the resource
     * @return {?} OK
     */
    GetV2TrashId(id) {
        return this.GetV2TrashIdResponse(id).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * The ID used in this endpoint is the ID given to the item when it is put in the trash, not the original ID from the resource, i.e. its project ID. Please use the GET /v2/trash endpoint to find the item’s trash ID.
     * @param {?} params The `BasespaceService.PostV2TrashIdRestorefromtrashParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `payload`:
     *
     * @return {?} OK
     */
    PostV2TrashIdRestorefromtrashResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/trash/${params.id}/restorefromtrash`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * The ID used in this endpoint is the ID given to the item when it is put in the trash, not the original ID from the resource, i.e. its project ID. Please use the GET /v2/trash endpoint to find the item’s trash ID.
     * @param {?} params The `BasespaceService.PostV2TrashIdRestorefromtrashParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `payload`:
     *
     * @return {?} OK
     */
    PostV2TrashIdRestorefromtrash(params) {
        return this.PostV2TrashIdRestorefromtrashResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Unzip one or more Runs. The status will update right away, but the unzip process itself is async
     * @param {?=} payload undefined
     * @return {?} OK
     */
    PostV2UnzipResponse(payload) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/unzip`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'text'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Unzip one or more Runs. The status will update right away, but the unzip process itself is async
     * @param {?=} payload undefined
     * @return {?} OK
     */
    PostV2Unzip(payload) {
        return this.PostV2UnzipResponse(payload).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2UseragreementsParams` containing the following parameters:
     *
     * - `title`: If specified, only return agreements with titles exactly matching the specified value.
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `include`: Expand or filter the agreements returned. Include=Expired will return expired agreements, giving a history of all agreements ever signed by the user. Include=Pending looks for agreements that the user hasn't signed yet.
     *
     * - `id`: The Id of the resource
     *
     * - `category`: If specified, only return agreements with category exactly matching the specified value.
     *
     * - `applicationid`: If specified, only return agreements for this application. If not, only return agreements not associated with an application.
     *
     * @return {?} OK
     */
    GetV2UseragreementsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.title != null)
            __params = __params.set('title', params.title.toString());
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        if (params.id != null)
            __params = __params.set('id', params.id.toString());
        if (params.category != null)
            __params = __params.set('category', params.category.toString());
        if (params.applicationid != null)
            __params = __params.set('applicationid', params.applicationid.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/useragreements/`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2UseragreementsParams` containing the following parameters:
     *
     * - `title`: If specified, only return agreements with titles exactly matching the specified value.
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `include`: Expand or filter the agreements returned. Include=Expired will return expired agreements, giving a history of all agreements ever signed by the user. Include=Pending looks for agreements that the user hasn't signed yet.
     *
     * - `id`: The Id of the resource
     *
     * - `category`: If specified, only return agreements with category exactly matching the specified value.
     *
     * - `applicationid`: If specified, only return agreements for this application. If not, only return agreements not associated with an application.
     *
     * @return {?} OK
     */
    GetV2Useragreements(params) {
        return this.GetV2UseragreementsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Sign an agreement.
     * @param {?=} payload undefined
     * @return {?} OK
     */
    PostV2UseragreementsResponse(payload) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/useragreements/`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Sign an agreement.
     * @param {?=} payload undefined
     * @return {?} OK
     */
    PostV2Useragreements(payload) {
        return this.PostV2UseragreementsResponse(payload).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2UsersIdParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `options`:
     *
     * - `include`:
     *
     * @return {?} OK
     */
    GetV2UsersIdResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.options != null)
            __params = __params.set('options', params.options.toString());
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/users/${params.id}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2UsersIdParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `options`:
     *
     * - `include`:
     *
     * @return {?} OK
     */
    GetV2UsersId(params) {
        return this.GetV2UsersIdResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2UsersIdAutodeletioneventsParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     * @return {?}
     */
    GetV2UsersIdAutodeletioneventsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/users/${params.id}/autodeletionevents`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2UsersIdAutodeletioneventsParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     * @return {?}
     */
    GetV2UsersIdAutodeletionevents(params) {
        return this.GetV2UsersIdAutodeletioneventsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2UsersIdMessagesParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     * @return {?}
     */
    GetV2UsersIdMessagesResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/users/${params.id}/messages`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2UsersIdMessagesParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     * @return {?}
     */
    GetV2UsersIdMessages(params) {
        return this.GetV2UsersIdMessagesResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * List notifications for a user
     * @param {?} params The `BasespaceService.GetV2UsersIdNotificationsParams` containing the following parameters:
     *
     * - `streamtype`: The classification of user notifications to receive. Applicable values are 'All', 'Activity', 'Storage', 'DataDeletion', 'Subscription', 'CMS'
     *
     * - `id`: The Id of the resource
     *
     * - `attentionrequired`: AttentionRequired
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `category`: The category within a 'Stream' of user notifications to receive. Currently only 'Activity' Stream supports Categories. Applicable values are 'All', 'Run', 'AppSession', 'Invite'
     *
     * @return {?} OK
     */
    GetV2UsersIdNotificationsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.streamtype != null)
            __params = __params.set('streamtype', params.streamtype.toString());
        if (params.attentionrequired != null)
            __params = __params.set('attentionrequired', params.attentionrequired.toString());
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        if (params.category != null)
            __params = __params.set('category', params.category.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/users/${params.id}/notifications`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * List notifications for a user
     * @param {?} params The `BasespaceService.GetV2UsersIdNotificationsParams` containing the following parameters:
     *
     * - `streamtype`: The classification of user notifications to receive. Applicable values are 'All', 'Activity', 'Storage', 'DataDeletion', 'Subscription', 'CMS'
     *
     * - `id`: The Id of the resource
     *
     * - `attentionrequired`: AttentionRequired
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `category`: The category within a 'Stream' of user notifications to receive. Currently only 'Activity' Stream supports Categories. Applicable values are 'All', 'Run', 'AppSession', 'Invite'
     *
     * @return {?} OK
     */
    GetV2UsersIdNotifications(params) {
        return this.GetV2UsersIdNotificationsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2UsersIdSettingsParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2UsersIdSettingsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/users/${params.id}/settings`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2UsersIdSettingsParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * @return {?} OK
     */
    GetV2UsersIdSettings(params) {
        return this.GetV2UsersIdSettingsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * A user may have settings such as how they receive notifications and expiration time on lab requeues. This currently only works with a session cookie.
     * @param {?} params The `BasespaceService.PostV2UsersIdSettingsParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `payload`:
     *
     * @return {?} OK
     */
    PostV2UsersIdSettingsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/users/${params.id}/settings`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * A user may have settings such as how they receive notifications and expiration time on lab requeues. This currently only works with a session cookie.
     * @param {?} params The `BasespaceService.PostV2UsersIdSettingsParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `payload`:
     *
     * @return {?} OK
     */
    PostV2UsersIdSettings(params) {
        return this.PostV2UsersIdSettingsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2UsersIdSubscriptionParams` containing the following parameters:
     *
     * - `refreshcache`:
     *
     * - `id`: The Id of the resource
     *
     * @return {?} OK
     */
    GetV2UsersIdSubscriptionResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.refreshcache != null)
            __params = __params.set('refreshcache', params.refreshcache.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/users/${params.id}/subscription`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2UsersIdSubscriptionParams` containing the following parameters:
     *
     * - `refreshcache`:
     *
     * - `id`: The Id of the resource
     *
     * @return {?} OK
     */
    GetV2UsersIdSubscription(params) {
        return this.GetV2UsersIdSubscriptionResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2UsersIdWorkgroupsParams` containing the following parameters:
     *
     * - `refreshcache`: This will force a refresh on the workgroup subscriptions
     *
     * - `includesubscription`: This will include subscription in the response
     *
     * - `includeloggedinuser`: Includes current user
     *
     * - `id`: The Id of the resource
     *
     * - `activeonly`: Excludes inactive workgroups
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `include`: Sub elements to include in the response: LoggedInUser, IsDefaultRunUploadWorkgroup
     *
     * @return {?} OK
     */
    GetV2UsersIdWorkgroupsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.refreshcache != null)
            __params = __params.set('refreshcache', params.refreshcache.toString());
        if (params.includesubscription != null)
            __params = __params.set('includesubscription', params.includesubscription.toString());
        if (params.includeloggedinuser != null)
            __params = __params.set('includeloggedinuser', params.includeloggedinuser.toString());
        if (params.activeonly != null)
            __params = __params.set('activeonly', params.activeonly.toString());
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/users/${params.id}/workgroups`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2UsersIdWorkgroupsParams` containing the following parameters:
     *
     * - `refreshcache`: This will force a refresh on the workgroup subscriptions
     *
     * - `includesubscription`: This will include subscription in the response
     *
     * - `includeloggedinuser`: Includes current user
     *
     * - `id`: The Id of the resource
     *
     * - `activeonly`: Excludes inactive workgroups
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `include`: Sub elements to include in the response: LoggedInUser, IsDefaultRunUploadWorkgroup
     *
     * @return {?} OK
     */
    GetV2UsersIdWorkgroups(params) {
        return this.GetV2UsersIdWorkgroupsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.PostV2UsersIdV2analysisconfigtemplateParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `payload`:
     * @return {?}
     */
    PostV2UsersIdV2analysisconfigtemplateResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/users/${params.id}analysisconfigtemplate`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.PostV2UsersIdV2analysisconfigtemplateParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `payload`:
     * @return {?}
     */
    PostV2UsersIdV2analysisconfigtemplate(params) {
        return this.PostV2UsersIdV2analysisconfigtemplateResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.PostV2UsersIdV2biosampleregistryParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `payload`:
     * @return {?}
     */
    PostV2UsersIdV2biosampleregistryResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/users/${params.id}biosampleregistry`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.PostV2UsersIdV2biosampleregistryParams` containing the following parameters:
     *
     * - `id`: The Id of the resource
     *
     * - `payload`:
     * @return {?}
     */
    PostV2UsersIdV2biosampleregistry(params) {
        return this.PostV2UsersIdV2biosampleregistryResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2UsersCurrentParams` containing the following parameters:
     *
     * - `options`:
     *
     * - `include`:
     *
     * - `id`: The Id of the resource
     *
     * @return {?} OK
     */
    GetV2UsersCurrentResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.options != null)
            __params = __params.set('options', params.options.toString());
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        if (params.id != null)
            __params = __params.set('id', params.id.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/users/current`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2UsersCurrentParams` containing the following parameters:
     *
     * - `options`:
     *
     * - `include`:
     *
     * - `id`: The Id of the resource
     *
     * @return {?} OK
     */
    GetV2UsersCurrent(params) {
        return this.GetV2UsersCurrentResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Change current user context.
     * @param {?=} payload undefined
     * @return {?} OK
     */
    PostV2UsersCurrentResponse(payload) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/users/current`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Change current user context.
     * @param {?=} payload undefined
     * @return {?} OK
     */
    PostV2UsersCurrent(payload) {
        return this.PostV2UsersCurrentResponse(payload).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?=} id The Id of the resource
     * @return {?}
     */
    GetV2UsersCurrentLabtypeResponse(id) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (id != null)
            __params = __params.set('id', id.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/users/current/labtype`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?=} id The Id of the resource
     * @return {?}
     */
    GetV2UsersCurrentLabtype(id) {
        return this.GetV2UsersCurrentLabtypeResponse(id).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2UsersCurrentMessagesParams` containing the following parameters:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `id`: The Id of the resource
     * @return {?}
     */
    GetV2UsersCurrentMessagesResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        if (params.id != null)
            __params = __params.set('id', params.id.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/users/current/messages`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2UsersCurrentMessagesParams` containing the following parameters:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `id`: The Id of the resource
     * @return {?}
     */
    GetV2UsersCurrentMessages(params) {
        return this.GetV2UsersCurrentMessagesResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * List notifications for a user
     * @param {?} params The `BasespaceService.GetV2UsersCurrentNotificationsParams` containing the following parameters:
     *
     * - `streamtype`: The classification of user notifications to receive. Applicable values are 'All', 'Activity', 'Storage', 'DataDeletion', 'Subscription', 'CMS'
     *
     * - `attentionrequired`: AttentionRequired
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `id`: The Id of the resource
     *
     * - `category`: The category within a 'Stream' of user notifications to receive. Currently only 'Activity' Stream supports Categories. Applicable values are 'All', 'Run', 'AppSession', 'Invite'
     *
     * @return {?} OK
     */
    GetV2UsersCurrentNotificationsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.streamtype != null)
            __params = __params.set('streamtype', params.streamtype.toString());
        if (params.attentionrequired != null)
            __params = __params.set('attentionrequired', params.attentionrequired.toString());
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        if (params.id != null)
            __params = __params.set('id', params.id.toString());
        if (params.category != null)
            __params = __params.set('category', params.category.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/users/current/notifications`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * List notifications for a user
     * @param {?} params The `BasespaceService.GetV2UsersCurrentNotificationsParams` containing the following parameters:
     *
     * - `streamtype`: The classification of user notifications to receive. Applicable values are 'All', 'Activity', 'Storage', 'DataDeletion', 'Subscription', 'CMS'
     *
     * - `attentionrequired`: AttentionRequired
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `id`: The Id of the resource
     *
     * - `category`: The category within a 'Stream' of user notifications to receive. Currently only 'Activity' Stream supports Categories. Applicable values are 'All', 'Run', 'AppSession', 'Invite'
     *
     * @return {?} OK
     */
    GetV2UsersCurrentNotifications(params) {
        return this.GetV2UsersCurrentNotificationsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * List properties for a resource
     * @param {?} params The `BasespaceService.GetV2UsersCurrentPropertiesParams` containing the following parameters:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `showhiddenitems`: Show Hidden projects and Datasets
     *
     * - `propertyitemslimit`: Limit the # of property items returned per property
     *
     * - `propertyfilters`: Filter by property name
     *
     * - `propertieslimit`: Limit the # of properties returned
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `id`:
     *
     * @return {?} OK
     */
    GetV2UsersCurrentPropertiesResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.showhiddenitems != null)
            __params = __params.set('showhiddenitems', params.showhiddenitems.toString());
        if (params.propertyitemslimit != null)
            __params = __params.set('propertyitemslimit', params.propertyitemslimit.toString());
        (params.propertyfilters || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('propertyfilters', val.toString()); }));
        if (params.propertieslimit != null)
            __params = __params.set('propertieslimit', params.propertieslimit.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        if (params.id != null)
            __params = __params.set('id', params.id.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/users/current/properties`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * List properties for a resource
     * @param {?} params The `BasespaceService.GetV2UsersCurrentPropertiesParams` containing the following parameters:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `showhiddenitems`: Show Hidden projects and Datasets
     *
     * - `propertyitemslimit`: Limit the # of property items returned per property
     *
     * - `propertyfilters`: Filter by property name
     *
     * - `propertieslimit`: Limit the # of properties returned
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `id`:
     *
     * @return {?} OK
     */
    GetV2UsersCurrentProperties(params) {
        return this.GetV2UsersCurrentPropertiesResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Get property information
     * @param {?} params The `BasespaceService.GetV2UsersCurrentPropertiesNameParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `showhiddenitems`: Hidden filter
     *
     * - `propertyitemslimit`: Limit the # of property items returned per property
     *
     * - `id`:
     *
     * @return {?} OK
     */
    GetV2UsersCurrentPropertiesNameResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.showhiddenitems != null)
            __params = __params.set('showhiddenitems', params.showhiddenitems.toString());
        if (params.propertyitemslimit != null)
            __params = __params.set('propertyitemslimit', params.propertyitemslimit.toString());
        if (params.id != null)
            __params = __params.set('id', params.id.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/users/current/properties/${params.name}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get property information
     * @param {?} params The `BasespaceService.GetV2UsersCurrentPropertiesNameParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `showhiddenitems`: Hidden filter
     *
     * - `propertyitemslimit`: Limit the # of property items returned per property
     *
     * - `id`:
     *
     * @return {?} OK
     */
    GetV2UsersCurrentPropertiesName(params) {
        return this.GetV2UsersCurrentPropertiesNameResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Get property item details
     * @param {?} params The `BasespaceService.GetV2UsersCurrentPropertiesNameItemsParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `showhiddenitems`: Hidden filter
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `id`:
     *
     * @return {?} OK
     */
    GetV2UsersCurrentPropertiesNameItemsResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.showhiddenitems != null)
            __params = __params.set('showhiddenitems', params.showhiddenitems.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        if (params.id != null)
            __params = __params.set('id', params.id.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/users/current/properties/${params.name}/items`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get property item details
     * @param {?} params The `BasespaceService.GetV2UsersCurrentPropertiesNameItemsParams` containing the following parameters:
     *
     * - `name`: Property name
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `showhiddenitems`: Hidden filter
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `id`:
     *
     * @return {?} OK
     */
    GetV2UsersCurrentPropertiesNameItems(params) {
        return this.GetV2UsersCurrentPropertiesNameItemsResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2UsersCurrentSubscriptionParams` containing the following parameters:
     *
     * - `refreshcache`:
     *
     * - `id`: The Id of the resource
     *
     * @return {?} OK
     */
    GetV2UsersCurrentSubscriptionResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.refreshcache != null)
            __params = __params.set('refreshcache', params.refreshcache.toString());
        if (params.id != null)
            __params = __params.set('id', params.id.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/users/current/subscription`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2UsersCurrentSubscriptionParams` containing the following parameters:
     *
     * - `refreshcache`:
     *
     * - `id`: The Id of the resource
     *
     * @return {?} OK
     */
    GetV2UsersCurrentSubscription(params) {
        return this.GetV2UsersCurrentSubscriptionResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Information about storage and compute usage will be returned for the user’s personal account, as well as any workgroups they own.
     * @param {?} params The `BasespaceService.GetV2UsersCurrentUsageParams` containing the following parameters:
     *
     * - `refreshcache`:
     *
     * - `periods`:
     *
     * - `includeloggedinuser`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `id`: The Id of the resource
     *
     * @return {?} OK
     */
    GetV2UsersCurrentUsageResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.refreshcache != null)
            __params = __params.set('refreshcache', params.refreshcache.toString());
        if (params.periods != null)
            __params = __params.set('periods', params.periods.toString());
        if (params.includeloggedinuser != null)
            __params = __params.set('includeloggedinuser', params.includeloggedinuser.toString());
        if (params.sortdir != null)
            __params = __params.set('sortdir', params.sortdir.toString());
        if (params.sortby != null)
            __params = __params.set('sortby', params.sortby.toString());
        if (params.offset != null)
            __params = __params.set('offset', params.offset.toString());
        if (params.limit != null)
            __params = __params.set('limit', params.limit.toString());
        if (params.id != null)
            __params = __params.set('id', params.id.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/users/current/usage`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Information about storage and compute usage will be returned for the user’s personal account, as well as any workgroups they own.
     * @param {?} params The `BasespaceService.GetV2UsersCurrentUsageParams` containing the following parameters:
     *
     * - `refreshcache`:
     *
     * - `periods`:
     *
     * - `includeloggedinuser`:
     *
     * - `sortdir`: The sort direction for the result set
     *
     * - `sortby`: The field(s) used to sort the result set
     *
     * - `offset`: The starting offset to read
     *
     * - `limit`: The maximum number of items to return
     *
     * - `id`: The Id of the resource
     *
     * @return {?} OK
     */
    GetV2UsersCurrentUsage(params) {
        return this.GetV2UsersCurrentUsageResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?=} payload undefined
     * @return {?}
     */
    PostV2UsersFilesResponse(payload) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/users/files`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?=} payload undefined
     * @return {?}
     */
    PostV2UsersFiles(payload) {
        return this.PostV2UsersFilesResponse(payload).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Validate a OAuthV1 signed url for GroundControl
     * @param {?=} payload undefined
     * @return {?} OAuthV1 validation results of a signed url
     */
    PostV2ValidatesignedurlResponse(payload) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = payload;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/validatesignedurl`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Validate a OAuthV1 signed url for GroundControl
     * @param {?=} payload undefined
     * @return {?} OAuthV1 validation results of a signed url
     */
    PostV2Validatesignedurl(payload) {
        return this.PostV2ValidatesignedurlResponse(payload).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} id Workgroup ID
     * @return {?} OK
     */
    GetV2WorkgroupsIdResponse(id) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/workgroups/${id}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} id Workgroup ID
     * @return {?} OK
     */
    GetV2WorkgroupsId(id) {
        return this.GetV2WorkgroupsIdResponse(id).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2V2migrationStatusStepnameParams` containing the following parameters:
     *
     * - `stepname`: Migration Step Name
     *
     * - `id`: The Id of the resource
     *
     * @return {?} OK
     */
    GetV2V2migrationStatusStepnameResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.id != null)
            __params = __params.set('id', params.id.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `migration/status/${params.stepname}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `BasespaceService.GetV2V2migrationStatusStepnameParams` containing the following parameters:
     *
     * - `stepname`: Migration Step Name
     *
     * - `id`: The Id of the resource
     *
     * @return {?} OK
     */
    GetV2V2migrationStatusStepname(params) {
        return this.GetV2V2migrationStatusStepnameResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
}
BasespaceService.ngInjectableDef = ɵngcc0.ɵɵdefineInjectable({ token: BasespaceService, factory: function BasespaceService_Factory(t) { return new (t || BasespaceService)(ɵngcc0.ɵɵinject(ApiConfiguration), ɵngcc0.ɵɵinject(HttpClient)); }, providedIn: 'root' });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(BasespaceService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiConfiguration }, { type: HttpClient }]; }, { constructor: [], GetV2AgreementsResponse: [], GetV2Agreements: [], GetV2AgreementsIdResponse: [], GetV2AgreementsId: [], GetV2ApplicationmetadataResponse: [], GetV2Applicationmetadata: [], GetV2ApplicationsResponse: [], GetV2Applications: [], GetV2ApplicationsIdResponse: [], GetV2ApplicationsId: [], GetV2ApplicationsIdQcthresholdsResponse: [], GetV2ApplicationsIdQcthresholds: [], PutV2ApplicationsIdQcthresholdsResponse: [], PutV2ApplicationsIdQcthresholds: [], GetV2ApplicationsIdScreenshotsResponse: [], GetV2ApplicationsIdScreenshots: [], GetV2ApplicationsIdSettingsResponse: [], GetV2ApplicationsIdSettings: [], GetV2ApplicationsIdVersionsResponse: [], GetV2ApplicationsIdVersions: [], GetV2ApplicationsIdWorkflowdependenciesResponse: [], GetV2ApplicationsIdWorkflowdependencies: [], PutV2ApplicationsIdWorkflowdependenciesResponse: [], PutV2ApplicationsIdWorkflowdependencies: [], PostV2ApplicationsIdWorkflowsResponse: [], PostV2ApplicationsIdWorkflows: [], GetV2AppresultsIdFileUploadInfoResponse: [], GetV2AppresultsIdFileUploadInfo: [], PostV2AppresultsIdFileUploadInfoResponse: [], PostV2AppresultsIdFileUploadInfo: [], GetV2AppsessionsResponse: [], GetV2Appsessions: [], PostV2AppsessionsResponse: [], PostV2Appsessions: [], DeleteV2AppsessionsIdResponse: [], DeleteV2AppsessionsId: [], GetV2AppsessionsIdResponse: [], GetV2AppsessionsId: [], PostV2AppsessionsIdResponse: [], PostV2AppsessionsId: [], GetV2AppsessionsIdCommentsResponse: [], GetV2AppsessionsIdComments: [], GetV2AppsessionsIdLogfilesResponse: [], GetV2AppsessionsIdLogfiles: [], PostV2AppsessionsIdLogfilesResponse: [], PostV2AppsessionsIdLogfiles: [], GetV2AppsessionsIdPropertiesResponse: [], GetV2AppsessionsIdProperties: [], PostV2AppsessionsIdPropertiesResponse: [], PostV2AppsessionsIdProperties: [], DeleteV2AppsessionsIdPropertiesNameResponse: [], DeleteV2AppsessionsIdPropertiesName: [], GetV2AppsessionsIdPropertiesNameResponse: [], GetV2AppsessionsIdPropertiesName: [], GetV2AppsessionsIdPropertiesNameItemsResponse: [], GetV2AppsessionsIdPropertiesNameItems: [], PostV2AppsessionsIdRescheduleResponse: [], PostV2AppsessionsIdReschedule: [], PostV2AppsessionsIdStopResponse: [], PostV2AppsessionsIdStop: [], PostV2AppsessionsTrackResponse: [], PostV2AppsessionsTrack: [], PostV2AppsessionsWorkflowsessionsTrackResponse: [], PostV2AppsessionsWorkflowsessionsTrack: [], PostV2ArchiveResponse: [], PostV2Archive: [], GetV2ArchivingstatsResponse: [], GetV2Archivingstats: [], GetV2ArchivingstatsdetailsResponse: [], GetV2Archivingstatsdetails: [], GetV2AutodeletioneventsResponse: [], GetV2Autodeletionevents: [], GetV2AutodeletionpipelineResponse: [], GetV2Autodeletionpipeline: [], GetV2AutodeletionusersResponse: [], GetV2Autodeletionusers: [], GetV2BiosamplesResponse: [], GetV2Biosamples: [], PostV2BiosamplesResponse: [], PostV2Biosamples: [], GetV2BiosamplesBiosampleidLabrequeuesResponse: [], GetV2BiosamplesBiosampleidLabrequeues: [], GetV2BiosamplesIdResponse: [], GetV2BiosamplesId: [], PostV2BiosamplesIdResponse: [], PostV2BiosamplesId: [], GetV2BiosamplesIdAggregatedfastqdatasetsResponse: [], GetV2BiosamplesIdAggregatedfastqdatasets: [], PostV2BiosamplesIdAggregationResponse: [], PostV2BiosamplesIdAggregation: [], GetV2BiosamplesIdLibrariesResponse: [], GetV2BiosamplesIdLibraries: [], PostV2BiosamplesIdLibrariesResponse: [], PostV2BiosamplesIdLibraries: [], GetV2BiosamplesIdPropertiesResponse: [], GetV2BiosamplesIdProperties: [], GetV2BiosamplesIdPropertiesNameResponse: [], GetV2BiosamplesIdPropertiesName: [], GetV2BiosamplesIdPropertiesNameItemsResponse: [], GetV2BiosamplesIdPropertiesNameItems: [], GetV2BiosamplesIdRunlanesummariesResponse: [], GetV2BiosamplesIdRunlanesummaries: [], PostV2BiosamplesBulkupdateResponse: [], PostV2BiosamplesBulkupdate: [], PostV2DatacompressResponse: [], PostV2Datacompress: [], GetV2DatasetsResponse: [], GetV2Datasets: [], PostV2DatasetsResponse: [], PostV2Datasets: [], GetV2DatasetsIdResponse: [], GetV2DatasetsId: [], PostV2DatasetsIdResponse: [], PostV2DatasetsId: [], GetV2DatasetsIdCommentsResponse: [], GetV2DatasetsIdComments: [], PostV2DatasetsIdCopyResponse: [], PostV2DatasetsIdCopy: [], GetV2DatasetsIdDirectUploadInfoResponse: [], GetV2DatasetsIdDirectUploadInfo: [], PostV2DatasetsIdDirectUploadInfoResponse: [], PostV2DatasetsIdDirectUploadInfo: [], GetV2DatasetsIdFilesResponse: [], GetV2DatasetsIdFiles: [], PostV2DatasetsIdFilesResponse: [], PostV2DatasetsIdFiles: [], GetV2DatasetsIdFileUploadInfoResponse: [], GetV2DatasetsIdFileUploadInfo: [], PostV2DatasetsIdFileUploadInfoResponse: [], PostV2DatasetsIdFileUploadInfo: [], GetV2DatasetsIdPropertiesResponse: [], GetV2DatasetsIdProperties: [], GetV2DatasetsIdPropertiesNameResponse: [], GetV2DatasetsIdPropertiesName: [], GetV2DatasetsIdPropertiesNameItemsResponse: [], GetV2DatasetsIdPropertiesNameItems: [], GetV2DatasettypesIdResponse: [], GetV2DatasettypesId: [], GetV2GdssharetransferstatsResponse: [], GetV2Gdssharetransferstats: [], DeleteV2IcauploadsFoldertypeDataidResponse: [], DeleteV2IcauploadsFoldertypeDataid: [], PostV2IcauploadsFoldertypeCompleteUploadResponse: [], PostV2IcauploadsFoldertypeCompleteUpload: [], PostV2IcauploadsFoldertypeDirectUploadInfoResponse: [], PostV2IcauploadsFoldertypeDirectUploadInfo: [], GetV2InstrumentconnectioncheckFileUploadInfoResponse: [], GetV2InstrumentconnectioncheckFileUploadInfo: [], PostV2InstrumentdiagnosticsResponse: [], PostV2Instrumentdiagnostics: [], GetV2InstrumentdiagnosticsIdResponse: [], GetV2InstrumentdiagnosticsId: [], PostV2InstrumentdiagnosticsIdResponse: [], PostV2InstrumentdiagnosticsId: [], GetV2InstrumentsResponse: [], GetV2Instruments: [], PostV2InstrumentsErrorsResponse: [], PostV2InstrumentsErrors: [], GetV2InstrumentstatisticsResponse: [], GetV2Instrumentstatistics: [], GetV2InstrumentstatusResponse: [], GetV2Instrumentstatus: [], GetV2LabrequeuesResponse: [], GetV2Labrequeues: [], GetV2LabrequeuesIdResponse: [], GetV2LabrequeuesId: [], GetV2LaneqcthresholdsResponse: [], GetV2Laneqcthresholds: [], PutV2LaneqcthresholdsResponse: [], PutV2Laneqcthresholds: [], GetV2LanesIdResponse: [], GetV2LanesId: [], PostV2LanesIdResponse: [], PostV2LanesId: [], GetV2LanesIdCommentsResponse: [], GetV2LanesIdComments: [], GetV2LibrariesResponse: [], GetV2Libraries: [], GetV2LibrariesIdPropertiesResponse: [], GetV2LibrariesIdProperties: [], GetV2LibrariesIdPropertiesNameResponse: [], GetV2LibrariesIdPropertiesName: [], GetV2LibrariesIdPropertiesNameItemsResponse: [], GetV2LibrariesIdPropertiesNameItems: [], PostV2LibrariesLibraryidLabrequeuesResponse: [], PostV2LibrariesLibraryidLabrequeues: [], GetV2LibrarypoolsResponse: [], GetV2Librarypools: [], PostV2LibrarypoolsIdResponse: [], PostV2LibrarypoolsId: [], GetV2LibrarypoolsIdLibrariesResponse: [], GetV2LibrarypoolsIdLibraries: [], GetV2LibrarypoolsIdPropertiesResponse: [], GetV2LibrarypoolsIdProperties: [], GetV2LibrarypoolsIdPropertiesNameResponse: [], GetV2LibrarypoolsIdPropertiesName: [], GetV2LibrarypoolsIdPropertiesNameItemsResponse: [], GetV2LibrarypoolsIdPropertiesNameItems: [], PostV2LibrarypoolsPoolidLabrequeuesResponse: [], PostV2LibrarypoolsPoolidLabrequeues: [], DeleteV2NotificationsIdResponse: [], DeleteV2NotificationsId: [], PutV2NotificationsDismissResponse: [], PutV2NotificationsDismiss: [], PostV2Oauthv1Tokenfromoauthv2Response: [], PostV2Oauthv1Tokenfromoauthv2: [], PostV2Oauthv2TokenResponse: [], PostV2Oauthv2Token: [], PostV2Oauthv2TokenfromapplicationjwtResponse: [], PostV2Oauthv2Tokenfromapplicationjwt: [], PostV2Oauthv2tokensUseridResponse: [], PostV2Oauthv2tokensUserid: [], DeleteV2Oauthv2tokensCurrentResponse: [], DeleteV2Oauthv2tokensCurrent: [], PostV2PreprequestsPreprequestidLabrequeuesResponse: [], PostV2PreprequestsPreprequestidLabrequeues: [], PostV2ProjectsResponse: [], PostV2Projects: [], GetV2ProjectsIdResponse: [], GetV2ProjectsId: [], GetV2ProjectsIdDatasetsResponse: [], GetV2ProjectsIdDatasets: [], PostV2ProjectsIdDatasetsResponse: [], PostV2ProjectsIdDatasets: [], GetV2ProjectsIdPropertiesResponse: [], GetV2ProjectsIdProperties: [], GetV2ProjectsIdPropertiesNameResponse: [], GetV2ProjectsIdPropertiesName: [], GetV2ProjectsIdPropertiesNameItemsResponse: [], GetV2ProjectsIdPropertiesNameItems: [], PostV2PublishappsessionstatusResponse: [], PostV2Publishappsessionstatus: [], GetV2ResourcemanifestResponse: [], GetV2Resourcemanifest: [], PostV2RestoreResponse: [], PostV2Restore: [], GetV2RunsResponse: [], GetV2Runs: [], PostV2RunsResponse: [], PostV2Runs: [], GetV2RunsIdResponse: [], GetV2RunsId: [], PostV2RunsIdResponse: [], PostV2RunsId: [], GetV2RunsIdFilesResponse: [], GetV2RunsIdFiles: [], PostV2RunsIdFilesResponse: [], PostV2RunsIdFiles: [], GetV2RunsIdFileUploadInfoResponse: [], GetV2RunsIdFileUploadInfo: [], PostV2RunsIdFileUploadInfoResponse: [], PostV2RunsIdFileUploadInfo: [], GetV2RunsIdPropertiesResponse: [], GetV2RunsIdProperties: [], GetV2RunsIdPropertiesNameResponse: [], GetV2RunsIdPropertiesName: [], GetV2RunsIdPropertiesNameItemsResponse: [], GetV2RunsIdPropertiesNameItems: [], GetV2RunsIdSamplesheetResponse: [], GetV2RunsIdSamplesheet: [], GetV2RunsIdSequencingstatsResponse: [], GetV2RunsIdSequencingstats: [], GetV2RunsAccesscheckResponse: [], GetV2RunsAccesscheck: [], PostV2RunsStartResponse: [], PostV2RunsStart: [], GetV2RunuploadtestResponse: [], GetV2Runuploadtest: [], GetV2SamplesIdFileUploadInfoResponse: [], GetV2SamplesIdFileUploadInfo: [], PostV2SamplesIdFileUploadInfoResponse: [], PostV2SamplesIdFileUploadInfo: [], DeleteV2SessionInvalidateResponse: [], DeleteV2SessionInvalidate: [], GetV2SubjectsIdPropertiesResponse: [], GetV2SubjectsIdProperties: [], GetV2SubjectsIdPropertiesNameResponse: [], GetV2SubjectsIdPropertiesName: [], GetV2SubjectsIdPropertiesNameItemsResponse: [], GetV2SubjectsIdPropertiesNameItems: [], PostV2TokensInstrumentsResponse: [], PostV2TokensInstruments: [], DeleteV2TrashResponse: [], DeleteV2Trash: [], GetV2TrashResponse: [], GetV2Trash: [], GetV2TrashIdResponse: [], GetV2TrashId: [], PostV2TrashIdRestorefromtrashResponse: [], PostV2TrashIdRestorefromtrash: [], PostV2UnzipResponse: [], PostV2Unzip: [], GetV2UseragreementsResponse: [], GetV2Useragreements: [], PostV2UseragreementsResponse: [], PostV2Useragreements: [], GetV2UsersIdResponse: [], GetV2UsersId: [], GetV2UsersIdAutodeletioneventsResponse: [], GetV2UsersIdAutodeletionevents: [], GetV2UsersIdMessagesResponse: [], GetV2UsersIdMessages: [], GetV2UsersIdNotificationsResponse: [], GetV2UsersIdNotifications: [], GetV2UsersIdSettingsResponse: [], GetV2UsersIdSettings: [], PostV2UsersIdSettingsResponse: [], PostV2UsersIdSettings: [], GetV2UsersIdSubscriptionResponse: [], GetV2UsersIdSubscription: [], GetV2UsersIdWorkgroupsResponse: [], GetV2UsersIdWorkgroups: [], PostV2UsersIdV2analysisconfigtemplateResponse: [], PostV2UsersIdV2analysisconfigtemplate: [], PostV2UsersIdV2biosampleregistryResponse: [], PostV2UsersIdV2biosampleregistry: [], GetV2UsersCurrentResponse: [], GetV2UsersCurrent: [], PostV2UsersCurrentResponse: [], PostV2UsersCurrent: [], GetV2UsersCurrentLabtypeResponse: [], GetV2UsersCurrentLabtype: [], GetV2UsersCurrentMessagesResponse: [], GetV2UsersCurrentMessages: [], GetV2UsersCurrentNotificationsResponse: [], GetV2UsersCurrentNotifications: [], GetV2UsersCurrentPropertiesResponse: [], GetV2UsersCurrentProperties: [], GetV2UsersCurrentPropertiesNameResponse: [], GetV2UsersCurrentPropertiesName: [], GetV2UsersCurrentPropertiesNameItemsResponse: [], GetV2UsersCurrentPropertiesNameItems: [], GetV2UsersCurrentSubscriptionResponse: [], GetV2UsersCurrentSubscription: [], GetV2UsersCurrentUsageResponse: [], GetV2UsersCurrentUsage: [], PostV2UsersFilesResponse: [], PostV2UsersFiles: [], PostV2ValidatesignedurlResponse: [], PostV2Validatesignedurl: [], GetV2WorkgroupsIdResponse: [], GetV2WorkgroupsId: [], GetV2V2migrationStatusStepnameResponse: [], GetV2V2migrationStatusStepname: [] });
BasespaceService.GetV2AgreementsPath = '/agreements/';
BasespaceService.GetV2AgreementsIdPath = '/agreements/{id}';
BasespaceService.GetV2ApplicationmetadataPath = '/applicationmetadata';
BasespaceService.GetV2ApplicationsPath = '/applications';
BasespaceService.GetV2ApplicationsIdPath = '/applications/{id}';
BasespaceService.GetV2ApplicationsIdQcthresholdsPath = '/applications/{id}/qcthresholds';
BasespaceService.PutV2ApplicationsIdQcthresholdsPath = '/applications/{id}/qcthresholds';
BasespaceService.GetV2ApplicationsIdScreenshotsPath = '/applications/{id}/screenshots';
BasespaceService.GetV2ApplicationsIdSettingsPath = '/applications/{id}/settings';
BasespaceService.GetV2ApplicationsIdVersionsPath = '/applications/{id}/versions';
BasespaceService.GetV2ApplicationsIdWorkflowdependenciesPath = '/applications/{id}/workflowdependencies';
BasespaceService.PutV2ApplicationsIdWorkflowdependenciesPath = '/applications/{id}/workflowdependencies';
BasespaceService.PostV2ApplicationsIdWorkflowsPath = '/applications/{id}/workflows';
BasespaceService.GetV2AppresultsIdFileUploadInfoPath = '/appresults/{id}/file-upload-info';
BasespaceService.PostV2AppresultsIdFileUploadInfoPath = '/appresults/{id}/file-upload-info';
BasespaceService.GetV2AppsessionsPath = '/appsessions';
BasespaceService.PostV2AppsessionsPath = '/appsessions';
BasespaceService.DeleteV2AppsessionsIdPath = '/appsessions/{id}';
BasespaceService.GetV2AppsessionsIdPath = '/appsessions/{id}';
BasespaceService.PostV2AppsessionsIdPath = '/appsessions/{id}';
BasespaceService.GetV2AppsessionsIdCommentsPath = '/appsessions/{id}/comments';
BasespaceService.GetV2AppsessionsIdLogfilesPath = '/appsessions/{id}/logfiles';
BasespaceService.PostV2AppsessionsIdLogfilesPath = '/appsessions/{id}/logfiles';
BasespaceService.GetV2AppsessionsIdPropertiesPath = '/appsessions/{id}/properties';
BasespaceService.PostV2AppsessionsIdPropertiesPath = '/appsessions/{id}/properties';
BasespaceService.DeleteV2AppsessionsIdPropertiesNamePath = '/appsessions/{id}/properties/{name}';
BasespaceService.GetV2AppsessionsIdPropertiesNamePath = '/appsessions/{id}/properties/{name}';
BasespaceService.GetV2AppsessionsIdPropertiesNameItemsPath = '/appsessions/{id}/properties/{name}/items';
BasespaceService.PostV2AppsessionsIdReschedulePath = '/appsessions/{id}/reschedule';
BasespaceService.PostV2AppsessionsIdStopPath = '/appsessions/{id}/stop';
BasespaceService.PostV2AppsessionsTrackPath = '/appsessions/track';
BasespaceService.PostV2AppsessionsWorkflowsessionsTrackPath = '/appsessions/workflowsessions/track';
BasespaceService.PostV2ArchivePath = '/archive';
BasespaceService.GetV2ArchivingstatsPath = '/archivingstats';
BasespaceService.GetV2ArchivingstatsdetailsPath = '/archivingstatsdetails';
BasespaceService.GetV2AutodeletioneventsPath = '/autodeletionevents';
BasespaceService.GetV2AutodeletionpipelinePath = '/autodeletionpipeline';
BasespaceService.GetV2AutodeletionusersPath = '/autodeletionusers';
BasespaceService.GetV2BiosamplesPath = '/biosamples';
BasespaceService.PostV2BiosamplesPath = '/biosamples';
BasespaceService.GetV2BiosamplesBiosampleidLabrequeuesPath = '/biosamples/{biosampleid}/labrequeues';
BasespaceService.GetV2BiosamplesIdPath = '/biosamples/{id}';
BasespaceService.PostV2BiosamplesIdPath = '/biosamples/{id}';
BasespaceService.GetV2BiosamplesIdAggregatedfastqdatasetsPath = '/biosamples/{id}/aggregatedfastqdatasets';
BasespaceService.PostV2BiosamplesIdAggregationPath = '/biosamples/{id}/aggregation';
BasespaceService.GetV2BiosamplesIdLibrariesPath = '/biosamples/{id}/libraries';
BasespaceService.PostV2BiosamplesIdLibrariesPath = '/biosamples/{id}/libraries';
BasespaceService.GetV2BiosamplesIdPropertiesPath = '/biosamples/{id}/properties';
BasespaceService.GetV2BiosamplesIdPropertiesNamePath = '/biosamples/{id}/properties/{name}';
BasespaceService.GetV2BiosamplesIdPropertiesNameItemsPath = '/biosamples/{id}/properties/{name}/items';
BasespaceService.GetV2BiosamplesIdRunlanesummariesPath = '/biosamples/{id}/runlanesummaries';
BasespaceService.PostV2BiosamplesBulkupdatePath = '/biosamples/bulkupdate';
BasespaceService.PostV2DatacompressPath = '/datacompress';
BasespaceService.GetV2DatasetsPath = '/datasets';
BasespaceService.PostV2DatasetsPath = '/datasets';
BasespaceService.GetV2DatasetsIdPath = '/datasets/{id}';
BasespaceService.PostV2DatasetsIdPath = '/datasets/{id}';
BasespaceService.GetV2DatasetsIdCommentsPath = '/datasets/{id}/comments';
BasespaceService.PostV2DatasetsIdCopyPath = '/datasets/{id}/copy';
BasespaceService.GetV2DatasetsIdDirectUploadInfoPath = '/datasets/{id}/direct-upload-info';
BasespaceService.PostV2DatasetsIdDirectUploadInfoPath = '/datasets/{id}/direct-upload-info';
BasespaceService.GetV2DatasetsIdFilesPath = '/datasets/{id}/files';
BasespaceService.PostV2DatasetsIdFilesPath = '/datasets/{id}/files';
BasespaceService.GetV2DatasetsIdFileUploadInfoPath = '/datasets/{id}/file-upload-info';
BasespaceService.PostV2DatasetsIdFileUploadInfoPath = '/datasets/{id}/file-upload-info';
BasespaceService.GetV2DatasetsIdPropertiesPath = '/datasets/{id}/properties';
BasespaceService.GetV2DatasetsIdPropertiesNamePath = '/datasets/{id}/properties/{name}';
BasespaceService.GetV2DatasetsIdPropertiesNameItemsPath = '/datasets/{id}/properties/{name}/items';
BasespaceService.GetV2DatasettypesIdPath = '/datasettypes/{id}';
BasespaceService.GetV2GdssharetransferstatsPath = '/gdssharetransferstats';
BasespaceService.DeleteV2IcauploadsFoldertypeDataidPath = '/icauploads/{foldertype}/{dataid}';
BasespaceService.PostV2IcauploadsFoldertypeCompleteUploadPath = '/icauploads/{foldertype}/complete-upload';
BasespaceService.PostV2IcauploadsFoldertypeDirectUploadInfoPath = '/icauploads/{foldertype}/direct-upload-info';
BasespaceService.GetV2InstrumentconnectioncheckFileUploadInfoPath = '/instrumentconnectioncheck/file-upload-info';
BasespaceService.PostV2InstrumentdiagnosticsPath = '/instrumentdiagnostics';
BasespaceService.GetV2InstrumentdiagnosticsIdPath = '/instrumentdiagnostics/{id}';
BasespaceService.PostV2InstrumentdiagnosticsIdPath = '/instrumentdiagnostics/{id}';
BasespaceService.GetV2InstrumentsPath = '/instruments';
BasespaceService.PostV2InstrumentsErrorsPath = '/instruments/errors';
BasespaceService.GetV2InstrumentstatisticsPath = '/instrumentstatistics';
BasespaceService.GetV2InstrumentstatusPath = '/instrumentstatus';
BasespaceService.GetV2LabrequeuesPath = '/labrequeues';
BasespaceService.GetV2LabrequeuesIdPath = '/labrequeues/{id}';
BasespaceService.GetV2LaneqcthresholdsPath = '/laneqcthresholds';
BasespaceService.PutV2LaneqcthresholdsPath = '/laneqcthresholds';
BasespaceService.GetV2LanesIdPath = '/lanes/{id}';
BasespaceService.PostV2LanesIdPath = '/lanes/{id}';
BasespaceService.GetV2LanesIdCommentsPath = '/lanes/{id}/comments';
BasespaceService.GetV2LibrariesPath = '/libraries';
BasespaceService.GetV2LibrariesIdPropertiesPath = '/libraries/{id}/properties';
BasespaceService.GetV2LibrariesIdPropertiesNamePath = '/libraries/{id}/properties/{name}';
BasespaceService.GetV2LibrariesIdPropertiesNameItemsPath = '/libraries/{id}/properties/{name}/items';
BasespaceService.PostV2LibrariesLibraryidLabrequeuesPath = '/libraries/{libraryid}/labrequeues';
BasespaceService.GetV2LibrarypoolsPath = '/librarypools';
BasespaceService.PostV2LibrarypoolsIdPath = '/librarypools/{id}';
BasespaceService.GetV2LibrarypoolsIdLibrariesPath = '/librarypools/{id}/libraries';
BasespaceService.GetV2LibrarypoolsIdPropertiesPath = '/librarypools/{id}/properties';
BasespaceService.GetV2LibrarypoolsIdPropertiesNamePath = '/librarypools/{id}/properties/{name}';
BasespaceService.GetV2LibrarypoolsIdPropertiesNameItemsPath = '/librarypools/{id}/properties/{name}/items';
BasespaceService.PostV2LibrarypoolsPoolidLabrequeuesPath = '/librarypools/{poolid}/labrequeues';
BasespaceService.DeleteV2NotificationsIdPath = '/notifications/{id}';
BasespaceService.PutV2NotificationsDismissPath = '/notifications/dismiss';
BasespaceService.PostV2Oauthv1Tokenfromoauthv2Path = '/oauthv1/tokenfromoauthv2';
BasespaceService.PostV2Oauthv2TokenPath = '/oauthv2/token';
BasespaceService.PostV2Oauthv2TokenfromapplicationjwtPath = '/oauthv2/tokenfromapplicationjwt';
BasespaceService.PostV2Oauthv2tokensUseridPath = '/oauthv2tokens/{userid}';
BasespaceService.DeleteV2Oauthv2tokensCurrentPath = '/oauthv2tokens/current';
BasespaceService.PostV2PreprequestsPreprequestidLabrequeuesPath = '/preprequests/{preprequestid}/labrequeues';
BasespaceService.PostV2ProjectsPath = '/projects';
BasespaceService.GetV2ProjectsIdPath = '/projects/{id}';
BasespaceService.GetV2ProjectsIdDatasetsPath = '/projects/{id}/datasets';
BasespaceService.PostV2ProjectsIdDatasetsPath = '/projects/{id}/datasets';
BasespaceService.GetV2ProjectsIdPropertiesPath = '/projects/{id}/properties';
BasespaceService.GetV2ProjectsIdPropertiesNamePath = '/projects/{id}/properties/{name}';
BasespaceService.GetV2ProjectsIdPropertiesNameItemsPath = '/projects/{id}/properties/{name}/items';
BasespaceService.PostV2PublishappsessionstatusPath = '/publishappsessionstatus';
BasespaceService.GetV2ResourcemanifestPath = '/resourcemanifest';
BasespaceService.PostV2RestorePath = '/restore';
BasespaceService.GetV2RunsPath = '/runs';
BasespaceService.PostV2RunsPath = '/runs';
BasespaceService.GetV2RunsIdPath = '/runs/{id}';
BasespaceService.PostV2RunsIdPath = '/runs/{id}';
BasespaceService.GetV2RunsIdFilesPath = '/runs/{id}/files';
BasespaceService.PostV2RunsIdFilesPath = '/runs/{id}/files';
BasespaceService.GetV2RunsIdFileUploadInfoPath = '/runs/{id}/file-upload-info';
BasespaceService.PostV2RunsIdFileUploadInfoPath = '/runs/{id}/file-upload-info';
BasespaceService.GetV2RunsIdPropertiesPath = '/runs/{id}/properties';
BasespaceService.GetV2RunsIdPropertiesNamePath = '/runs/{id}/properties/{name}';
BasespaceService.GetV2RunsIdPropertiesNameItemsPath = '/runs/{id}/properties/{name}/items';
BasespaceService.GetV2RunsIdSamplesheetPath = '/runs/{id}/samplesheet';
BasespaceService.GetV2RunsIdSequencingstatsPath = '/runs/{id}/sequencingstats';
BasespaceService.GetV2RunsAccesscheckPath = '/runs/accesscheck';
BasespaceService.PostV2RunsStartPath = '/runs/start';
BasespaceService.GetV2RunuploadtestPath = '/runuploadtest';
BasespaceService.GetV2SamplesIdFileUploadInfoPath = '/samples/{id}/file-upload-info';
BasespaceService.PostV2SamplesIdFileUploadInfoPath = '/samples/{id}/file-upload-info';
BasespaceService.DeleteV2SessionInvalidatePath = '/session/invalidate';
BasespaceService.GetV2SubjectsIdPropertiesPath = '/subjects/{id}/properties';
BasespaceService.GetV2SubjectsIdPropertiesNamePath = '/subjects/{id}/properties/{name}';
BasespaceService.GetV2SubjectsIdPropertiesNameItemsPath = '/subjects/{id}/properties/{name}/items';
BasespaceService.PostV2TokensInstrumentsPath = '/tokens/instruments';
BasespaceService.DeleteV2TrashPath = '/trash';
BasespaceService.GetV2TrashPath = '/trash';
BasespaceService.GetV2TrashIdPath = '/trash/{id}';
BasespaceService.PostV2TrashIdRestorefromtrashPath = '/trash/{id}/restorefromtrash';
BasespaceService.PostV2UnzipPath = '/unzip';
BasespaceService.GetV2UseragreementsPath = '/useragreements/';
BasespaceService.PostV2UseragreementsPath = '/useragreements/';
BasespaceService.GetV2UsersIdPath = '/users/{id}';
BasespaceService.GetV2UsersIdAutodeletioneventsPath = '/users/{id}/autodeletionevents';
BasespaceService.GetV2UsersIdMessagesPath = '/users/{id}/messages';
BasespaceService.GetV2UsersIdNotificationsPath = '/users/{id}/notifications';
BasespaceService.GetV2UsersIdSettingsPath = '/users/{id}/settings';
BasespaceService.PostV2UsersIdSettingsPath = '/users/{id}/settings';
BasespaceService.GetV2UsersIdSubscriptionPath = '/users/{id}/subscription';
BasespaceService.GetV2UsersIdWorkgroupsPath = '/users/{id}/workgroups';
BasespaceService.PostV2UsersIdV2analysisconfigtemplatePath = '/users/{id}analysisconfigtemplate';
BasespaceService.PostV2UsersIdV2biosampleregistryPath = '/users/{id}biosampleregistry';
BasespaceService.GetV2UsersCurrentPath = '/users/current';
BasespaceService.PostV2UsersCurrentPath = '/users/current';
BasespaceService.GetV2UsersCurrentLabtypePath = '/users/current/labtype';
BasespaceService.GetV2UsersCurrentMessagesPath = '/users/current/messages';
BasespaceService.GetV2UsersCurrentNotificationsPath = '/users/current/notifications';
BasespaceService.GetV2UsersCurrentPropertiesPath = '/users/current/properties';
BasespaceService.GetV2UsersCurrentPropertiesNamePath = '/users/current/properties/{name}';
BasespaceService.GetV2UsersCurrentPropertiesNameItemsPath = '/users/current/properties/{name}/items';
BasespaceService.GetV2UsersCurrentSubscriptionPath = '/users/current/subscription';
BasespaceService.GetV2UsersCurrentUsagePath = '/users/current/usage';
BasespaceService.PostV2UsersFilesPath = '/users/files';
BasespaceService.PostV2ValidatesignedurlPath = '/validatesignedurl';
BasespaceService.GetV2WorkgroupsIdPath = '/workgroups/{id}';
BasespaceService.GetV2V2migrationStatusStepnamePath = 'migration/status/{stepname}';
/** @nocollapse */
BasespaceService.ctorParameters = () => [
    { type: ApiConfiguration },
    { type: HttpClient }
];
/** @nocollapse */ BasespaceService.ngInjectableDef = ɵɵdefineInjectable({ factory: function BasespaceService_Factory() { return new BasespaceService(ɵɵinject(ApiConfiguration), ɵɵinject(HttpClient)); }, token: BasespaceService, providedIn: "root" });
if (false) {
    /** @type {?} */
    BasespaceService.GetV2AgreementsPath;
    /** @type {?} */
    BasespaceService.GetV2AgreementsIdPath;
    /** @type {?} */
    BasespaceService.GetV2ApplicationmetadataPath;
    /** @type {?} */
    BasespaceService.GetV2ApplicationsPath;
    /** @type {?} */
    BasespaceService.GetV2ApplicationsIdPath;
    /** @type {?} */
    BasespaceService.GetV2ApplicationsIdQcthresholdsPath;
    /** @type {?} */
    BasespaceService.PutV2ApplicationsIdQcthresholdsPath;
    /** @type {?} */
    BasespaceService.GetV2ApplicationsIdScreenshotsPath;
    /** @type {?} */
    BasespaceService.GetV2ApplicationsIdSettingsPath;
    /** @type {?} */
    BasespaceService.GetV2ApplicationsIdVersionsPath;
    /** @type {?} */
    BasespaceService.GetV2ApplicationsIdWorkflowdependenciesPath;
    /** @type {?} */
    BasespaceService.PutV2ApplicationsIdWorkflowdependenciesPath;
    /** @type {?} */
    BasespaceService.PostV2ApplicationsIdWorkflowsPath;
    /** @type {?} */
    BasespaceService.GetV2AppresultsIdFileUploadInfoPath;
    /** @type {?} */
    BasespaceService.PostV2AppresultsIdFileUploadInfoPath;
    /** @type {?} */
    BasespaceService.GetV2AppsessionsPath;
    /** @type {?} */
    BasespaceService.PostV2AppsessionsPath;
    /** @type {?} */
    BasespaceService.DeleteV2AppsessionsIdPath;
    /** @type {?} */
    BasespaceService.GetV2AppsessionsIdPath;
    /** @type {?} */
    BasespaceService.PostV2AppsessionsIdPath;
    /** @type {?} */
    BasespaceService.GetV2AppsessionsIdCommentsPath;
    /** @type {?} */
    BasespaceService.GetV2AppsessionsIdLogfilesPath;
    /** @type {?} */
    BasespaceService.PostV2AppsessionsIdLogfilesPath;
    /** @type {?} */
    BasespaceService.GetV2AppsessionsIdPropertiesPath;
    /** @type {?} */
    BasespaceService.PostV2AppsessionsIdPropertiesPath;
    /** @type {?} */
    BasespaceService.DeleteV2AppsessionsIdPropertiesNamePath;
    /** @type {?} */
    BasespaceService.GetV2AppsessionsIdPropertiesNamePath;
    /** @type {?} */
    BasespaceService.GetV2AppsessionsIdPropertiesNameItemsPath;
    /** @type {?} */
    BasespaceService.PostV2AppsessionsIdReschedulePath;
    /** @type {?} */
    BasespaceService.PostV2AppsessionsIdStopPath;
    /** @type {?} */
    BasespaceService.PostV2AppsessionsTrackPath;
    /** @type {?} */
    BasespaceService.PostV2AppsessionsWorkflowsessionsTrackPath;
    /** @type {?} */
    BasespaceService.PostV2ArchivePath;
    /** @type {?} */
    BasespaceService.GetV2ArchivingstatsPath;
    /** @type {?} */
    BasespaceService.GetV2ArchivingstatsdetailsPath;
    /** @type {?} */
    BasespaceService.GetV2AutodeletioneventsPath;
    /** @type {?} */
    BasespaceService.GetV2AutodeletionpipelinePath;
    /** @type {?} */
    BasespaceService.GetV2AutodeletionusersPath;
    /** @type {?} */
    BasespaceService.GetV2BiosamplesPath;
    /** @type {?} */
    BasespaceService.PostV2BiosamplesPath;
    /** @type {?} */
    BasespaceService.GetV2BiosamplesBiosampleidLabrequeuesPath;
    /** @type {?} */
    BasespaceService.GetV2BiosamplesIdPath;
    /** @type {?} */
    BasespaceService.PostV2BiosamplesIdPath;
    /** @type {?} */
    BasespaceService.GetV2BiosamplesIdAggregatedfastqdatasetsPath;
    /** @type {?} */
    BasespaceService.PostV2BiosamplesIdAggregationPath;
    /** @type {?} */
    BasespaceService.GetV2BiosamplesIdLibrariesPath;
    /** @type {?} */
    BasespaceService.PostV2BiosamplesIdLibrariesPath;
    /** @type {?} */
    BasespaceService.GetV2BiosamplesIdPropertiesPath;
    /** @type {?} */
    BasespaceService.GetV2BiosamplesIdPropertiesNamePath;
    /** @type {?} */
    BasespaceService.GetV2BiosamplesIdPropertiesNameItemsPath;
    /** @type {?} */
    BasespaceService.GetV2BiosamplesIdRunlanesummariesPath;
    /** @type {?} */
    BasespaceService.PostV2BiosamplesBulkupdatePath;
    /** @type {?} */
    BasespaceService.PostV2DatacompressPath;
    /** @type {?} */
    BasespaceService.GetV2DatasetsPath;
    /** @type {?} */
    BasespaceService.PostV2DatasetsPath;
    /** @type {?} */
    BasespaceService.GetV2DatasetsIdPath;
    /** @type {?} */
    BasespaceService.PostV2DatasetsIdPath;
    /** @type {?} */
    BasespaceService.GetV2DatasetsIdCommentsPath;
    /** @type {?} */
    BasespaceService.PostV2DatasetsIdCopyPath;
    /** @type {?} */
    BasespaceService.GetV2DatasetsIdDirectUploadInfoPath;
    /** @type {?} */
    BasespaceService.PostV2DatasetsIdDirectUploadInfoPath;
    /** @type {?} */
    BasespaceService.GetV2DatasetsIdFilesPath;
    /** @type {?} */
    BasespaceService.PostV2DatasetsIdFilesPath;
    /** @type {?} */
    BasespaceService.GetV2DatasetsIdFileUploadInfoPath;
    /** @type {?} */
    BasespaceService.PostV2DatasetsIdFileUploadInfoPath;
    /** @type {?} */
    BasespaceService.GetV2DatasetsIdPropertiesPath;
    /** @type {?} */
    BasespaceService.GetV2DatasetsIdPropertiesNamePath;
    /** @type {?} */
    BasespaceService.GetV2DatasetsIdPropertiesNameItemsPath;
    /** @type {?} */
    BasespaceService.GetV2DatasettypesIdPath;
    /** @type {?} */
    BasespaceService.GetV2GdssharetransferstatsPath;
    /** @type {?} */
    BasespaceService.DeleteV2IcauploadsFoldertypeDataidPath;
    /** @type {?} */
    BasespaceService.PostV2IcauploadsFoldertypeCompleteUploadPath;
    /** @type {?} */
    BasespaceService.PostV2IcauploadsFoldertypeDirectUploadInfoPath;
    /** @type {?} */
    BasespaceService.GetV2InstrumentconnectioncheckFileUploadInfoPath;
    /** @type {?} */
    BasespaceService.PostV2InstrumentdiagnosticsPath;
    /** @type {?} */
    BasespaceService.GetV2InstrumentdiagnosticsIdPath;
    /** @type {?} */
    BasespaceService.PostV2InstrumentdiagnosticsIdPath;
    /** @type {?} */
    BasespaceService.GetV2InstrumentsPath;
    /** @type {?} */
    BasespaceService.PostV2InstrumentsErrorsPath;
    /** @type {?} */
    BasespaceService.GetV2InstrumentstatisticsPath;
    /** @type {?} */
    BasespaceService.GetV2InstrumentstatusPath;
    /** @type {?} */
    BasespaceService.GetV2LabrequeuesPath;
    /** @type {?} */
    BasespaceService.GetV2LabrequeuesIdPath;
    /** @type {?} */
    BasespaceService.GetV2LaneqcthresholdsPath;
    /** @type {?} */
    BasespaceService.PutV2LaneqcthresholdsPath;
    /** @type {?} */
    BasespaceService.GetV2LanesIdPath;
    /** @type {?} */
    BasespaceService.PostV2LanesIdPath;
    /** @type {?} */
    BasespaceService.GetV2LanesIdCommentsPath;
    /** @type {?} */
    BasespaceService.GetV2LibrariesPath;
    /** @type {?} */
    BasespaceService.GetV2LibrariesIdPropertiesPath;
    /** @type {?} */
    BasespaceService.GetV2LibrariesIdPropertiesNamePath;
    /** @type {?} */
    BasespaceService.GetV2LibrariesIdPropertiesNameItemsPath;
    /** @type {?} */
    BasespaceService.PostV2LibrariesLibraryidLabrequeuesPath;
    /** @type {?} */
    BasespaceService.GetV2LibrarypoolsPath;
    /** @type {?} */
    BasespaceService.PostV2LibrarypoolsIdPath;
    /** @type {?} */
    BasespaceService.GetV2LibrarypoolsIdLibrariesPath;
    /** @type {?} */
    BasespaceService.GetV2LibrarypoolsIdPropertiesPath;
    /** @type {?} */
    BasespaceService.GetV2LibrarypoolsIdPropertiesNamePath;
    /** @type {?} */
    BasespaceService.GetV2LibrarypoolsIdPropertiesNameItemsPath;
    /** @type {?} */
    BasespaceService.PostV2LibrarypoolsPoolidLabrequeuesPath;
    /** @type {?} */
    BasespaceService.DeleteV2NotificationsIdPath;
    /** @type {?} */
    BasespaceService.PutV2NotificationsDismissPath;
    /** @type {?} */
    BasespaceService.PostV2Oauthv1Tokenfromoauthv2Path;
    /** @type {?} */
    BasespaceService.PostV2Oauthv2TokenPath;
    /** @type {?} */
    BasespaceService.PostV2Oauthv2TokenfromapplicationjwtPath;
    /** @type {?} */
    BasespaceService.PostV2Oauthv2tokensUseridPath;
    /** @type {?} */
    BasespaceService.DeleteV2Oauthv2tokensCurrentPath;
    /** @type {?} */
    BasespaceService.PostV2PreprequestsPreprequestidLabrequeuesPath;
    /** @type {?} */
    BasespaceService.PostV2ProjectsPath;
    /** @type {?} */
    BasespaceService.GetV2ProjectsIdPath;
    /** @type {?} */
    BasespaceService.GetV2ProjectsIdDatasetsPath;
    /** @type {?} */
    BasespaceService.PostV2ProjectsIdDatasetsPath;
    /** @type {?} */
    BasespaceService.GetV2ProjectsIdPropertiesPath;
    /** @type {?} */
    BasespaceService.GetV2ProjectsIdPropertiesNamePath;
    /** @type {?} */
    BasespaceService.GetV2ProjectsIdPropertiesNameItemsPath;
    /** @type {?} */
    BasespaceService.PostV2PublishappsessionstatusPath;
    /** @type {?} */
    BasespaceService.GetV2ResourcemanifestPath;
    /** @type {?} */
    BasespaceService.PostV2RestorePath;
    /** @type {?} */
    BasespaceService.GetV2RunsPath;
    /** @type {?} */
    BasespaceService.PostV2RunsPath;
    /** @type {?} */
    BasespaceService.GetV2RunsIdPath;
    /** @type {?} */
    BasespaceService.PostV2RunsIdPath;
    /** @type {?} */
    BasespaceService.GetV2RunsIdFilesPath;
    /** @type {?} */
    BasespaceService.PostV2RunsIdFilesPath;
    /** @type {?} */
    BasespaceService.GetV2RunsIdFileUploadInfoPath;
    /** @type {?} */
    BasespaceService.PostV2RunsIdFileUploadInfoPath;
    /** @type {?} */
    BasespaceService.GetV2RunsIdPropertiesPath;
    /** @type {?} */
    BasespaceService.GetV2RunsIdPropertiesNamePath;
    /** @type {?} */
    BasespaceService.GetV2RunsIdPropertiesNameItemsPath;
    /** @type {?} */
    BasespaceService.GetV2RunsIdSamplesheetPath;
    /** @type {?} */
    BasespaceService.GetV2RunsIdSequencingstatsPath;
    /** @type {?} */
    BasespaceService.GetV2RunsAccesscheckPath;
    /** @type {?} */
    BasespaceService.PostV2RunsStartPath;
    /** @type {?} */
    BasespaceService.GetV2RunuploadtestPath;
    /** @type {?} */
    BasespaceService.GetV2SamplesIdFileUploadInfoPath;
    /** @type {?} */
    BasespaceService.PostV2SamplesIdFileUploadInfoPath;
    /** @type {?} */
    BasespaceService.DeleteV2SessionInvalidatePath;
    /** @type {?} */
    BasespaceService.GetV2SubjectsIdPropertiesPath;
    /** @type {?} */
    BasespaceService.GetV2SubjectsIdPropertiesNamePath;
    /** @type {?} */
    BasespaceService.GetV2SubjectsIdPropertiesNameItemsPath;
    /** @type {?} */
    BasespaceService.PostV2TokensInstrumentsPath;
    /** @type {?} */
    BasespaceService.DeleteV2TrashPath;
    /** @type {?} */
    BasespaceService.GetV2TrashPath;
    /** @type {?} */
    BasespaceService.GetV2TrashIdPath;
    /** @type {?} */
    BasespaceService.PostV2TrashIdRestorefromtrashPath;
    /** @type {?} */
    BasespaceService.PostV2UnzipPath;
    /** @type {?} */
    BasespaceService.GetV2UseragreementsPath;
    /** @type {?} */
    BasespaceService.PostV2UseragreementsPath;
    /** @type {?} */
    BasespaceService.GetV2UsersIdPath;
    /** @type {?} */
    BasespaceService.GetV2UsersIdAutodeletioneventsPath;
    /** @type {?} */
    BasespaceService.GetV2UsersIdMessagesPath;
    /** @type {?} */
    BasespaceService.GetV2UsersIdNotificationsPath;
    /** @type {?} */
    BasespaceService.GetV2UsersIdSettingsPath;
    /** @type {?} */
    BasespaceService.PostV2UsersIdSettingsPath;
    /** @type {?} */
    BasespaceService.GetV2UsersIdSubscriptionPath;
    /** @type {?} */
    BasespaceService.GetV2UsersIdWorkgroupsPath;
    /** @type {?} */
    BasespaceService.PostV2UsersIdV2analysisconfigtemplatePath;
    /** @type {?} */
    BasespaceService.PostV2UsersIdV2biosampleregistryPath;
    /** @type {?} */
    BasespaceService.GetV2UsersCurrentPath;
    /** @type {?} */
    BasespaceService.PostV2UsersCurrentPath;
    /** @type {?} */
    BasespaceService.GetV2UsersCurrentLabtypePath;
    /** @type {?} */
    BasespaceService.GetV2UsersCurrentMessagesPath;
    /** @type {?} */
    BasespaceService.GetV2UsersCurrentNotificationsPath;
    /** @type {?} */
    BasespaceService.GetV2UsersCurrentPropertiesPath;
    /** @type {?} */
    BasespaceService.GetV2UsersCurrentPropertiesNamePath;
    /** @type {?} */
    BasespaceService.GetV2UsersCurrentPropertiesNameItemsPath;
    /** @type {?} */
    BasespaceService.GetV2UsersCurrentSubscriptionPath;
    /** @type {?} */
    BasespaceService.GetV2UsersCurrentUsagePath;
    /** @type {?} */
    BasespaceService.PostV2UsersFilesPath;
    /** @type {?} */
    BasespaceService.PostV2ValidatesignedurlPath;
    /** @type {?} */
    BasespaceService.GetV2WorkgroupsIdPath;
    /** @type {?} */
    BasespaceService.GetV2V2migrationStatusStepnamePath;
}
(function (BasespaceService) {
    /**
     * Parameters for GetV2Agreements
     * @record
     */
    function GetV2AgreementsParams() { }
    BasespaceService.GetV2AgreementsParams = GetV2AgreementsParams;
    if (false) {
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2AgreementsParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2AgreementsParams.prototype.sortby;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2AgreementsParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2AgreementsParams.prototype.limit;
        /**
         * The Id of the resource
         * @type {?|undefined}
         */
        GetV2AgreementsParams.prototype.id;
        /**
         * Required, only agreements with category exactly matching the specified value will be returned.
         * @type {?|undefined}
         */
        GetV2AgreementsParams.prototype.category;
    }
    /**
     * Parameters for GetV2Applications
     * @record
     */
    function GetV2ApplicationsParams() { }
    BasespaceService.GetV2ApplicationsParams = GetV2ApplicationsParams;
    if (false) {
        /**
         * Returns only applications where there is a CWL form enabled.
         * @type {?}
         */
        GetV2ApplicationsParams.prototype.cwlactive;
        /**
         * Returns only applications that can be auto-launched after a run completes
         * @type {?}
         */
        GetV2ApplicationsParams.prototype.autolaunchableonruncompleteappsonly;
        /**
         * Return all the applications versions
         * @type {?}
         */
        GetV2ApplicationsParams.prototype.allversions;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2ApplicationsParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2ApplicationsParams.prototype.sortby;
        /**
         * Returns all analysis workflows that a user has access to that were created from a particular app, denoted by its unique slug ID
         * @type {?|undefined}
         */
        GetV2ApplicationsParams.prototype.references;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2ApplicationsParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2ApplicationsParams.prototype.limit;
        /**
         * The Id of the resource
         * @type {?|undefined}
         */
        GetV2ApplicationsParams.prototype.id;
        /**
         * Return all apps that belong to a specific category that a user has access to (examples include: Native, Workflow, Other). Only a single category can be specified in a given call
         * @type {?|undefined}
         */
        GetV2ApplicationsParams.prototype.category;
    }
    /**
     * Parameters for GetV2ApplicationsId
     * @record
     */
    function GetV2ApplicationsIdParams() { }
    BasespaceService.GetV2ApplicationsIdParams = GetV2ApplicationsIdParams;
    if (false) {
        /** @type {?} */
        GetV2ApplicationsIdParams.prototype.id;
        /**
         * Returns only the specified number of property items per property for the application
         * @type {?|undefined}
         */
        GetV2ApplicationsIdParams.prototype.propertyitemslimit;
        /**
         * Returns only the specified number of properties for the application.
         * @type {?|undefined}
         */
        GetV2ApplicationsIdParams.prototype.propertieslimit;
    }
    /**
     * Parameters for PutV2ApplicationsIdQcthresholds
     * @record
     */
    function PutV2ApplicationsIdQcthresholdsParams() { }
    BasespaceService.PutV2ApplicationsIdQcthresholdsParams = PutV2ApplicationsIdQcthresholdsParams;
    if (false) {
        /**
         * The Id of the resource
         * @type {?}
         */
        PutV2ApplicationsIdQcthresholdsParams.prototype.id;
        /** @type {?|undefined} */
        PutV2ApplicationsIdQcthresholdsParams.prototype.qcthresholds;
    }
    /**
     * Parameters for GetV2ApplicationsIdScreenshots
     * @record
     */
    function GetV2ApplicationsIdScreenshotsParams() { }
    BasespaceService.GetV2ApplicationsIdScreenshotsParams = GetV2ApplicationsIdScreenshotsParams;
    if (false) {
        /**
         * The Id of the resource
         * @type {?}
         */
        GetV2ApplicationsIdScreenshotsParams.prototype.id;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2ApplicationsIdScreenshotsParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2ApplicationsIdScreenshotsParams.prototype.sortby;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2ApplicationsIdScreenshotsParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2ApplicationsIdScreenshotsParams.prototype.limit;
    }
    /**
     * Parameters for GetV2ApplicationsIdVersions
     * @record
     */
    function GetV2ApplicationsIdVersionsParams() { }
    BasespaceService.GetV2ApplicationsIdVersionsParams = GetV2ApplicationsIdVersionsParams;
    if (false) {
        /**
         * The Id of the resource
         * @type {?}
         */
        GetV2ApplicationsIdVersionsParams.prototype.id;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2ApplicationsIdVersionsParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2ApplicationsIdVersionsParams.prototype.sortby;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2ApplicationsIdVersionsParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2ApplicationsIdVersionsParams.prototype.limit;
    }
    /**
     * Parameters for PutV2ApplicationsIdWorkflowdependencies
     * @record
     */
    function PutV2ApplicationsIdWorkflowdependenciesParams() { }
    BasespaceService.PutV2ApplicationsIdWorkflowdependenciesParams = PutV2ApplicationsIdWorkflowdependenciesParams;
    if (false) {
        /**
         * The Id of the resource
         * @type {?}
         */
        PutV2ApplicationsIdWorkflowdependenciesParams.prototype.id;
        /** @type {?|undefined} */
        PutV2ApplicationsIdWorkflowdependenciesParams.prototype.version;
        /** @type {?|undefined} */
        PutV2ApplicationsIdWorkflowdependenciesParams.prototype.dependencies;
    }
    /**
     * Parameters for PostV2ApplicationsIdWorkflows
     * @record
     */
    function PostV2ApplicationsIdWorkflowsParams() { }
    BasespaceService.PostV2ApplicationsIdWorkflowsParams = PostV2ApplicationsIdWorkflowsParams;
    if (false) {
        /**
         * Applicaiton Id
         * @type {?}
         */
        PostV2ApplicationsIdWorkflowsParams.prototype.id;
        /** @type {?|undefined} */
        PostV2ApplicationsIdWorkflowsParams.prototype.payload;
    }
    /**
     * Parameters for GetV2AppresultsIdFileUploadInfo
     * @record
     */
    function GetV2AppresultsIdFileUploadInfoParams() { }
    BasespaceService.GetV2AppresultsIdFileUploadInfoParams = GetV2AppresultsIdFileUploadInfoParams;
    if (false) {
        /**
         * The Id of the resource
         * @type {?}
         */
        GetV2AppresultsIdFileUploadInfoParams.prototype.id;
        /** @type {?|undefined} */
        GetV2AppresultsIdFileUploadInfoParams.prototype.uploadpartcount;
        /** @type {?|undefined} */
        GetV2AppresultsIdFileUploadInfoParams.prototype.filepath;
    }
    /**
     * Parameters for PostV2AppresultsIdFileUploadInfo
     * @record
     */
    function PostV2AppresultsIdFileUploadInfoParams() { }
    BasespaceService.PostV2AppresultsIdFileUploadInfoParams = PostV2AppresultsIdFileUploadInfoParams;
    if (false) {
        /**
         * The Id of the resource
         * @type {?}
         */
        PostV2AppresultsIdFileUploadInfoParams.prototype.id;
        /** @type {?|undefined} */
        PostV2AppresultsIdFileUploadInfoParams.prototype.payload;
    }
    /**
     * Parameters for GetV2Appsessions
     * @record
     */
    function GetV2AppsessionsParams() { }
    BasespaceService.GetV2AppsessionsParams = GetV2AppsessionsParams;
    if (false) {
        /**
         * ID of user who created appsession
         * @type {?|undefined}
         */
        GetV2AppsessionsParams.prototype.usercreatedby;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2AppsessionsParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2AppsessionsParams.prototype.sortby;
        /**
         * Filter by QC status
         * @type {?|undefined}
         */
        GetV2AppsessionsParams.prototype.qcstatus;
        /**
         * Filter by appsessions include the specified property names
         * @type {?|undefined}
         */
        GetV2AppsessionsParams.prototype.propertyfilters;
        /**
         * Only include appsessions where the project has WRITE permission by the current user
         * @type {?|undefined}
         */
        GetV2AppsessionsParams.prototype.ownedbycurrentuser;
        /**
         * Filter by ID of output project
         * @type {?|undefined}
         */
        GetV2AppsessionsParams.prototype.outputProjects;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2AppsessionsParams.prototype.offset;
        /** @type {?|undefined} */
        GetV2AppsessionsParams.prototype.name;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2AppsessionsParams.prototype.limit;
        /**
         * Filter by ID of run input
         * @type {?|undefined}
         */
        GetV2AppsessionsParams.prototype.inputRuns;
        /**
         * Filter by ID of biosample input
         * @type {?|undefined}
         */
        GetV2AppsessionsParams.prototype.inputBiosamples;
        /**
         * Additional resources to include
         * @type {?|undefined}
         */
        GetV2AppsessionsParams.prototype.include;
        /**
         * Filter by execution status
         * @type {?|undefined}
         */
        GetV2AppsessionsParams.prototype.executionstatus;
        /**
         * Filter by delivery status
         * @type {?|undefined}
         */
        GetV2AppsessionsParams.prototype.deliverystatus;
        /** @type {?|undefined} */
        GetV2AppsessionsParams.prototype.datemodified;
        /**
         * Filter by application family
         * @type {?|undefined}
         */
        GetV2AppsessionsParams.prototype.applicationfamilyslugs;
        /**
         * Filter by ID of application used
         * @type {?|undefined}
         */
        GetV2AppsessionsParams.prototype.appid;
    }
    /**
     * Parameters for DeleteV2AppsessionsId
     * @record
     */
    function DeleteV2AppsessionsIdParams() { }
    BasespaceService.DeleteV2AppsessionsIdParams = DeleteV2AppsessionsIdParams;
    if (false) {
        /**
         * Appsession ID
         * @type {?}
         */
        DeleteV2AppsessionsIdParams.prototype.id;
        /**
         * Preserve "Metadata", to keep records, but not files, of an appsession
         * @type {?|undefined}
         */
        DeleteV2AppsessionsIdParams.prototype.preserve;
        /**
         * Select true to go straight to deletion
         * @type {?|undefined}
         */
        DeleteV2AppsessionsIdParams.prototype.bypasstrash;
    }
    /**
     * Parameters for GetV2AppsessionsId
     * @record
     */
    function GetV2AppsessionsIdParams() { }
    BasespaceService.GetV2AppsessionsIdParams = GetV2AppsessionsIdParams;
    if (false) {
        /**
         * Appsession ID
         * @type {?}
         */
        GetV2AppsessionsIdParams.prototype.id;
        /**
         * ShowHiddenItems
         * @type {?|undefined}
         */
        GetV2AppsessionsIdParams.prototype.showhiddenitems;
        /**
         * Additional resources to include
         * @type {?|undefined}
         */
        GetV2AppsessionsIdParams.prototype.include;
    }
    /**
     * Parameters for PostV2AppsessionsId
     * @record
     */
    function PostV2AppsessionsIdParams() { }
    BasespaceService.PostV2AppsessionsIdParams = PostV2AppsessionsIdParams;
    if (false) {
        /**
         * Appsession ID
         * @type {?}
         */
        PostV2AppsessionsIdParams.prototype.id;
        /** @type {?|undefined} */
        PostV2AppsessionsIdParams.prototype.payload;
    }
    /**
     * Parameters for GetV2AppsessionsIdComments
     * @record
     */
    function GetV2AppsessionsIdCommentsParams() { }
    BasespaceService.GetV2AppsessionsIdCommentsParams = GetV2AppsessionsIdCommentsParams;
    if (false) {
        /**
         * Appsession ID
         * @type {?}
         */
        GetV2AppsessionsIdCommentsParams.prototype.id;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2AppsessionsIdCommentsParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2AppsessionsIdCommentsParams.prototype.sortby;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2AppsessionsIdCommentsParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2AppsessionsIdCommentsParams.prototype.limit;
    }
    /**
     * Parameters for GetV2AppsessionsIdLogfiles
     * @record
     */
    function GetV2AppsessionsIdLogfilesParams() { }
    BasespaceService.GetV2AppsessionsIdLogfilesParams = GetV2AppsessionsIdLogfilesParams;
    if (false) {
        /** @type {?} */
        GetV2AppsessionsIdLogfilesParams.prototype.turbomode;
        /**
         * Appsession ID
         * @type {?}
         */
        GetV2AppsessionsIdLogfilesParams.prototype.id;
        /**
         * Resolves the HrefContent to the direct file URI to avoid a hop to GET: files/{id}/content
         * @type {?}
         */
        GetV2AppsessionsIdLogfilesParams.prototype.filehrefcontentresolution;
        /**
         * Whether to exclude VCF index folders
         * @type {?}
         */
        GetV2AppsessionsIdLogfilesParams.prototype.excludevcfindexfolder;
        /**
         * Whether to exclude system folders
         * @type {?}
         */
        GetV2AppsessionsIdLogfilesParams.prototype.excludesystemfolder;
        /**
         * Whether to exclude empty files
         * @type {?}
         */
        GetV2AppsessionsIdLogfilesParams.prototype.excludeemptyfiles;
        /**
         * Whether to exclude BAM coverage folders
         * @type {?}
         */
        GetV2AppsessionsIdLogfilesParams.prototype.excludebamcoveragefolder;
        /**
         * Optionally filter by status (default complete)
         * @type {?|undefined}
         */
        GetV2AppsessionsIdLogfilesParams.prototype.statuses;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2AppsessionsIdLogfilesParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2AppsessionsIdLogfilesParams.prototype.sortby;
        /**
         * To be pre-fixed in the path of the file
         * @type {?|undefined}
         */
        GetV2AppsessionsIdLogfilesParams.prototype.pathprefix;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2AppsessionsIdLogfilesParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2AppsessionsIdLogfilesParams.prototype.limit;
        /**
         * Whether to return subdirectories
         * @type {?|undefined}
         */
        GetV2AppsessionsIdLogfilesParams.prototype.includesubdirectories;
        /** @type {?|undefined} */
        GetV2AppsessionsIdLogfilesParams.prototype.filesetid;
        /**
         * Filter by file extension
         * @type {?|undefined}
         */
        GetV2AppsessionsIdLogfilesParams.prototype.extensions;
        /**
         * Exclude by file extension
         * @type {?|undefined}
         */
        GetV2AppsessionsIdLogfilesParams.prototype.excludeextensions;
        /**
         * Filter by directory path (root is /)
         * @type {?|undefined}
         */
        GetV2AppsessionsIdLogfilesParams.prototype.directory;
    }
    /**
     * Parameters for PostV2AppsessionsIdLogfiles
     * @record
     */
    function PostV2AppsessionsIdLogfilesParams() { }
    BasespaceService.PostV2AppsessionsIdLogfilesParams = PostV2AppsessionsIdLogfilesParams;
    if (false) {
        /**
         * Appsession ID
         * @type {?}
         */
        PostV2AppsessionsIdLogfilesParams.prototype.id;
        /** @type {?|undefined} */
        PostV2AppsessionsIdLogfilesParams.prototype.payload;
    }
    /**
     * Parameters for GetV2AppsessionsIdProperties
     * @record
     */
    function GetV2AppsessionsIdPropertiesParams() { }
    BasespaceService.GetV2AppsessionsIdPropertiesParams = GetV2AppsessionsIdPropertiesParams;
    if (false) {
        /**
         * Appsession ID
         * @type {?}
         */
        GetV2AppsessionsIdPropertiesParams.prototype.id;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2AppsessionsIdPropertiesParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2AppsessionsIdPropertiesParams.prototype.sortby;
        /**
         * Show Hidden projects and Datasets
         * @type {?|undefined}
         */
        GetV2AppsessionsIdPropertiesParams.prototype.showhiddenitems;
        /**
         * Limit the # of property items returned per property
         * @type {?|undefined}
         */
        GetV2AppsessionsIdPropertiesParams.prototype.propertyitemslimit;
        /**
         * Filter by property name
         * @type {?|undefined}
         */
        GetV2AppsessionsIdPropertiesParams.prototype.propertyfilters;
        /**
         * Limit the # of properties returned
         * @type {?|undefined}
         */
        GetV2AppsessionsIdPropertiesParams.prototype.propertieslimit;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2AppsessionsIdPropertiesParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2AppsessionsIdPropertiesParams.prototype.limit;
    }
    /**
     * Parameters for PostV2AppsessionsIdProperties
     * @record
     */
    function PostV2AppsessionsIdPropertiesParams() { }
    BasespaceService.PostV2AppsessionsIdPropertiesParams = PostV2AppsessionsIdPropertiesParams;
    if (false) {
        /**
         * Appsession ID
         * @type {?}
         */
        PostV2AppsessionsIdPropertiesParams.prototype.id;
        /** @type {?|undefined} */
        PostV2AppsessionsIdPropertiesParams.prototype.payload;
    }
    /**
     * Parameters for DeleteV2AppsessionsIdPropertiesName
     * @record
     */
    function DeleteV2AppsessionsIdPropertiesNameParams() { }
    BasespaceService.DeleteV2AppsessionsIdPropertiesNameParams = DeleteV2AppsessionsIdPropertiesNameParams;
    if (false) {
        /**
         * Property name
         * @type {?}
         */
        DeleteV2AppsessionsIdPropertiesNameParams.prototype.name;
        /**
         * Appsession ID
         * @type {?}
         */
        DeleteV2AppsessionsIdPropertiesNameParams.prototype.id;
    }
    /**
     * Parameters for GetV2AppsessionsIdPropertiesName
     * @record
     */
    function GetV2AppsessionsIdPropertiesNameParams() { }
    BasespaceService.GetV2AppsessionsIdPropertiesNameParams = GetV2AppsessionsIdPropertiesNameParams;
    if (false) {
        /**
         * Property name
         * @type {?}
         */
        GetV2AppsessionsIdPropertiesNameParams.prototype.name;
        /**
         * Appsession ID
         * @type {?}
         */
        GetV2AppsessionsIdPropertiesNameParams.prototype.id;
        /**
         * Hidden filter
         * @type {?|undefined}
         */
        GetV2AppsessionsIdPropertiesNameParams.prototype.showhiddenitems;
        /**
         * Limit the # of property items returned per property
         * @type {?|undefined}
         */
        GetV2AppsessionsIdPropertiesNameParams.prototype.propertyitemslimit;
    }
    /**
     * Parameters for GetV2AppsessionsIdPropertiesNameItems
     * @record
     */
    function GetV2AppsessionsIdPropertiesNameItemsParams() { }
    BasespaceService.GetV2AppsessionsIdPropertiesNameItemsParams = GetV2AppsessionsIdPropertiesNameItemsParams;
    if (false) {
        /**
         * Property name
         * @type {?}
         */
        GetV2AppsessionsIdPropertiesNameItemsParams.prototype.name;
        /**
         * Appsession ID
         * @type {?}
         */
        GetV2AppsessionsIdPropertiesNameItemsParams.prototype.id;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2AppsessionsIdPropertiesNameItemsParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2AppsessionsIdPropertiesNameItemsParams.prototype.sortby;
        /**
         * Hidden filter
         * @type {?|undefined}
         */
        GetV2AppsessionsIdPropertiesNameItemsParams.prototype.showhiddenitems;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2AppsessionsIdPropertiesNameItemsParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2AppsessionsIdPropertiesNameItemsParams.prototype.limit;
    }
    /**
     * Parameters for PostV2AppsessionsIdReschedule
     * @record
     */
    function PostV2AppsessionsIdRescheduleParams() { }
    BasespaceService.PostV2AppsessionsIdRescheduleParams = PostV2AppsessionsIdRescheduleParams;
    if (false) {
        /** @type {?} */
        PostV2AppsessionsIdRescheduleParams.prototype.id;
        /** @type {?|undefined} */
        PostV2AppsessionsIdRescheduleParams.prototype.payload;
    }
    /**
     * Parameters for PostV2AppsessionsIdStop
     * @record
     */
    function PostV2AppsessionsIdStopParams() { }
    BasespaceService.PostV2AppsessionsIdStopParams = PostV2AppsessionsIdStopParams;
    if (false) {
        /**
         * Appsession ID
         * @type {?}
         */
        PostV2AppsessionsIdStopParams.prototype.id;
        /** @type {?|undefined} */
        PostV2AppsessionsIdStopParams.prototype.payload;
    }
    /**
     * Parameters for GetV2Archivingstatsdetails
     * @record
     */
    function GetV2ArchivingstatsdetailsParams() { }
    BasespaceService.GetV2ArchivingstatsdetailsParams = GetV2ArchivingstatsdetailsParams;
    if (false) {
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2ArchivingstatsdetailsParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2ArchivingstatsdetailsParams.prototype.sortby;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2ArchivingstatsdetailsParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2ArchivingstatsdetailsParams.prototype.limit;
        /**
         * The Id of the resource
         * @type {?|undefined}
         */
        GetV2ArchivingstatsdetailsParams.prototype.id;
    }
    /**
     * Parameters for GetV2Autodeletionevents
     * @record
     */
    function GetV2AutodeletioneventsParams() { }
    BasespaceService.GetV2AutodeletioneventsParams = GetV2AutodeletioneventsParams;
    if (false) {
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2AutodeletioneventsParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2AutodeletioneventsParams.prototype.sortby;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2AutodeletioneventsParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2AutodeletioneventsParams.prototype.limit;
        /**
         * The Id of the resource
         * @type {?|undefined}
         */
        GetV2AutodeletioneventsParams.prototype.id;
    }
    /**
     * Parameters for GetV2Autodeletionpipeline
     * @record
     */
    function GetV2AutodeletionpipelineParams() { }
    BasespaceService.GetV2AutodeletionpipelineParams = GetV2AutodeletionpipelineParams;
    if (false) {
        /** @type {?} */
        GetV2AutodeletionpipelineParams.prototype.format;
        /** @type {?|undefined} */
        GetV2AutodeletionpipelineParams.prototype.emailtemplatename;
    }
    /**
     * Parameters for GetV2Autodeletionusers
     * @record
     */
    function GetV2AutodeletionusersParams() { }
    BasespaceService.GetV2AutodeletionusersParams = GetV2AutodeletionusersParams;
    if (false) {
        /** @type {?} */
        GetV2AutodeletionusersParams.prototype.sent;
        /** @type {?} */
        GetV2AutodeletionusersParams.prototype.illuminausers;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2AutodeletionusersParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2AutodeletionusersParams.prototype.sortby;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2AutodeletionusersParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2AutodeletionusersParams.prototype.limit;
        /**
         * The Id of the resource
         * @type {?|undefined}
         */
        GetV2AutodeletionusersParams.prototype.id;
        /** @type {?|undefined} */
        GetV2AutodeletionusersParams.prototype.emailtemplatename;
    }
    /**
     * Parameters for GetV2Biosamples
     * @record
     */
    function GetV2BiosamplesParams() { }
    BasespaceService.GetV2BiosamplesParams = GetV2BiosamplesParams;
    if (false) {
        /**
         * Only return biosamples with the given Status(es)
         * @type {?|undefined}
         */
        GetV2BiosamplesParams.prototype.status;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2BiosamplesParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2BiosamplesParams.prototype.sortby;
        /** @type {?|undefined} */
        GetV2BiosamplesParams.prototype.propertynamestartswith;
        /**
         * Only return biosamples with the specified default projects or datasets in those projects
         * @type {?|undefined}
         */
        GetV2BiosamplesParams.prototype.projectid;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2BiosamplesParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2BiosamplesParams.prototype.limit;
        /**
         * Only return biosamples with the given LabStatus(es)
         * @type {?|undefined}
         */
        GetV2BiosamplesParams.prototype.labstatus;
        /**
         * Sub elements to include in the response
         * @type {?|undefined}
         */
        GetV2BiosamplesParams.prototype.include;
        /**
         * Only return biosamples with the given BioSampleName(s)
         * @type {?|undefined}
         */
        GetV2BiosamplesParams.prototype.biosamplename;
    }
    /**
     * Parameters for GetV2BiosamplesBiosampleidLabrequeues
     * @record
     */
    function GetV2BiosamplesBiosampleidLabrequeuesParams() { }
    BasespaceService.GetV2BiosamplesBiosampleidLabrequeuesParams = GetV2BiosamplesBiosampleidLabrequeuesParams;
    if (false) {
        /**
         * Biosample ID
         * @type {?}
         */
        GetV2BiosamplesBiosampleidLabrequeuesParams.prototype.biosampleid;
        /**
         * Specify which type of lab requeue to be listed e.g. NewBioSampleLibrary, AdditionalYieldOfLibraryPool, or AdditionalYieldOfFinishedLibrary.
         * @type {?|undefined}
         */
        GetV2BiosamplesBiosampleidLabrequeuesParams.prototype.type;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2BiosamplesBiosampleidLabrequeuesParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2BiosamplesBiosampleidLabrequeuesParams.prototype.sortby;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2BiosamplesBiosampleidLabrequeuesParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2BiosamplesBiosampleidLabrequeuesParams.prototype.limit;
    }
    /**
     * Parameters for GetV2BiosamplesId
     * @record
     */
    function GetV2BiosamplesIdParams() { }
    BasespaceService.GetV2BiosamplesIdParams = GetV2BiosamplesIdParams;
    if (false) {
        /**
         * Biosample ID
         * @type {?}
         */
        GetV2BiosamplesIdParams.prototype.id;
        /**
         * Sub elements to include in the response
         * @type {?|undefined}
         */
        GetV2BiosamplesIdParams.prototype.include;
    }
    /**
     * Parameters for PostV2BiosamplesId
     * @record
     */
    function PostV2BiosamplesIdParams() { }
    BasespaceService.PostV2BiosamplesIdParams = PostV2BiosamplesIdParams;
    if (false) {
        /**
         * Biosample ID
         * @type {?}
         */
        PostV2BiosamplesIdParams.prototype.id;
        /** @type {?|undefined} */
        PostV2BiosamplesIdParams.prototype.payload;
    }
    /**
     * Parameters for GetV2BiosamplesIdAggregatedfastqdatasets
     * @record
     */
    function GetV2BiosamplesIdAggregatedfastqdatasetsParams() { }
    BasespaceService.GetV2BiosamplesIdAggregatedfastqdatasetsParams = GetV2BiosamplesIdAggregatedfastqdatasetsParams;
    if (false) {
        /**
         * If true, mixing datasets of different library types is allowed, false otherwise
         * @type {?}
         */
        GetV2BiosamplesIdAggregatedfastqdatasetsParams.prototype.mixlibrarytypesallowed;
        /**
         * Biosample ID
         * @type {?}
         */
        GetV2BiosamplesIdAggregatedfastqdatasetsParams.prototype.id;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2BiosamplesIdAggregatedfastqdatasetsParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2BiosamplesIdAggregatedfastqdatasetsParams.prototype.sortby;
        /**
         * Optional comma-separated list of selected LibraryPrepId values to consider
         * @type {?|undefined}
         */
        GetV2BiosamplesIdAggregatedfastqdatasetsParams.prototype.selectedlibraryprepids;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2BiosamplesIdAggregatedfastqdatasetsParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2BiosamplesIdAggregatedfastqdatasetsParams.prototype.limit;
    }
    /**
     * Parameters for PostV2BiosamplesIdAggregation
     * @record
     */
    function PostV2BiosamplesIdAggregationParams() { }
    BasespaceService.PostV2BiosamplesIdAggregationParams = PostV2BiosamplesIdAggregationParams;
    if (false) {
        /**
         * The Id of the resource
         * @type {?}
         */
        PostV2BiosamplesIdAggregationParams.prototype.id;
        /** @type {?|undefined} */
        PostV2BiosamplesIdAggregationParams.prototype.payload;
    }
    /**
     * Parameters for GetV2BiosamplesIdLibraries
     * @record
     */
    function GetV2BiosamplesIdLibrariesParams() { }
    BasespaceService.GetV2BiosamplesIdLibrariesParams = GetV2BiosamplesIdLibrariesParams;
    if (false) {
        /**
         * Biosample ID
         * @type {?}
         */
        GetV2BiosamplesIdLibrariesParams.prototype.id;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2BiosamplesIdLibrariesParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2BiosamplesIdLibrariesParams.prototype.sortby;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2BiosamplesIdLibrariesParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2BiosamplesIdLibrariesParams.prototype.limit;
        /**
         * Sub elements to include in the response: LibraryIndex, YieldInformation
         * @type {?|undefined}
         */
        GetV2BiosamplesIdLibrariesParams.prototype.include;
    }
    /**
     * Parameters for PostV2BiosamplesIdLibraries
     * @record
     */
    function PostV2BiosamplesIdLibrariesParams() { }
    BasespaceService.PostV2BiosamplesIdLibrariesParams = PostV2BiosamplesIdLibrariesParams;
    if (false) {
        /**
         * The Id of the resource
         * @type {?}
         */
        PostV2BiosamplesIdLibrariesParams.prototype.id;
        /** @type {?|undefined} */
        PostV2BiosamplesIdLibrariesParams.prototype.payload;
    }
    /**
     * Parameters for GetV2BiosamplesIdProperties
     * @record
     */
    function GetV2BiosamplesIdPropertiesParams() { }
    BasespaceService.GetV2BiosamplesIdPropertiesParams = GetV2BiosamplesIdPropertiesParams;
    if (false) {
        /** @type {?} */
        GetV2BiosamplesIdPropertiesParams.prototype.id;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2BiosamplesIdPropertiesParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2BiosamplesIdPropertiesParams.prototype.sortby;
        /**
         * Show Hidden projects and Datasets
         * @type {?|undefined}
         */
        GetV2BiosamplesIdPropertiesParams.prototype.showhiddenitems;
        /**
         * Limit the # of property items returned per property
         * @type {?|undefined}
         */
        GetV2BiosamplesIdPropertiesParams.prototype.propertyitemslimit;
        /**
         * Filter by property name
         * @type {?|undefined}
         */
        GetV2BiosamplesIdPropertiesParams.prototype.propertyfilters;
        /**
         * Limit the # of properties returned
         * @type {?|undefined}
         */
        GetV2BiosamplesIdPropertiesParams.prototype.propertieslimit;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2BiosamplesIdPropertiesParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2BiosamplesIdPropertiesParams.prototype.limit;
    }
    /**
     * Parameters for GetV2BiosamplesIdPropertiesName
     * @record
     */
    function GetV2BiosamplesIdPropertiesNameParams() { }
    BasespaceService.GetV2BiosamplesIdPropertiesNameParams = GetV2BiosamplesIdPropertiesNameParams;
    if (false) {
        /**
         * Property name
         * @type {?}
         */
        GetV2BiosamplesIdPropertiesNameParams.prototype.name;
        /** @type {?} */
        GetV2BiosamplesIdPropertiesNameParams.prototype.id;
        /**
         * Hidden filter
         * @type {?|undefined}
         */
        GetV2BiosamplesIdPropertiesNameParams.prototype.showhiddenitems;
        /**
         * Limit the # of property items returned per property
         * @type {?|undefined}
         */
        GetV2BiosamplesIdPropertiesNameParams.prototype.propertyitemslimit;
    }
    /**
     * Parameters for GetV2BiosamplesIdPropertiesNameItems
     * @record
     */
    function GetV2BiosamplesIdPropertiesNameItemsParams() { }
    BasespaceService.GetV2BiosamplesIdPropertiesNameItemsParams = GetV2BiosamplesIdPropertiesNameItemsParams;
    if (false) {
        /**
         * Property name
         * @type {?}
         */
        GetV2BiosamplesIdPropertiesNameItemsParams.prototype.name;
        /** @type {?} */
        GetV2BiosamplesIdPropertiesNameItemsParams.prototype.id;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2BiosamplesIdPropertiesNameItemsParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2BiosamplesIdPropertiesNameItemsParams.prototype.sortby;
        /**
         * Hidden filter
         * @type {?|undefined}
         */
        GetV2BiosamplesIdPropertiesNameItemsParams.prototype.showhiddenitems;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2BiosamplesIdPropertiesNameItemsParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2BiosamplesIdPropertiesNameItemsParams.prototype.limit;
    }
    /**
     * Parameters for GetV2BiosamplesIdRunlanesummaries
     * @record
     */
    function GetV2BiosamplesIdRunlanesummariesParams() { }
    BasespaceService.GetV2BiosamplesIdRunlanesummariesParams = GetV2BiosamplesIdRunlanesummariesParams;
    if (false) {
        /**
         * Biosample ID
         * @type {?}
         */
        GetV2BiosamplesIdRunlanesummariesParams.prototype.id;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2BiosamplesIdRunlanesummariesParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2BiosamplesIdRunlanesummariesParams.prototype.sortby;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2BiosamplesIdRunlanesummariesParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2BiosamplesIdRunlanesummariesParams.prototype.limit;
    }
    /**
     * Parameters for GetV2Datasets
     * @record
     */
    function GetV2DatasetsParams() { }
    BasespaceService.GetV2DatasetsParams = GetV2DatasetsParams;
    if (false) {
        /**
         * Return datasets of this file upload status.
         * @type {?|undefined}
         */
        GetV2DatasetsParams.prototype.uploadstatus;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2DatasetsParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2DatasetsParams.prototype.sortby;
        /**
         * Return datasets of this QC status.
         * @type {?|undefined}
         */
        GetV2DatasetsParams.prototype.qcstatus;
        /**
         * Specify which properties to include in the properties section, e.g. Input.BioSamples, Input.Libraries, or Input.Runs.
         * @type {?|undefined}
         */
        GetV2DatasetsParams.prototype.propertyfilters;
        /**
         * Return datasets related to this project ID.
         * @type {?|undefined}
         */
        GetV2DatasetsParams.prototype.projectid;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2DatasetsParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2DatasetsParams.prototype.limit;
        /**
         * The archive states to filter by. Valid values include: True, False.
         * @type {?|undefined}
         */
        GetV2DatasetsParams.prototype.isarchived;
        /**
         * Return datasets related to this run ID token.
         * @type {?|undefined}
         */
        GetV2DatasetsParams.prototype.inputruntokens;
        /**
         * Return datasets related to this run ID.
         * @type {?|undefined}
         */
        GetV2DatasetsParams.prototype.inputruns;
        /**
         * Return datasets related to this biosample ID.
         * @type {?|undefined}
         */
        GetV2DatasetsParams.prototype.inputbiosamples;
        /**
         * Can specify to return Properties, which returns an additional properties section for each dataset. Or return AppSessionRoot, which returns information about the root analysis of a workflow in the AppSession section for each dataset it applies to.
         * @type {?|undefined}
         */
        GetV2DatasetsParams.prototype.include;
        /**
         * Return datasets of this type or excluding this type. Supports comma-separated lists.
         * @type {?|undefined}
         */
        GetV2DatasetsParams.prototype.datasettypes;
        /**
         * Return datasets related to this app session ID.
         * @type {?|undefined}
         */
        GetV2DatasetsParams.prototype.appsessionids;
    }
    /**
     * Parameters for PostV2DatasetsId
     * @record
     */
    function PostV2DatasetsIdParams() { }
    BasespaceService.PostV2DatasetsIdParams = PostV2DatasetsIdParams;
    if (false) {
        /**
         * Dataset ID
         * @type {?}
         */
        PostV2DatasetsIdParams.prototype.id;
        /** @type {?|undefined} */
        PostV2DatasetsIdParams.prototype.payload;
    }
    /**
     * Parameters for GetV2DatasetsIdComments
     * @record
     */
    function GetV2DatasetsIdCommentsParams() { }
    BasespaceService.GetV2DatasetsIdCommentsParams = GetV2DatasetsIdCommentsParams;
    if (false) {
        /**
         * Dataset ID
         * @type {?}
         */
        GetV2DatasetsIdCommentsParams.prototype.id;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2DatasetsIdCommentsParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2DatasetsIdCommentsParams.prototype.sortby;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2DatasetsIdCommentsParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2DatasetsIdCommentsParams.prototype.limit;
    }
    /**
     * Parameters for PostV2DatasetsIdCopy
     * @record
     */
    function PostV2DatasetsIdCopyParams() { }
    BasespaceService.PostV2DatasetsIdCopyParams = PostV2DatasetsIdCopyParams;
    if (false) {
        /**
         * The Id of the resource
         * @type {?}
         */
        PostV2DatasetsIdCopyParams.prototype.id;
        /** @type {?|undefined} */
        PostV2DatasetsIdCopyParams.prototype.payload;
    }
    /**
     * Parameters for PostV2DatasetsIdDirectUploadInfo
     * @record
     */
    function PostV2DatasetsIdDirectUploadInfoParams() { }
    BasespaceService.PostV2DatasetsIdDirectUploadInfoParams = PostV2DatasetsIdDirectUploadInfoParams;
    if (false) {
        /**
         * The Id of the resource
         * @type {?}
         */
        PostV2DatasetsIdDirectUploadInfoParams.prototype.id;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        PostV2DatasetsIdDirectUploadInfoParams.prototype.sortdir;
        /** @type {?|undefined} */
        PostV2DatasetsIdDirectUploadInfoParams.prototype.payload;
    }
    /**
     * Parameters for GetV2DatasetsIdFiles
     * @record
     */
    function GetV2DatasetsIdFilesParams() { }
    BasespaceService.GetV2DatasetsIdFilesParams = GetV2DatasetsIdFilesParams;
    if (false) {
        /** @type {?} */
        GetV2DatasetsIdFilesParams.prototype.turbomode;
        /**
         * The Id of the resource
         * @type {?}
         */
        GetV2DatasetsIdFilesParams.prototype.id;
        /**
         * Resolves the HrefContent to the direct file URI to avoid a hop to GET: files/{id}/content
         * @type {?}
         */
        GetV2DatasetsIdFilesParams.prototype.filehrefcontentresolution;
        /**
         * Whether to exclude VCF index folders
         * @type {?}
         */
        GetV2DatasetsIdFilesParams.prototype.excludevcfindexfolder;
        /**
         * Whether to exclude system folders
         * @type {?}
         */
        GetV2DatasetsIdFilesParams.prototype.excludesystemfolder;
        /**
         * Whether to exclude empty files
         * @type {?}
         */
        GetV2DatasetsIdFilesParams.prototype.excludeemptyfiles;
        /**
         * Whether to exclude BAM coverage folders
         * @type {?}
         */
        GetV2DatasetsIdFilesParams.prototype.excludebamcoveragefolder;
        /**
         * Optionally filter by status (default complete)
         * @type {?|undefined}
         */
        GetV2DatasetsIdFilesParams.prototype.statuses;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2DatasetsIdFilesParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2DatasetsIdFilesParams.prototype.sortby;
        /**
         * To be pre-fixed in the path of the file
         * @type {?|undefined}
         */
        GetV2DatasetsIdFilesParams.prototype.pathprefix;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2DatasetsIdFilesParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2DatasetsIdFilesParams.prototype.limit;
        /**
         * Whether to return subdirectories
         * @type {?|undefined}
         */
        GetV2DatasetsIdFilesParams.prototype.includesubdirectories;
        /** @type {?|undefined} */
        GetV2DatasetsIdFilesParams.prototype.filesetid;
        /**
         * Filter by file extension
         * @type {?|undefined}
         */
        GetV2DatasetsIdFilesParams.prototype.extensions;
        /**
         * Exclude by file extension
         * @type {?|undefined}
         */
        GetV2DatasetsIdFilesParams.prototype.excludeextensions;
        /**
         * Filter by directory path (root is /)
         * @type {?|undefined}
         */
        GetV2DatasetsIdFilesParams.prototype.directory;
    }
    /**
     * Parameters for PostV2DatasetsIdFiles
     * @record
     */
    function PostV2DatasetsIdFilesParams() { }
    BasespaceService.PostV2DatasetsIdFilesParams = PostV2DatasetsIdFilesParams;
    if (false) {
        /**
         * The Id of the resource
         * @type {?}
         */
        PostV2DatasetsIdFilesParams.prototype.id;
        /**
         * The file to upload
         * @type {?}
         */
        PostV2DatasetsIdFilesParams.prototype.file;
    }
    /**
     * Parameters for GetV2DatasetsIdFileUploadInfo
     * @record
     */
    function GetV2DatasetsIdFileUploadInfoParams() { }
    BasespaceService.GetV2DatasetsIdFileUploadInfoParams = GetV2DatasetsIdFileUploadInfoParams;
    if (false) {
        /**
         * The Id of the resource
         * @type {?}
         */
        GetV2DatasetsIdFileUploadInfoParams.prototype.id;
        /** @type {?|undefined} */
        GetV2DatasetsIdFileUploadInfoParams.prototype.uploadpartcount;
        /** @type {?|undefined} */
        GetV2DatasetsIdFileUploadInfoParams.prototype.filepath;
    }
    /**
     * Parameters for PostV2DatasetsIdFileUploadInfo
     * @record
     */
    function PostV2DatasetsIdFileUploadInfoParams() { }
    BasespaceService.PostV2DatasetsIdFileUploadInfoParams = PostV2DatasetsIdFileUploadInfoParams;
    if (false) {
        /**
         * The Id of the resource
         * @type {?}
         */
        PostV2DatasetsIdFileUploadInfoParams.prototype.id;
        /** @type {?|undefined} */
        PostV2DatasetsIdFileUploadInfoParams.prototype.payload;
    }
    /**
     * Parameters for GetV2DatasetsIdProperties
     * @record
     */
    function GetV2DatasetsIdPropertiesParams() { }
    BasespaceService.GetV2DatasetsIdPropertiesParams = GetV2DatasetsIdPropertiesParams;
    if (false) {
        /** @type {?} */
        GetV2DatasetsIdPropertiesParams.prototype.id;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2DatasetsIdPropertiesParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2DatasetsIdPropertiesParams.prototype.sortby;
        /**
         * Show Hidden projects and Datasets
         * @type {?|undefined}
         */
        GetV2DatasetsIdPropertiesParams.prototype.showhiddenitems;
        /**
         * Limit the # of property items returned per property
         * @type {?|undefined}
         */
        GetV2DatasetsIdPropertiesParams.prototype.propertyitemslimit;
        /**
         * Filter by property name
         * @type {?|undefined}
         */
        GetV2DatasetsIdPropertiesParams.prototype.propertyfilters;
        /**
         * Limit the # of properties returned
         * @type {?|undefined}
         */
        GetV2DatasetsIdPropertiesParams.prototype.propertieslimit;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2DatasetsIdPropertiesParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2DatasetsIdPropertiesParams.prototype.limit;
    }
    /**
     * Parameters for GetV2DatasetsIdPropertiesName
     * @record
     */
    function GetV2DatasetsIdPropertiesNameParams() { }
    BasespaceService.GetV2DatasetsIdPropertiesNameParams = GetV2DatasetsIdPropertiesNameParams;
    if (false) {
        /**
         * Property name
         * @type {?}
         */
        GetV2DatasetsIdPropertiesNameParams.prototype.name;
        /** @type {?} */
        GetV2DatasetsIdPropertiesNameParams.prototype.id;
        /**
         * Hidden filter
         * @type {?|undefined}
         */
        GetV2DatasetsIdPropertiesNameParams.prototype.showhiddenitems;
        /**
         * Limit the # of property items returned per property
         * @type {?|undefined}
         */
        GetV2DatasetsIdPropertiesNameParams.prototype.propertyitemslimit;
    }
    /**
     * Parameters for GetV2DatasetsIdPropertiesNameItems
     * @record
     */
    function GetV2DatasetsIdPropertiesNameItemsParams() { }
    BasespaceService.GetV2DatasetsIdPropertiesNameItemsParams = GetV2DatasetsIdPropertiesNameItemsParams;
    if (false) {
        /**
         * Property name
         * @type {?}
         */
        GetV2DatasetsIdPropertiesNameItemsParams.prototype.name;
        /** @type {?} */
        GetV2DatasetsIdPropertiesNameItemsParams.prototype.id;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2DatasetsIdPropertiesNameItemsParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2DatasetsIdPropertiesNameItemsParams.prototype.sortby;
        /**
         * Hidden filter
         * @type {?|undefined}
         */
        GetV2DatasetsIdPropertiesNameItemsParams.prototype.showhiddenitems;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2DatasetsIdPropertiesNameItemsParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2DatasetsIdPropertiesNameItemsParams.prototype.limit;
    }
    /**
     * Parameters for GetV2DatasettypesId
     * @record
     */
    function GetV2DatasettypesIdParams() { }
    BasespaceService.GetV2DatasettypesIdParams = GetV2DatasettypesIdParams;
    if (false) {
        /**
         * Dataset type ID
         * @type {?}
         */
        GetV2DatasettypesIdParams.prototype.id;
        /** @type {?|undefined} */
        GetV2DatasettypesIdParams.prototype.include;
    }
    /**
     * Parameters for GetV2Gdssharetransferstats
     * @record
     */
    function GetV2GdssharetransferstatsParams() { }
    BasespaceService.GetV2GdssharetransferstatsParams = GetV2GdssharetransferstatsParams;
    if (false) {
        /** @type {?|undefined} */
        GetV2GdssharetransferstatsParams.prototype.status;
        /** @type {?|undefined} */
        GetV2GdssharetransferstatsParams.prototype.operationtype;
        /** @type {?|undefined} */
        GetV2GdssharetransferstatsParams.prototype.maxitems;
    }
    /**
     * Parameters for DeleteV2IcauploadsFoldertypeDataid
     * @record
     */
    function DeleteV2IcauploadsFoldertypeDataidParams() { }
    BasespaceService.DeleteV2IcauploadsFoldertypeDataidParams = DeleteV2IcauploadsFoldertypeDataidParams;
    if (false) {
        /** @type {?} */
        DeleteV2IcauploadsFoldertypeDataidParams.prototype.foldertype;
        /** @type {?} */
        DeleteV2IcauploadsFoldertypeDataidParams.prototype.dataid;
    }
    /**
     * Parameters for PostV2IcauploadsFoldertypeCompleteUpload
     * @record
     */
    function PostV2IcauploadsFoldertypeCompleteUploadParams() { }
    BasespaceService.PostV2IcauploadsFoldertypeCompleteUploadParams = PostV2IcauploadsFoldertypeCompleteUploadParams;
    if (false) {
        /** @type {?} */
        PostV2IcauploadsFoldertypeCompleteUploadParams.prototype.foldertype;
        /** @type {?|undefined} */
        PostV2IcauploadsFoldertypeCompleteUploadParams.prototype.payload;
    }
    /**
     * Parameters for PostV2IcauploadsFoldertypeDirectUploadInfo
     * @record
     */
    function PostV2IcauploadsFoldertypeDirectUploadInfoParams() { }
    BasespaceService.PostV2IcauploadsFoldertypeDirectUploadInfoParams = PostV2IcauploadsFoldertypeDirectUploadInfoParams;
    if (false) {
        /** @type {?} */
        PostV2IcauploadsFoldertypeDirectUploadInfoParams.prototype.foldertype;
        /** @type {?|undefined} */
        PostV2IcauploadsFoldertypeDirectUploadInfoParams.prototype.payload;
    }
    /**
     * Parameters for GetV2InstrumentconnectioncheckFileUploadInfo
     * @record
     */
    function GetV2InstrumentconnectioncheckFileUploadInfoParams() { }
    BasespaceService.GetV2InstrumentconnectioncheckFileUploadInfoParams = GetV2InstrumentconnectioncheckFileUploadInfoParams;
    if (false) {
        /** @type {?|undefined} */
        GetV2InstrumentconnectioncheckFileUploadInfoParams.prototype.uploadpartcount;
        /**
         * The Id of the resource
         * @type {?|undefined}
         */
        GetV2InstrumentconnectioncheckFileUploadInfoParams.prototype.id;
        /** @type {?|undefined} */
        GetV2InstrumentconnectioncheckFileUploadInfoParams.prototype.filepath;
    }
    /**
     * Parameters for PostV2InstrumentdiagnosticsId
     * @record
     */
    function PostV2InstrumentdiagnosticsIdParams() { }
    BasespaceService.PostV2InstrumentdiagnosticsIdParams = PostV2InstrumentdiagnosticsIdParams;
    if (false) {
        /**
         * The Id of the resource
         * @type {?}
         */
        PostV2InstrumentdiagnosticsIdParams.prototype.id;
        /** @type {?|undefined} */
        PostV2InstrumentdiagnosticsIdParams.prototype.payload;
    }
    /**
     * Parameters for GetV2Instruments
     * @record
     */
    function GetV2InstrumentsParams() { }
    BasespaceService.GetV2InstrumentsParams = GetV2InstrumentsParams;
    if (false) {
        /** @type {?} */
        GetV2InstrumentsParams.prototype.allworkgroups;
        /** @type {?} */
        GetV2InstrumentsParams.prototype.activeruns;
        /** @type {?|undefined} */
        GetV2InstrumentsParams.prototype.todate;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2InstrumentsParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2InstrumentsParams.prototype.sortby;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2InstrumentsParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2InstrumentsParams.prototype.limit;
        /**
         * The Id of the resource
         * @type {?|undefined}
         */
        GetV2InstrumentsParams.prototype.id;
        /** @type {?|undefined} */
        GetV2InstrumentsParams.prototype.fromdate;
    }
    /**
     * Parameters for GetV2Instrumentstatistics
     * @record
     */
    function GetV2InstrumentstatisticsParams() { }
    BasespaceService.GetV2InstrumentstatisticsParams = GetV2InstrumentstatisticsParams;
    if (false) {
        /**
         * User timezone for binning.
         * @type {?}
         */
        GetV2InstrumentstatisticsParams.prototype.timezone;
        /**
         * Comma-separated list of serial numbers.
         * @type {?}
         */
        GetV2InstrumentstatisticsParams.prototype.serialnumbers;
        /**
         * From date in user ISO 8601 format.
         * @type {?}
         */
        GetV2InstrumentstatisticsParams.prototype.fromdate;
        /**
         * To date in ISO 8601 format. Defaults to current date if not specified.
         * @type {?|undefined}
         */
        GetV2InstrumentstatisticsParams.prototype.todate;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2InstrumentstatisticsParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2InstrumentstatisticsParams.prototype.sortby;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2InstrumentstatisticsParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2InstrumentstatisticsParams.prototype.limit;
        /**
         * The Id of the resource
         * @type {?|undefined}
         */
        GetV2InstrumentstatisticsParams.prototype.id;
        /**
         * BinBy can be 'week' or 'month'.
         * @type {?|undefined}
         */
        GetV2InstrumentstatisticsParams.prototype.binby;
    }
    /**
     * Parameters for GetV2Instrumentstatus
     * @record
     */
    function GetV2InstrumentstatusParams() { }
    BasespaceService.GetV2InstrumentstatusParams = GetV2InstrumentstatusParams;
    if (false) {
        /**
         * Set to true to include a list of active runs for each instrument.  Default is false.
         * @type {?}
         */
        GetV2InstrumentstatusParams.prototype.includeactiveruns;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2InstrumentstatusParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2InstrumentstatusParams.prototype.sortby;
        /**
         * A comma-delimited list of instrument serial numbers.
         * @type {?|undefined}
         */
        GetV2InstrumentstatusParams.prototype.serialnumbers;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2InstrumentstatusParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2InstrumentstatusParams.prototype.limit;
        /**
         * The Id of the resource
         * @type {?|undefined}
         */
        GetV2InstrumentstatusParams.prototype.id;
    }
    /**
     * Parameters for GetV2Labrequeues
     * @record
     */
    function GetV2LabrequeuesParams() { }
    BasespaceService.GetV2LabrequeuesParams = GetV2LabrequeuesParams;
    if (false) {
        /**
         * Only return labrequeues with the given LabRequeueTypes(s)
         * @type {?|undefined}
         */
        GetV2LabrequeuesParams.prototype.type;
        /**
         * Only return labrequeues with the given Status(es)
         * @type {?|undefined}
         */
        GetV2LabrequeuesParams.prototype.status;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2LabrequeuesParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2LabrequeuesParams.prototype.sortby;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2LabrequeuesParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2LabrequeuesParams.prototype.limit;
        /**
         * The Id of the resource
         * @type {?|undefined}
         */
        GetV2LabrequeuesParams.prototype.id;
    }
    /**
     * Parameters for PutV2Laneqcthresholds
     * @record
     */
    function PutV2LaneqcthresholdsParams() { }
    BasespaceService.PutV2LaneqcthresholdsParams = PutV2LaneqcthresholdsParams;
    if (false) {
        /** @type {?|undefined} */
        PutV2LaneqcthresholdsParams.prototype.qcthresholds;
        /**
         * The Id of the resource
         * @type {?|undefined}
         */
        PutV2LaneqcthresholdsParams.prototype.id;
    }
    /**
     * Parameters for PostV2LanesId
     * @record
     */
    function PostV2LanesIdParams() { }
    BasespaceService.PostV2LanesIdParams = PostV2LanesIdParams;
    if (false) {
        /** @type {?} */
        PostV2LanesIdParams.prototype.id;
        /** @type {?|undefined} */
        PostV2LanesIdParams.prototype.payload;
    }
    /**
     * Parameters for GetV2LanesIdComments
     * @record
     */
    function GetV2LanesIdCommentsParams() { }
    BasespaceService.GetV2LanesIdCommentsParams = GetV2LanesIdCommentsParams;
    if (false) {
        /**
         * Lane ID
         * @type {?}
         */
        GetV2LanesIdCommentsParams.prototype.id;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2LanesIdCommentsParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2LanesIdCommentsParams.prototype.sortby;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2LanesIdCommentsParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2LanesIdCommentsParams.prototype.limit;
    }
    /**
     * Parameters for GetV2Libraries
     * @record
     */
    function GetV2LibrariesParams() { }
    BasespaceService.GetV2LibrariesParams = GetV2LibrariesParams;
    if (false) {
        /** @type {?|undefined} */
        GetV2LibrariesParams.prototype.status;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2LibrariesParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2LibrariesParams.prototype.sortby;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2LibrariesParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2LibrariesParams.prototype.limit;
        /**
         * The Id of the resource
         * @type {?|undefined}
         */
        GetV2LibrariesParams.prototype.id;
    }
    /**
     * Parameters for GetV2LibrariesIdProperties
     * @record
     */
    function GetV2LibrariesIdPropertiesParams() { }
    BasespaceService.GetV2LibrariesIdPropertiesParams = GetV2LibrariesIdPropertiesParams;
    if (false) {
        /** @type {?} */
        GetV2LibrariesIdPropertiesParams.prototype.id;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2LibrariesIdPropertiesParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2LibrariesIdPropertiesParams.prototype.sortby;
        /**
         * Show Hidden projects and Datasets
         * @type {?|undefined}
         */
        GetV2LibrariesIdPropertiesParams.prototype.showhiddenitems;
        /**
         * Limit the # of property items returned per property
         * @type {?|undefined}
         */
        GetV2LibrariesIdPropertiesParams.prototype.propertyitemslimit;
        /**
         * Filter by property name
         * @type {?|undefined}
         */
        GetV2LibrariesIdPropertiesParams.prototype.propertyfilters;
        /**
         * Limit the # of properties returned
         * @type {?|undefined}
         */
        GetV2LibrariesIdPropertiesParams.prototype.propertieslimit;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2LibrariesIdPropertiesParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2LibrariesIdPropertiesParams.prototype.limit;
    }
    /**
     * Parameters for GetV2LibrariesIdPropertiesName
     * @record
     */
    function GetV2LibrariesIdPropertiesNameParams() { }
    BasespaceService.GetV2LibrariesIdPropertiesNameParams = GetV2LibrariesIdPropertiesNameParams;
    if (false) {
        /**
         * Property name
         * @type {?}
         */
        GetV2LibrariesIdPropertiesNameParams.prototype.name;
        /** @type {?} */
        GetV2LibrariesIdPropertiesNameParams.prototype.id;
        /**
         * Hidden filter
         * @type {?|undefined}
         */
        GetV2LibrariesIdPropertiesNameParams.prototype.showhiddenitems;
        /**
         * Limit the # of property items returned per property
         * @type {?|undefined}
         */
        GetV2LibrariesIdPropertiesNameParams.prototype.propertyitemslimit;
    }
    /**
     * Parameters for GetV2LibrariesIdPropertiesNameItems
     * @record
     */
    function GetV2LibrariesIdPropertiesNameItemsParams() { }
    BasespaceService.GetV2LibrariesIdPropertiesNameItemsParams = GetV2LibrariesIdPropertiesNameItemsParams;
    if (false) {
        /**
         * Property name
         * @type {?}
         */
        GetV2LibrariesIdPropertiesNameItemsParams.prototype.name;
        /** @type {?} */
        GetV2LibrariesIdPropertiesNameItemsParams.prototype.id;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2LibrariesIdPropertiesNameItemsParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2LibrariesIdPropertiesNameItemsParams.prototype.sortby;
        /**
         * Hidden filter
         * @type {?|undefined}
         */
        GetV2LibrariesIdPropertiesNameItemsParams.prototype.showhiddenitems;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2LibrariesIdPropertiesNameItemsParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2LibrariesIdPropertiesNameItemsParams.prototype.limit;
    }
    /**
     * Parameters for PostV2LibrariesLibraryidLabrequeues
     * @record
     */
    function PostV2LibrariesLibraryidLabrequeuesParams() { }
    BasespaceService.PostV2LibrariesLibraryidLabrequeuesParams = PostV2LibrariesLibraryidLabrequeuesParams;
    if (false) {
        /** @type {?} */
        PostV2LibrariesLibraryidLabrequeuesParams.prototype.libraryid;
        /** @type {?|undefined} */
        PostV2LibrariesLibraryidLabrequeuesParams.prototype.payload;
    }
    /**
     * Parameters for GetV2Librarypools
     * @record
     */
    function GetV2LibrarypoolsParams() { }
    BasespaceService.GetV2LibrarypoolsParams = GetV2LibrarypoolsParams;
    if (false) {
        /**
         * Possible values are: Active, Failed, Consumed, QCFailed
         * @type {?|undefined}
         */
        GetV2LibrarypoolsParams.prototype.status;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2LibrarypoolsParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2LibrarypoolsParams.prototype.sortby;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2LibrarypoolsParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2LibrarypoolsParams.prototype.limit;
        /**
         * The Id of the resource
         * @type {?|undefined}
         */
        GetV2LibrarypoolsParams.prototype.id;
    }
    /**
     * Parameters for PostV2LibrarypoolsId
     * @record
     */
    function PostV2LibrarypoolsIdParams() { }
    BasespaceService.PostV2LibrarypoolsIdParams = PostV2LibrarypoolsIdParams;
    if (false) {
        /**
         * The Id of the resource
         * @type {?}
         */
        PostV2LibrarypoolsIdParams.prototype.id;
        /** @type {?|undefined} */
        PostV2LibrarypoolsIdParams.prototype.payload;
    }
    /**
     * Parameters for GetV2LibrarypoolsIdLibraries
     * @record
     */
    function GetV2LibrarypoolsIdLibrariesParams() { }
    BasespaceService.GetV2LibrarypoolsIdLibrariesParams = GetV2LibrarypoolsIdLibrariesParams;
    if (false) {
        /**
         * The Id of the resource
         * @type {?}
         */
        GetV2LibrarypoolsIdLibrariesParams.prototype.id;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2LibrarypoolsIdLibrariesParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2LibrarypoolsIdLibrariesParams.prototype.sortby;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2LibrarypoolsIdLibrariesParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2LibrarypoolsIdLibrariesParams.prototype.limit;
        /**
         * Sub elements to include in the response: LibraryIndex, YieldInformation
         * @type {?|undefined}
         */
        GetV2LibrarypoolsIdLibrariesParams.prototype.include;
    }
    /**
     * Parameters for GetV2LibrarypoolsIdProperties
     * @record
     */
    function GetV2LibrarypoolsIdPropertiesParams() { }
    BasespaceService.GetV2LibrarypoolsIdPropertiesParams = GetV2LibrarypoolsIdPropertiesParams;
    if (false) {
        /** @type {?} */
        GetV2LibrarypoolsIdPropertiesParams.prototype.id;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2LibrarypoolsIdPropertiesParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2LibrarypoolsIdPropertiesParams.prototype.sortby;
        /**
         * Show Hidden projects and Datasets
         * @type {?|undefined}
         */
        GetV2LibrarypoolsIdPropertiesParams.prototype.showhiddenitems;
        /**
         * Limit the # of property items returned per property
         * @type {?|undefined}
         */
        GetV2LibrarypoolsIdPropertiesParams.prototype.propertyitemslimit;
        /**
         * Filter by property name
         * @type {?|undefined}
         */
        GetV2LibrarypoolsIdPropertiesParams.prototype.propertyfilters;
        /**
         * Limit the # of properties returned
         * @type {?|undefined}
         */
        GetV2LibrarypoolsIdPropertiesParams.prototype.propertieslimit;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2LibrarypoolsIdPropertiesParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2LibrarypoolsIdPropertiesParams.prototype.limit;
    }
    /**
     * Parameters for GetV2LibrarypoolsIdPropertiesName
     * @record
     */
    function GetV2LibrarypoolsIdPropertiesNameParams() { }
    BasespaceService.GetV2LibrarypoolsIdPropertiesNameParams = GetV2LibrarypoolsIdPropertiesNameParams;
    if (false) {
        /**
         * Property name
         * @type {?}
         */
        GetV2LibrarypoolsIdPropertiesNameParams.prototype.name;
        /** @type {?} */
        GetV2LibrarypoolsIdPropertiesNameParams.prototype.id;
        /**
         * Hidden filter
         * @type {?|undefined}
         */
        GetV2LibrarypoolsIdPropertiesNameParams.prototype.showhiddenitems;
        /**
         * Limit the # of property items returned per property
         * @type {?|undefined}
         */
        GetV2LibrarypoolsIdPropertiesNameParams.prototype.propertyitemslimit;
    }
    /**
     * Parameters for GetV2LibrarypoolsIdPropertiesNameItems
     * @record
     */
    function GetV2LibrarypoolsIdPropertiesNameItemsParams() { }
    BasespaceService.GetV2LibrarypoolsIdPropertiesNameItemsParams = GetV2LibrarypoolsIdPropertiesNameItemsParams;
    if (false) {
        /**
         * Property name
         * @type {?}
         */
        GetV2LibrarypoolsIdPropertiesNameItemsParams.prototype.name;
        /** @type {?} */
        GetV2LibrarypoolsIdPropertiesNameItemsParams.prototype.id;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2LibrarypoolsIdPropertiesNameItemsParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2LibrarypoolsIdPropertiesNameItemsParams.prototype.sortby;
        /**
         * Hidden filter
         * @type {?|undefined}
         */
        GetV2LibrarypoolsIdPropertiesNameItemsParams.prototype.showhiddenitems;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2LibrarypoolsIdPropertiesNameItemsParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2LibrarypoolsIdPropertiesNameItemsParams.prototype.limit;
    }
    /**
     * Parameters for PostV2LibrarypoolsPoolidLabrequeues
     * @record
     */
    function PostV2LibrarypoolsPoolidLabrequeuesParams() { }
    BasespaceService.PostV2LibrarypoolsPoolidLabrequeuesParams = PostV2LibrarypoolsPoolidLabrequeuesParams;
    if (false) {
        /** @type {?} */
        PostV2LibrarypoolsPoolidLabrequeuesParams.prototype.poolid;
        /** @type {?|undefined} */
        PostV2LibrarypoolsPoolidLabrequeuesParams.prototype.payload;
    }
    /**
     * Parameters for PutV2NotificationsDismiss
     * @record
     */
    function PutV2NotificationsDismissParams() { }
    BasespaceService.PutV2NotificationsDismissParams = PutV2NotificationsDismissParams;
    if (false) {
        /**
         * The Type of the notification with in a stream.Only notifications with 'IsDismissable' flag set are dismissable
         * @type {?}
         */
        PutV2NotificationsDismissParams.prototype.type;
        /**
         * The stream type of the notification to be dismissed.Only DataDeletion, Storage or Subscription notifications can dismissed.
         * @type {?}
         */
        PutV2NotificationsDismissParams.prototype.stream;
        /**
         * The Id of the resource
         * @type {?|undefined}
         */
        PutV2NotificationsDismissParams.prototype.id;
    }
    /**
     * Parameters for PostV2Oauthv2tokensUserid
     * @record
     */
    function PostV2Oauthv2tokensUseridParams() { }
    BasespaceService.PostV2Oauthv2tokensUseridParams = PostV2Oauthv2tokensUseridParams;
    if (false) {
        /** @type {?} */
        PostV2Oauthv2tokensUseridParams.prototype.userid;
        /** @type {?|undefined} */
        PostV2Oauthv2tokensUseridParams.prototype.payload;
    }
    /**
     * Parameters for PostV2PreprequestsPreprequestidLabrequeues
     * @record
     */
    function PostV2PreprequestsPreprequestidLabrequeuesParams() { }
    BasespaceService.PostV2PreprequestsPreprequestidLabrequeuesParams = PostV2PreprequestsPreprequestidLabrequeuesParams;
    if (false) {
        /** @type {?} */
        PostV2PreprequestsPreprequestidLabrequeuesParams.prototype.preprequestid;
        /** @type {?|undefined} */
        PostV2PreprequestsPreprequestidLabrequeuesParams.prototype.payload;
    }
    /**
     * Parameters for PostV2Projects
     * @record
     */
    function PostV2ProjectsParams() { }
    BasespaceService.PostV2ProjectsParams = PostV2ProjectsParams;
    if (false) {
        /**
         * The name of the project.
         * @type {?}
         */
        PostV2ProjectsParams.prototype.name;
        /** @type {?|undefined} */
        PostV2ProjectsParams.prototype.payload;
        /**
         * Optional description of the project.
         * @type {?|undefined}
         */
        PostV2ProjectsParams.prototype.description;
    }
    /**
     * Parameters for GetV2ProjectsId
     * @record
     */
    function GetV2ProjectsIdParams() { }
    BasespaceService.GetV2ProjectsIdParams = GetV2ProjectsIdParams;
    if (false) {
        /**
         * The Id of the resource
         * @type {?}
         */
        GetV2ProjectsIdParams.prototype.id;
        /** @type {?|undefined} */
        GetV2ProjectsIdParams.prototype.propertyitemslimit;
        /** @type {?|undefined} */
        GetV2ProjectsIdParams.prototype.propertieslimit;
        /** @type {?|undefined} */
        GetV2ProjectsIdParams.prototype.include;
    }
    /**
     * Parameters for GetV2ProjectsIdDatasets
     * @record
     */
    function GetV2ProjectsIdDatasetsParams() { }
    BasespaceService.GetV2ProjectsIdDatasetsParams = GetV2ProjectsIdDatasetsParams;
    if (false) {
        /**
         * Project ID
         * @type {?}
         */
        GetV2ProjectsIdDatasetsParams.prototype.id;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2ProjectsIdDatasetsParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2ProjectsIdDatasetsParams.prototype.sortby;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2ProjectsIdDatasetsParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2ProjectsIdDatasetsParams.prototype.limit;
        /**
         * The archive states to filter by. Valid values include: True, False.
         * @type {?|undefined}
         */
        GetV2ProjectsIdDatasetsParams.prototype.isarchived;
    }
    /**
     * Parameters for PostV2ProjectsIdDatasets
     * @record
     */
    function PostV2ProjectsIdDatasetsParams() { }
    BasespaceService.PostV2ProjectsIdDatasetsParams = PostV2ProjectsIdDatasetsParams;
    if (false) {
        /**
         * Project ID
         * @type {?}
         */
        PostV2ProjectsIdDatasetsParams.prototype.id;
        /** @type {?|undefined} */
        PostV2ProjectsIdDatasetsParams.prototype.payload;
    }
    /**
     * Parameters for GetV2ProjectsIdProperties
     * @record
     */
    function GetV2ProjectsIdPropertiesParams() { }
    BasespaceService.GetV2ProjectsIdPropertiesParams = GetV2ProjectsIdPropertiesParams;
    if (false) {
        /** @type {?} */
        GetV2ProjectsIdPropertiesParams.prototype.id;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2ProjectsIdPropertiesParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2ProjectsIdPropertiesParams.prototype.sortby;
        /**
         * Show Hidden projects and Datasets
         * @type {?|undefined}
         */
        GetV2ProjectsIdPropertiesParams.prototype.showhiddenitems;
        /**
         * Limit the # of property items returned per property
         * @type {?|undefined}
         */
        GetV2ProjectsIdPropertiesParams.prototype.propertyitemslimit;
        /**
         * Filter by property name
         * @type {?|undefined}
         */
        GetV2ProjectsIdPropertiesParams.prototype.propertyfilters;
        /**
         * Limit the # of properties returned
         * @type {?|undefined}
         */
        GetV2ProjectsIdPropertiesParams.prototype.propertieslimit;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2ProjectsIdPropertiesParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2ProjectsIdPropertiesParams.prototype.limit;
    }
    /**
     * Parameters for GetV2ProjectsIdPropertiesName
     * @record
     */
    function GetV2ProjectsIdPropertiesNameParams() { }
    BasespaceService.GetV2ProjectsIdPropertiesNameParams = GetV2ProjectsIdPropertiesNameParams;
    if (false) {
        /**
         * Property name
         * @type {?}
         */
        GetV2ProjectsIdPropertiesNameParams.prototype.name;
        /** @type {?} */
        GetV2ProjectsIdPropertiesNameParams.prototype.id;
        /**
         * Hidden filter
         * @type {?|undefined}
         */
        GetV2ProjectsIdPropertiesNameParams.prototype.showhiddenitems;
        /**
         * Limit the # of property items returned per property
         * @type {?|undefined}
         */
        GetV2ProjectsIdPropertiesNameParams.prototype.propertyitemslimit;
    }
    /**
     * Parameters for GetV2ProjectsIdPropertiesNameItems
     * @record
     */
    function GetV2ProjectsIdPropertiesNameItemsParams() { }
    BasespaceService.GetV2ProjectsIdPropertiesNameItemsParams = GetV2ProjectsIdPropertiesNameItemsParams;
    if (false) {
        /**
         * Property name
         * @type {?}
         */
        GetV2ProjectsIdPropertiesNameItemsParams.prototype.name;
        /** @type {?} */
        GetV2ProjectsIdPropertiesNameItemsParams.prototype.id;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2ProjectsIdPropertiesNameItemsParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2ProjectsIdPropertiesNameItemsParams.prototype.sortby;
        /**
         * Hidden filter
         * @type {?|undefined}
         */
        GetV2ProjectsIdPropertiesNameItemsParams.prototype.showhiddenitems;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2ProjectsIdPropertiesNameItemsParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2ProjectsIdPropertiesNameItemsParams.prototype.limit;
    }
    /**
     * Parameters for GetV2Resourcemanifest
     * @record
     */
    function GetV2ResourcemanifestParams() { }
    BasespaceService.GetV2ResourcemanifestParams = GetV2ResourcemanifestParams;
    if (false) {
        /** @type {?} */
        GetV2ResourcemanifestParams.prototype.fileszipped;
        /** @type {?} */
        GetV2ResourcemanifestParams.prototype.excludeemptyfiles;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2ResourcemanifestParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2ResourcemanifestParams.prototype.sortby;
        /** @type {?|undefined} */
        GetV2ResourcemanifestParams.prototype.samples;
        /** @type {?|undefined} */
        GetV2ResourcemanifestParams.prototype.runmetrics;
        /** @type {?|undefined} */
        GetV2ResourcemanifestParams.prototype.runlogs;
        /** @type {?|undefined} */
        GetV2ResourcemanifestParams.prototype.runimages;
        /** @type {?|undefined} */
        GetV2ResourcemanifestParams.prototype.projects;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2ResourcemanifestParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2ResourcemanifestParams.prototype.limit;
        /** @type {?|undefined} */
        GetV2ResourcemanifestParams.prototype.ipdrunparameters;
        /**
         * The Id of the resource
         * @type {?|undefined}
         */
        GetV2ResourcemanifestParams.prototype.id;
        /** @type {?|undefined} */
        GetV2ResourcemanifestParams.prototype.extensions;
        /** @type {?|undefined} */
        GetV2ResourcemanifestParams.prototype.datasets;
        /** @type {?|undefined} */
        GetV2ResourcemanifestParams.prototype.appsessions;
        /** @type {?|undefined} */
        GetV2ResourcemanifestParams.prototype.appresults;
    }
    /**
     * Parameters for GetV2Runs
     * @record
     */
    function GetV2RunsParams() { }
    BasespaceService.GetV2RunsParams = GetV2RunsParams;
    if (false) {
        /**
         * The run statuses to filter by. Valid values include: New, Ready, Running, Paused, Stopped, Uploading, PendingAnalysis, Analyzing, Complete, Failed, NeedsAttention. Multiple values may be provided separated by commas.
         * @type {?|undefined}
         */
        GetV2RunsParams.prototype.statuses;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2RunsParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2RunsParams.prototype.sortby;
        /**
         * Filter properties by name starting with. Max items returned is 1024.
         * @type {?|undefined}
         */
        GetV2RunsParams.prototype.propertynamestartswith;
        /**
         * The project ids to filter by.
         * @type {?|undefined}
         */
        GetV2RunsParams.prototype.outputProjects;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2RunsParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2RunsParams.prototype.limit;
        /**
         * The lane and QC statues to filter by.  Valid values include: Inital, QcPassed, and LaneQcFailed.  Multiple values may be separated by commas.
         * @type {?|undefined}
         */
        GetV2RunsParams.prototype.laneandqcstatuses;
        /**
         * The instrument type to filter by.
         * @type {?|undefined}
         */
        GetV2RunsParams.prototype.instrumenttype;
        /**
         * Sub elements to include in the response
         * @type {?|undefined}
         */
        GetV2RunsParams.prototype.include;
        /**
         * The Id of the resource
         * @type {?|undefined}
         */
        GetV2RunsParams.prototype.id;
        /**
         * The flowcell barcode to filter by. To request empty barcodes, provide an empty string
         * @type {?|undefined}
         */
        GetV2RunsParams.prototype.flowcellbarcode;
        /**
         * The experiment name to filter by.
         * @type {?|undefined}
         */
        GetV2RunsParams.prototype.experimentname;
        /**
         * Filter properties by name not starting with. Max items returned is 1024.
         * @type {?|undefined}
         */
        GetV2RunsParams.prototype.excludepropertynamestartswith;
    }
    /**
     * Parameters for PostV2Runs
     * @record
     */
    function PostV2RunsParams() { }
    BasespaceService.PostV2RunsParams = PostV2RunsParams;
    if (false) {
        /**
         * The InstrumentType identifies from which the run is generated. This is REQUIRED for runs uploaded manually. Runs uploaded from an instrument must specify the ClientKey. AllowedValues: 'HiSeq1000', 'HiSeq1500', 'HiSeq2000', 'HiSeq2500', 'HiSeq3000', 'HiSeq4000', 'HiSeqX', 'NovaSeq5000', 'NovaSeq6000', 'MiniSeq', 'MiSeq', 'MiSeqDx', 'NextSeq', 'NextSeqDx', 'iSeq100'
         * @type {?}
         */
        PostV2RunsParams.prototype.instrumenttype;
        /**
         * The name of the experiment.
         * @type {?}
         */
        PostV2RunsParams.prototype.experimentname;
        /**
         * The name of the sample sheet.
         * @type {?|undefined}
         */
        PostV2RunsParams.prototype.samplesheetname;
        /** @type {?|undefined} */
        PostV2RunsParams.prototype.payload;
    }
    /**
     * Parameters for GetV2RunsId
     * @record
     */
    function GetV2RunsIdParams() { }
    BasespaceService.GetV2RunsIdParams = GetV2RunsIdParams;
    if (false) {
        /**
         * The Id of the resource
         * @type {?}
         */
        GetV2RunsIdParams.prototype.id;
        /** @type {?|undefined} */
        GetV2RunsIdParams.prototype.propertyitemslimit;
        /** @type {?|undefined} */
        GetV2RunsIdParams.prototype.propertieslimit;
        /** @type {?|undefined} */
        GetV2RunsIdParams.prototype.include;
    }
    /**
     * Parameters for PostV2RunsId
     * @record
     */
    function PostV2RunsIdParams() { }
    BasespaceService.PostV2RunsIdParams = PostV2RunsIdParams;
    if (false) {
        /**
         * The Id of the resource
         * @type {?}
         */
        PostV2RunsIdParams.prototype.id;
        /**
         * Specifies the updated state of a run. AllowedValues: 'Uploading', 'Completed', 'Failed'.
         * @type {?|undefined}
         */
        PostV2RunsIdParams.prototype.uploadstatus;
        /**
         * Update the run data based on the contents of run parameters.
         * @type {?|undefined}
         */
        PostV2RunsIdParams.prototype.runparametersxml;
        /**
         * Specifies the PrepkitName.
         * @type {?|undefined}
         */
        PostV2RunsIdParams.prototype.prepkitname;
        /** @type {?|undefined} */
        PostV2RunsIdParams.prototype.payload;
        /**
         * Specifies the updated state of a run. AllowedValues: 'Running', 'Stopped', 'InstrumentCompleted', 'Failed', 'Rehybing'.
         * @type {?|undefined}
         */
        PostV2RunsIdParams.prototype.instrumentrunstatus;
        /**
         * Specifies the InstrumentRunNumber.
         * @type {?|undefined}
         */
        PostV2RunsIdParams.prototype.instrumentrunnumber;
        /**
         * Specifies the InstrumentRunId.
         * @type {?|undefined}
         */
        PostV2RunsIdParams.prototype.instrumentrunid;
        /**
         * Specifies the FlowcellBarcode.
         * @type {?|undefined}
         */
        PostV2RunsIdParams.prototype.flowcellbarcode;
    }
    /**
     * Parameters for GetV2RunsIdFiles
     * @record
     */
    function GetV2RunsIdFilesParams() { }
    BasespaceService.GetV2RunsIdFilesParams = GetV2RunsIdFilesParams;
    if (false) {
        /**
         * If a 'directory' is provided, files in subfolders of the given directory are also included
         * @type {?}
         */
        GetV2RunsIdFilesParams.prototype.recursive;
        /**
         * The Id of the resource
         * @type {?}
         */
        GetV2RunsIdFilesParams.prototype.id;
        /**
         * Resolves the HrefContent to the direct file URI to avoid a hop to GET: files/{id}/content
         * @type {?}
         */
        GetV2RunsIdFilesParams.prototype.filehrefcontentresolution;
        /**
         * Optionally filter by status (default complete)
         * @type {?|undefined}
         */
        GetV2RunsIdFilesParams.prototype.statuses;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2RunsIdFilesParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2RunsIdFilesParams.prototype.sortby;
        /**
         * To be pre-fixed in the path of the file
         * @type {?|undefined}
         */
        GetV2RunsIdFilesParams.prototype.pathprefix;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2RunsIdFilesParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2RunsIdFilesParams.prototype.limit;
        /**
         * Possible values: 'Subdirectories', 'TotalCount'
         * @type {?|undefined}
         */
        GetV2RunsIdFilesParams.prototype.include;
        /**
         * The file extensions to filter by (comma-separated)
         * @type {?|undefined}
         */
        GetV2RunsIdFilesParams.prototype.extensions;
        /**
         * The file extensions to exclude (comma-separated)
         * @type {?|undefined}
         */
        GetV2RunsIdFilesParams.prototype.excludeextensions;
        /**
         * The directory path to filter by (root is /)
         * @type {?|undefined}
         */
        GetV2RunsIdFilesParams.prototype.directory;
    }
    /**
     * Parameters for PostV2RunsIdFiles
     * @record
     */
    function PostV2RunsIdFilesParams() { }
    BasespaceService.PostV2RunsIdFilesParams = PostV2RunsIdFilesParams;
    if (false) {
        /**
         * The Id of the resource
         * @type {?}
         */
        PostV2RunsIdFilesParams.prototype.id;
        /**
         * The file to upload
         * @type {?}
         */
        PostV2RunsIdFilesParams.prototype.file;
    }
    /**
     * Parameters for GetV2RunsIdFileUploadInfo
     * @record
     */
    function GetV2RunsIdFileUploadInfoParams() { }
    BasespaceService.GetV2RunsIdFileUploadInfoParams = GetV2RunsIdFileUploadInfoParams;
    if (false) {
        /**
         * The Id of the resource
         * @type {?}
         */
        GetV2RunsIdFileUploadInfoParams.prototype.id;
        /** @type {?|undefined} */
        GetV2RunsIdFileUploadInfoParams.prototype.uploadpartcount;
        /** @type {?|undefined} */
        GetV2RunsIdFileUploadInfoParams.prototype.filepath;
    }
    /**
     * Parameters for PostV2RunsIdFileUploadInfo
     * @record
     */
    function PostV2RunsIdFileUploadInfoParams() { }
    BasespaceService.PostV2RunsIdFileUploadInfoParams = PostV2RunsIdFileUploadInfoParams;
    if (false) {
        /**
         * The Id of the resource
         * @type {?}
         */
        PostV2RunsIdFileUploadInfoParams.prototype.id;
        /** @type {?|undefined} */
        PostV2RunsIdFileUploadInfoParams.prototype.payload;
    }
    /**
     * Parameters for GetV2RunsIdProperties
     * @record
     */
    function GetV2RunsIdPropertiesParams() { }
    BasespaceService.GetV2RunsIdPropertiesParams = GetV2RunsIdPropertiesParams;
    if (false) {
        /** @type {?} */
        GetV2RunsIdPropertiesParams.prototype.id;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2RunsIdPropertiesParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2RunsIdPropertiesParams.prototype.sortby;
        /**
         * Show Hidden projects and Datasets
         * @type {?|undefined}
         */
        GetV2RunsIdPropertiesParams.prototype.showhiddenitems;
        /**
         * Limit the # of property items returned per property
         * @type {?|undefined}
         */
        GetV2RunsIdPropertiesParams.prototype.propertyitemslimit;
        /**
         * Filter by property name
         * @type {?|undefined}
         */
        GetV2RunsIdPropertiesParams.prototype.propertyfilters;
        /**
         * Limit the # of properties returned
         * @type {?|undefined}
         */
        GetV2RunsIdPropertiesParams.prototype.propertieslimit;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2RunsIdPropertiesParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2RunsIdPropertiesParams.prototype.limit;
    }
    /**
     * Parameters for GetV2RunsIdPropertiesName
     * @record
     */
    function GetV2RunsIdPropertiesNameParams() { }
    BasespaceService.GetV2RunsIdPropertiesNameParams = GetV2RunsIdPropertiesNameParams;
    if (false) {
        /**
         * Property name
         * @type {?}
         */
        GetV2RunsIdPropertiesNameParams.prototype.name;
        /** @type {?} */
        GetV2RunsIdPropertiesNameParams.prototype.id;
        /**
         * Hidden filter
         * @type {?|undefined}
         */
        GetV2RunsIdPropertiesNameParams.prototype.showhiddenitems;
        /**
         * Limit the # of property items returned per property
         * @type {?|undefined}
         */
        GetV2RunsIdPropertiesNameParams.prototype.propertyitemslimit;
    }
    /**
     * Parameters for GetV2RunsIdPropertiesNameItems
     * @record
     */
    function GetV2RunsIdPropertiesNameItemsParams() { }
    BasespaceService.GetV2RunsIdPropertiesNameItemsParams = GetV2RunsIdPropertiesNameItemsParams;
    if (false) {
        /**
         * Property name
         * @type {?}
         */
        GetV2RunsIdPropertiesNameItemsParams.prototype.name;
        /** @type {?} */
        GetV2RunsIdPropertiesNameItemsParams.prototype.id;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2RunsIdPropertiesNameItemsParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2RunsIdPropertiesNameItemsParams.prototype.sortby;
        /**
         * Hidden filter
         * @type {?|undefined}
         */
        GetV2RunsIdPropertiesNameItemsParams.prototype.showhiddenitems;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2RunsIdPropertiesNameItemsParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2RunsIdPropertiesNameItemsParams.prototype.limit;
    }
    /**
     * Parameters for GetV2SamplesIdFileUploadInfo
     * @record
     */
    function GetV2SamplesIdFileUploadInfoParams() { }
    BasespaceService.GetV2SamplesIdFileUploadInfoParams = GetV2SamplesIdFileUploadInfoParams;
    if (false) {
        /**
         * The Id of the resource
         * @type {?}
         */
        GetV2SamplesIdFileUploadInfoParams.prototype.id;
        /** @type {?|undefined} */
        GetV2SamplesIdFileUploadInfoParams.prototype.uploadpartcount;
        /** @type {?|undefined} */
        GetV2SamplesIdFileUploadInfoParams.prototype.filepath;
    }
    /**
     * Parameters for PostV2SamplesIdFileUploadInfo
     * @record
     */
    function PostV2SamplesIdFileUploadInfoParams() { }
    BasespaceService.PostV2SamplesIdFileUploadInfoParams = PostV2SamplesIdFileUploadInfoParams;
    if (false) {
        /**
         * The Id of the resource
         * @type {?}
         */
        PostV2SamplesIdFileUploadInfoParams.prototype.id;
        /** @type {?|undefined} */
        PostV2SamplesIdFileUploadInfoParams.prototype.payload;
    }
    /**
     * Parameters for GetV2SubjectsIdProperties
     * @record
     */
    function GetV2SubjectsIdPropertiesParams() { }
    BasespaceService.GetV2SubjectsIdPropertiesParams = GetV2SubjectsIdPropertiesParams;
    if (false) {
        /** @type {?} */
        GetV2SubjectsIdPropertiesParams.prototype.id;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2SubjectsIdPropertiesParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2SubjectsIdPropertiesParams.prototype.sortby;
        /**
         * Show Hidden projects and Datasets
         * @type {?|undefined}
         */
        GetV2SubjectsIdPropertiesParams.prototype.showhiddenitems;
        /**
         * Limit the # of property items returned per property
         * @type {?|undefined}
         */
        GetV2SubjectsIdPropertiesParams.prototype.propertyitemslimit;
        /**
         * Filter by property name
         * @type {?|undefined}
         */
        GetV2SubjectsIdPropertiesParams.prototype.propertyfilters;
        /**
         * Limit the # of properties returned
         * @type {?|undefined}
         */
        GetV2SubjectsIdPropertiesParams.prototype.propertieslimit;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2SubjectsIdPropertiesParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2SubjectsIdPropertiesParams.prototype.limit;
    }
    /**
     * Parameters for GetV2SubjectsIdPropertiesName
     * @record
     */
    function GetV2SubjectsIdPropertiesNameParams() { }
    BasespaceService.GetV2SubjectsIdPropertiesNameParams = GetV2SubjectsIdPropertiesNameParams;
    if (false) {
        /**
         * Property name
         * @type {?}
         */
        GetV2SubjectsIdPropertiesNameParams.prototype.name;
        /** @type {?} */
        GetV2SubjectsIdPropertiesNameParams.prototype.id;
        /**
         * Hidden filter
         * @type {?|undefined}
         */
        GetV2SubjectsIdPropertiesNameParams.prototype.showhiddenitems;
        /**
         * Limit the # of property items returned per property
         * @type {?|undefined}
         */
        GetV2SubjectsIdPropertiesNameParams.prototype.propertyitemslimit;
    }
    /**
     * Parameters for GetV2SubjectsIdPropertiesNameItems
     * @record
     */
    function GetV2SubjectsIdPropertiesNameItemsParams() { }
    BasespaceService.GetV2SubjectsIdPropertiesNameItemsParams = GetV2SubjectsIdPropertiesNameItemsParams;
    if (false) {
        /**
         * Property name
         * @type {?}
         */
        GetV2SubjectsIdPropertiesNameItemsParams.prototype.name;
        /** @type {?} */
        GetV2SubjectsIdPropertiesNameItemsParams.prototype.id;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2SubjectsIdPropertiesNameItemsParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2SubjectsIdPropertiesNameItemsParams.prototype.sortby;
        /**
         * Hidden filter
         * @type {?|undefined}
         */
        GetV2SubjectsIdPropertiesNameItemsParams.prototype.showhiddenitems;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2SubjectsIdPropertiesNameItemsParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2SubjectsIdPropertiesNameItemsParams.prototype.limit;
    }
    /**
     * Parameters for GetV2Trash
     * @record
     */
    function GetV2TrashParams() { }
    BasespaceService.GetV2TrashParams = GetV2TrashParams;
    if (false) {
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2TrashParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2TrashParams.prototype.sortby;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2TrashParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2TrashParams.prototype.limit;
    }
    /**
     * Parameters for PostV2TrashIdRestorefromtrash
     * @record
     */
    function PostV2TrashIdRestorefromtrashParams() { }
    BasespaceService.PostV2TrashIdRestorefromtrashParams = PostV2TrashIdRestorefromtrashParams;
    if (false) {
        /**
         * The Id of the resource
         * @type {?}
         */
        PostV2TrashIdRestorefromtrashParams.prototype.id;
        /** @type {?|undefined} */
        PostV2TrashIdRestorefromtrashParams.prototype.payload;
    }
    /**
     * Parameters for GetV2Useragreements
     * @record
     */
    function GetV2UseragreementsParams() { }
    BasespaceService.GetV2UseragreementsParams = GetV2UseragreementsParams;
    if (false) {
        /**
         * If specified, only return agreements with titles exactly matching the specified value.
         * @type {?|undefined}
         */
        GetV2UseragreementsParams.prototype.title;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2UseragreementsParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2UseragreementsParams.prototype.sortby;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2UseragreementsParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2UseragreementsParams.prototype.limit;
        /**
         * Expand or filter the agreements returned. Include=Expired will return expired agreements, giving a history of all agreements ever signed by the user. Include=Pending looks for agreements that the user hasn't signed yet.
         * @type {?|undefined}
         */
        GetV2UseragreementsParams.prototype.include;
        /**
         * The Id of the resource
         * @type {?|undefined}
         */
        GetV2UseragreementsParams.prototype.id;
        /**
         * If specified, only return agreements with category exactly matching the specified value.
         * @type {?|undefined}
         */
        GetV2UseragreementsParams.prototype.category;
        /**
         * If specified, only return agreements for this application. If not, only return agreements not associated with an application.
         * @type {?|undefined}
         */
        GetV2UseragreementsParams.prototype.applicationid;
    }
    /**
     * Parameters for GetV2UsersId
     * @record
     */
    function GetV2UsersIdParams() { }
    BasespaceService.GetV2UsersIdParams = GetV2UsersIdParams;
    if (false) {
        /**
         * The Id of the resource
         * @type {?}
         */
        GetV2UsersIdParams.prototype.id;
        /** @type {?|undefined} */
        GetV2UsersIdParams.prototype.options;
        /** @type {?|undefined} */
        GetV2UsersIdParams.prototype.include;
    }
    /**
     * Parameters for GetV2UsersIdAutodeletionevents
     * @record
     */
    function GetV2UsersIdAutodeletioneventsParams() { }
    BasespaceService.GetV2UsersIdAutodeletioneventsParams = GetV2UsersIdAutodeletioneventsParams;
    if (false) {
        /**
         * The Id of the resource
         * @type {?}
         */
        GetV2UsersIdAutodeletioneventsParams.prototype.id;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2UsersIdAutodeletioneventsParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2UsersIdAutodeletioneventsParams.prototype.sortby;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2UsersIdAutodeletioneventsParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2UsersIdAutodeletioneventsParams.prototype.limit;
    }
    /**
     * Parameters for GetV2UsersIdMessages
     * @record
     */
    function GetV2UsersIdMessagesParams() { }
    BasespaceService.GetV2UsersIdMessagesParams = GetV2UsersIdMessagesParams;
    if (false) {
        /**
         * The Id of the resource
         * @type {?}
         */
        GetV2UsersIdMessagesParams.prototype.id;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2UsersIdMessagesParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2UsersIdMessagesParams.prototype.sortby;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2UsersIdMessagesParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2UsersIdMessagesParams.prototype.limit;
    }
    /**
     * Parameters for GetV2UsersIdNotifications
     * @record
     */
    function GetV2UsersIdNotificationsParams() { }
    BasespaceService.GetV2UsersIdNotificationsParams = GetV2UsersIdNotificationsParams;
    if (false) {
        /**
         * The classification of user notifications to receive. Applicable values are 'All', 'Activity', 'Storage', 'DataDeletion', 'Subscription', 'CMS'
         * @type {?}
         */
        GetV2UsersIdNotificationsParams.prototype.streamtype;
        /**
         * The Id of the resource
         * @type {?}
         */
        GetV2UsersIdNotificationsParams.prototype.id;
        /**
         * AttentionRequired
         * @type {?}
         */
        GetV2UsersIdNotificationsParams.prototype.attentionrequired;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2UsersIdNotificationsParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2UsersIdNotificationsParams.prototype.sortby;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2UsersIdNotificationsParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2UsersIdNotificationsParams.prototype.limit;
        /**
         * The category within a 'Stream' of user notifications to receive. Currently only 'Activity' Stream supports Categories. Applicable values are 'All', 'Run', 'AppSession', 'Invite'
         * @type {?|undefined}
         */
        GetV2UsersIdNotificationsParams.prototype.category;
    }
    /**
     * Parameters for GetV2UsersIdSettings
     * @record
     */
    function GetV2UsersIdSettingsParams() { }
    BasespaceService.GetV2UsersIdSettingsParams = GetV2UsersIdSettingsParams;
    if (false) {
        /**
         * The Id of the resource
         * @type {?}
         */
        GetV2UsersIdSettingsParams.prototype.id;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2UsersIdSettingsParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2UsersIdSettingsParams.prototype.sortby;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2UsersIdSettingsParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2UsersIdSettingsParams.prototype.limit;
    }
    /**
     * Parameters for PostV2UsersIdSettings
     * @record
     */
    function PostV2UsersIdSettingsParams() { }
    BasespaceService.PostV2UsersIdSettingsParams = PostV2UsersIdSettingsParams;
    if (false) {
        /**
         * The Id of the resource
         * @type {?}
         */
        PostV2UsersIdSettingsParams.prototype.id;
        /** @type {?|undefined} */
        PostV2UsersIdSettingsParams.prototype.payload;
    }
    /**
     * Parameters for GetV2UsersIdSubscription
     * @record
     */
    function GetV2UsersIdSubscriptionParams() { }
    BasespaceService.GetV2UsersIdSubscriptionParams = GetV2UsersIdSubscriptionParams;
    if (false) {
        /** @type {?} */
        GetV2UsersIdSubscriptionParams.prototype.refreshcache;
        /**
         * The Id of the resource
         * @type {?}
         */
        GetV2UsersIdSubscriptionParams.prototype.id;
    }
    /**
     * Parameters for GetV2UsersIdWorkgroups
     * @record
     */
    function GetV2UsersIdWorkgroupsParams() { }
    BasespaceService.GetV2UsersIdWorkgroupsParams = GetV2UsersIdWorkgroupsParams;
    if (false) {
        /**
         * This will force a refresh on the workgroup subscriptions
         * @type {?}
         */
        GetV2UsersIdWorkgroupsParams.prototype.refreshcache;
        /**
         * This will include subscription in the response
         * @type {?}
         */
        GetV2UsersIdWorkgroupsParams.prototype.includesubscription;
        /**
         * Includes current user
         * @type {?}
         */
        GetV2UsersIdWorkgroupsParams.prototype.includeloggedinuser;
        /**
         * The Id of the resource
         * @type {?}
         */
        GetV2UsersIdWorkgroupsParams.prototype.id;
        /**
         * Excludes inactive workgroups
         * @type {?}
         */
        GetV2UsersIdWorkgroupsParams.prototype.activeonly;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2UsersIdWorkgroupsParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2UsersIdWorkgroupsParams.prototype.sortby;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2UsersIdWorkgroupsParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2UsersIdWorkgroupsParams.prototype.limit;
        /**
         * Sub elements to include in the response: LoggedInUser, IsDefaultRunUploadWorkgroup
         * @type {?|undefined}
         */
        GetV2UsersIdWorkgroupsParams.prototype.include;
    }
    /**
     * Parameters for PostV2UsersIdV2analysisconfigtemplate
     * @record
     */
    function PostV2UsersIdV2analysisconfigtemplateParams() { }
    BasespaceService.PostV2UsersIdV2analysisconfigtemplateParams = PostV2UsersIdV2analysisconfigtemplateParams;
    if (false) {
        /**
         * The Id of the resource
         * @type {?}
         */
        PostV2UsersIdV2analysisconfigtemplateParams.prototype.id;
        /** @type {?|undefined} */
        PostV2UsersIdV2analysisconfigtemplateParams.prototype.payload;
    }
    /**
     * Parameters for PostV2UsersIdV2biosampleregistry
     * @record
     */
    function PostV2UsersIdV2biosampleregistryParams() { }
    BasespaceService.PostV2UsersIdV2biosampleregistryParams = PostV2UsersIdV2biosampleregistryParams;
    if (false) {
        /**
         * The Id of the resource
         * @type {?}
         */
        PostV2UsersIdV2biosampleregistryParams.prototype.id;
        /** @type {?|undefined} */
        PostV2UsersIdV2biosampleregistryParams.prototype.payload;
    }
    /**
     * Parameters for GetV2UsersCurrent
     * @record
     */
    function GetV2UsersCurrentParams() { }
    BasespaceService.GetV2UsersCurrentParams = GetV2UsersCurrentParams;
    if (false) {
        /** @type {?|undefined} */
        GetV2UsersCurrentParams.prototype.options;
        /** @type {?|undefined} */
        GetV2UsersCurrentParams.prototype.include;
        /**
         * The Id of the resource
         * @type {?|undefined}
         */
        GetV2UsersCurrentParams.prototype.id;
    }
    /**
     * Parameters for GetV2UsersCurrentMessages
     * @record
     */
    function GetV2UsersCurrentMessagesParams() { }
    BasespaceService.GetV2UsersCurrentMessagesParams = GetV2UsersCurrentMessagesParams;
    if (false) {
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2UsersCurrentMessagesParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2UsersCurrentMessagesParams.prototype.sortby;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2UsersCurrentMessagesParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2UsersCurrentMessagesParams.prototype.limit;
        /**
         * The Id of the resource
         * @type {?|undefined}
         */
        GetV2UsersCurrentMessagesParams.prototype.id;
    }
    /**
     * Parameters for GetV2UsersCurrentNotifications
     * @record
     */
    function GetV2UsersCurrentNotificationsParams() { }
    BasespaceService.GetV2UsersCurrentNotificationsParams = GetV2UsersCurrentNotificationsParams;
    if (false) {
        /**
         * The classification of user notifications to receive. Applicable values are 'All', 'Activity', 'Storage', 'DataDeletion', 'Subscription', 'CMS'
         * @type {?}
         */
        GetV2UsersCurrentNotificationsParams.prototype.streamtype;
        /**
         * AttentionRequired
         * @type {?}
         */
        GetV2UsersCurrentNotificationsParams.prototype.attentionrequired;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2UsersCurrentNotificationsParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2UsersCurrentNotificationsParams.prototype.sortby;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2UsersCurrentNotificationsParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2UsersCurrentNotificationsParams.prototype.limit;
        /**
         * The Id of the resource
         * @type {?|undefined}
         */
        GetV2UsersCurrentNotificationsParams.prototype.id;
        /**
         * The category within a 'Stream' of user notifications to receive. Currently only 'Activity' Stream supports Categories. Applicable values are 'All', 'Run', 'AppSession', 'Invite'
         * @type {?|undefined}
         */
        GetV2UsersCurrentNotificationsParams.prototype.category;
    }
    /**
     * Parameters for GetV2UsersCurrentProperties
     * @record
     */
    function GetV2UsersCurrentPropertiesParams() { }
    BasespaceService.GetV2UsersCurrentPropertiesParams = GetV2UsersCurrentPropertiesParams;
    if (false) {
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2UsersCurrentPropertiesParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2UsersCurrentPropertiesParams.prototype.sortby;
        /**
         * Show Hidden projects and Datasets
         * @type {?|undefined}
         */
        GetV2UsersCurrentPropertiesParams.prototype.showhiddenitems;
        /**
         * Limit the # of property items returned per property
         * @type {?|undefined}
         */
        GetV2UsersCurrentPropertiesParams.prototype.propertyitemslimit;
        /**
         * Filter by property name
         * @type {?|undefined}
         */
        GetV2UsersCurrentPropertiesParams.prototype.propertyfilters;
        /**
         * Limit the # of properties returned
         * @type {?|undefined}
         */
        GetV2UsersCurrentPropertiesParams.prototype.propertieslimit;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2UsersCurrentPropertiesParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2UsersCurrentPropertiesParams.prototype.limit;
        /** @type {?|undefined} */
        GetV2UsersCurrentPropertiesParams.prototype.id;
    }
    /**
     * Parameters for GetV2UsersCurrentPropertiesName
     * @record
     */
    function GetV2UsersCurrentPropertiesNameParams() { }
    BasespaceService.GetV2UsersCurrentPropertiesNameParams = GetV2UsersCurrentPropertiesNameParams;
    if (false) {
        /**
         * Property name
         * @type {?}
         */
        GetV2UsersCurrentPropertiesNameParams.prototype.name;
        /**
         * Hidden filter
         * @type {?|undefined}
         */
        GetV2UsersCurrentPropertiesNameParams.prototype.showhiddenitems;
        /**
         * Limit the # of property items returned per property
         * @type {?|undefined}
         */
        GetV2UsersCurrentPropertiesNameParams.prototype.propertyitemslimit;
        /** @type {?|undefined} */
        GetV2UsersCurrentPropertiesNameParams.prototype.id;
    }
    /**
     * Parameters for GetV2UsersCurrentPropertiesNameItems
     * @record
     */
    function GetV2UsersCurrentPropertiesNameItemsParams() { }
    BasespaceService.GetV2UsersCurrentPropertiesNameItemsParams = GetV2UsersCurrentPropertiesNameItemsParams;
    if (false) {
        /**
         * Property name
         * @type {?}
         */
        GetV2UsersCurrentPropertiesNameItemsParams.prototype.name;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2UsersCurrentPropertiesNameItemsParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2UsersCurrentPropertiesNameItemsParams.prototype.sortby;
        /**
         * Hidden filter
         * @type {?|undefined}
         */
        GetV2UsersCurrentPropertiesNameItemsParams.prototype.showhiddenitems;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2UsersCurrentPropertiesNameItemsParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2UsersCurrentPropertiesNameItemsParams.prototype.limit;
        /** @type {?|undefined} */
        GetV2UsersCurrentPropertiesNameItemsParams.prototype.id;
    }
    /**
     * Parameters for GetV2UsersCurrentSubscription
     * @record
     */
    function GetV2UsersCurrentSubscriptionParams() { }
    BasespaceService.GetV2UsersCurrentSubscriptionParams = GetV2UsersCurrentSubscriptionParams;
    if (false) {
        /** @type {?} */
        GetV2UsersCurrentSubscriptionParams.prototype.refreshcache;
        /**
         * The Id of the resource
         * @type {?|undefined}
         */
        GetV2UsersCurrentSubscriptionParams.prototype.id;
    }
    /**
     * Parameters for GetV2UsersCurrentUsage
     * @record
     */
    function GetV2UsersCurrentUsageParams() { }
    BasespaceService.GetV2UsersCurrentUsageParams = GetV2UsersCurrentUsageParams;
    if (false) {
        /** @type {?} */
        GetV2UsersCurrentUsageParams.prototype.refreshcache;
        /** @type {?} */
        GetV2UsersCurrentUsageParams.prototype.periods;
        /** @type {?} */
        GetV2UsersCurrentUsageParams.prototype.includeloggedinuser;
        /**
         * The sort direction for the result set
         * @type {?|undefined}
         */
        GetV2UsersCurrentUsageParams.prototype.sortdir;
        /**
         * The field(s) used to sort the result set
         * @type {?|undefined}
         */
        GetV2UsersCurrentUsageParams.prototype.sortby;
        /**
         * The starting offset to read
         * @type {?|undefined}
         */
        GetV2UsersCurrentUsageParams.prototype.offset;
        /**
         * The maximum number of items to return
         * @type {?|undefined}
         */
        GetV2UsersCurrentUsageParams.prototype.limit;
        /**
         * The Id of the resource
         * @type {?|undefined}
         */
        GetV2UsersCurrentUsageParams.prototype.id;
    }
    /**
     * Parameters for GetV2V2migrationStatusStepname
     * @record
     */
    function GetV2V2migrationStatusStepnameParams() { }
    BasespaceService.GetV2V2migrationStatusStepnameParams = GetV2V2migrationStatusStepnameParams;
    if (false) {
        /**
         * Migration Step Name
         * @type {?}
         */
        GetV2V2migrationStatusStepnameParams.prototype.stepname;
        /**
         * The Id of the resource
         * @type {?|undefined}
         */
        GetV2V2migrationStatusStepnameParams.prototype.id;
    }
})(BasespaceService || (BasespaceService = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/api.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Provider for all Api services, plus ApiConfiguration
 */
class ApiModule {
    /**
     * @param {?} customParams
     * @return {?}
     */
    static forRoot(customParams) {
        return {
            ngModule: ApiModule,
            providers: [
                {
                    provide: ApiConfiguration,
                    useValue: { rootUrl: customParams.rootUrl }
                }
            ]
        };
    }
}
ApiModule.ngModuleDef = ɵngcc0.ɵɵdefineNgModule({ type: ApiModule });
/*@__PURE__*/ ɵngcc0.ɵɵsetNgModuleScope(ApiModule, { imports: function () { return [HttpClientModule]; }, exports: function () { return [HttpClientModule]; } });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(ApiModule, [{
        type: NgModule,
        args: [{
                imports: [
                    HttpClientModule
                ],
                exports: [
                    HttpClientModule
                ],
                declarations: [],
                providers: [
                    ApiConfiguration,
                    BasespaceService
                ]
            }]
    }], null, null);
ApiModule.ngInjectorDef = ɵngcc0.ɵɵdefineInjector({ factory: function ApiModule_Factory(t) { return new (t || ApiModule)(); }, providers: [
        ApiConfiguration,
        BasespaceService
    ], imports: [[
            HttpClientModule
        ],
        HttpClientModule] });

/**
 * @fileoverview added by tsickle
 * Generated from: api/http-request-interceptor.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Inject With Credentials into the request
 */
class HttpRequestInterceptor {
    /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    intercept(req, next) {
        req = req.clone({
            withCredentials: true
        });
        return next.handle(req).pipe(tap((/**
         * @param {?} x
         * @return {?}
         */
        x => x), (/**
         * @param {?} err
         * @return {?}
         */
        err => {
            // Handle this err
            console.error(`Error performing request, status code = ${err.status}`);
        })));
    }
}
HttpRequestInterceptor.ngInjectableDef = ɵngcc0.ɵɵdefineInjectable({ token: HttpRequestInterceptor, factory: function HttpRequestInterceptor_Factory(t) { return new (t || HttpRequestInterceptor)(); }, providedIn: null });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(HttpRequestInterceptor, [{
        type: Injectable
    }], null, { intercept: [] });
/** @type {?} */
const HttpRequestInterceptorProvider = {
    provide: HTTP_INTERCEPTORS,
    multi: true,
    useClass: HttpRequestInterceptor
};

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: bssh-ng-sdk.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { ApiModule, BaseService, BasespaceService, HttpRequestInterceptor, HttpRequestInterceptorProvider, ApiConfiguration as ɵa };

//# sourceMappingURL=bssh-ng-sdk.js.map